
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("5Uzk2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useIsModernGlobalIssueCreatePreferred", () => $962607f0f747762a$export$92258d85324089e5);
$parcel$export(module.exports, "Global", () => $962607f0f747762a$export$98f03c5d19621d70);
$parcel$export(module.exports, "default", () => $962607f0f747762a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lopBx = parcelRequire("lopBx");

var $6qDrV = parcelRequire("6qDrV");

var $g4bFh = parcelRequire("g4bFh");

var $7jTnu = parcelRequire("7jTnu");

var $ct3q5 = parcelRequire("ct3q5");

var $9nLOz = parcelRequire("9nLOz");

var $1aFj8 = parcelRequire("1aFj8");

var $3j8Fu = parcelRequire("3j8Fu");

var $6pm44 = parcelRequire("6pm44");

var $aS7Qh = parcelRequire("aS7Qh");

var $9cK0j = parcelRequire("9cK0j");

var $i9s9t = parcelRequire("i9s9t");

var $fw9To = parcelRequire("fw9To");

var $juJEk = parcelRequire("juJEk");

var $dRfS0 = parcelRequire("dRfS0");

var $h4s0U = parcelRequire("h4s0U");

var $fYLvG = parcelRequire("fYLvG");

var $bchQI = parcelRequire("bchQI");

var $8vyDv = parcelRequire("8vyDv");

var $gZTP9 = parcelRequire("gZTP9");

var $2cfd4 = parcelRequire("2cfd4");

var $eJrcF = parcelRequire("eJrcF");

var $5R873 = parcelRequire("5R873");



const $962607f0f747762a$var$IssueCreateTrigger = (parcelRequire("89Fdx")).default;
const $962607f0f747762a$export$92258d85324089e5 = ()=>(0, $eJrcF.useResource)((0, $dRfS0.gicOptInStatusResources)).data?.gicOptInStatus?.isEnabled ?? false;
const $962607f0f747762a$var$LegacyComponents = ()=>{
    const locale = (0, $2cfd4.useLocale)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cK0j.default), {
        locale: locale
    }));
};
const $962607f0f747762a$var$ProjectCreateDrawerComponent = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const locale = (0, $2cfd4.useLocale)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $juJEk.default), {
        isAdmin: isAdmin,
        isOnboarding: false,
        locale: locale,
        appEditions: appEditions
    });
};
const $962607f0f747762a$var$ModernGlobalIssueCreate = (0, $6qDrV.default)(()=>(0, $7jTnu.fg)('render_modern_global_issue_create_modal_experience') && $962607f0f747762a$export$92258d85324089e5(), ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bchQI.AsyncEnforceStorageLimitsModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6pm44.AsyncIssueCreateModal), null), (0, $7jTnu.fg)('render_modern_global_issue_create_modal_experience') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($962607f0f747762a$var$IssueCreateTrigger, null) : null), ()=>null);
const $962607f0f747762a$var$ModernIssueTransition = (0, $6qDrV.default)(()=>(0, $7jTnu.fg)('render-modern-issue-transition') || (0, $lopBx.isFedRamp)(), (0, $aS7Qh.AsyncIssueTransitionModal), ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));


const $962607f0f747762a$var$JiraCommandPalette = (parcelRequire("6BARP")).default;
const $962607f0f747762a$export$98f03c5d19621d70 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g4bFh.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9nLOz.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ct3q5.AsyncFeedbackCollectorRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($962607f0f747762a$var$LegacyComponents, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9s9t.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fw9To.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1aFj8.InvitePeopleModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($962607f0f747762a$var$ProjectCreateDrawerComponent, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3j8Fu.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($962607f0f747762a$var$ModernGlobalIssueCreate, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($962607f0f747762a$var$ModernIssueTransition, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h4s0U.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $b101af3c1212271f$export$bfef7353718d9887)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($962607f0f747762a$var$JiraCommandPalette, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fYLvG.FlagIssueWithCommentModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5R873.default), null));
var $962607f0f747762a$export$2e2bcd8739ae039 = $962607f0f747762a$export$98f03c5d19621d70;

});
parcelRegister("6qDrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d62983c7b7a7f090$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
var /**
 * @deprecated this does not support useRef and is being moved into a new package.
 * Use @atlassian/jira-feature-flagging-utils and componentWithCondition instead.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$d62983c7b7a7f090$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
    const ComponentWithCondition = (props)=>// @ts-expect-error - TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'. | TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'.
        conditionGetter() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ComponentTrue, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ComponentFalse, props);
    if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
    // @ts-expect-error - TS2322 - Type '{ (props: P): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<P, any>'.
    return ComponentWithCondition;
};

});

parcelRegister("g4bFh", function(module, exports) {

$parcel$export(module.exports, "default", () => $abaf09c103de1dfb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ck6ne = parcelRequire("ck6ne");

var $dFtHW = parcelRequire("dFtHW");

var $5xg7E = parcelRequire("5xg7E");
function $abaf09c103de1dfb$export$2e2bcd8739ae039(_props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFtHW.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ck6ne.FavoriteAPISubscriber), null, (__, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5xg7E.default), {
                items: favoriteChangeContext.items,
                changeFavorite: favoriteChangeContext.changeFavorite,
                // @ts-expect-error - TS2322 - Type 'BoundActions<State, Actions>' is not assignable to type 'Actions'.
                callbackRegistry: actions
            })));
}

});
parcelRegister("ck6ne", function(module, exports) {

$parcel$export(module.exports, "FavoriteAPISubscriber", () => $934f9880fdb29fa0$export$5f27f6398e1e9783);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $ht3nQ = parcelRequire("ht3nQ");

var $38LZa = parcelRequire("38LZa");
const $934f9880fdb29fa0$export$5f27f6398e1e9783 = (0, $ht3nQ.createSubscriber)((0, $38LZa.default), {
    displayName: 'FavoriteAPISubscriber',
    selector: null
});
const $934f9880fdb29fa0$export$e5f479962d73e3ca = (0, $6E16M.createContainer)((0, $38LZa.default));

});
parcelRegister("38LZa", function(module, exports) {

$parcel$export(module.exports, "default", () => $289dc70a1523c522$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $GtRbT = parcelRequire("GtRbT");

var $3UeZt = parcelRequire("3UeZt");
const $289dc70a1523c522$var$initialState = {
    callbacks: new Set()
};
var $289dc70a1523c522$export$2e2bcd8739ae039 = (0, $GtRbT.createStore)({
    name: 'favourite-api-callbacks',
    initialState: $289dc70a1523c522$var$initialState,
    actions: $3UeZt.default
});

});
parcelRegister("3UeZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b96e3e7d525ae65$export$2e2bcd8739ae039);

var $hp56f = parcelRequire("hp56f");
var $g0YFq = parcelRequire("g0YFq");
var $lyMVt = parcelRequire("lyMVt");
var $bo6Al = parcelRequire("bo6Al");
const $6b96e3e7d525ae65$var$actions = {
    add: (cb)=>({ dispatch: dispatch })=>dispatch($hp56f.default('callbacks', cb)),
    remove: (cb)=>({ dispatch: dispatch })=>dispatch($lyMVt.default('callbacks', cb)),
    clear: ()=>({ dispatch: dispatch })=>dispatch($g0YFq.default('callbacks')),
    run: (...args)=>({ dispatch: dispatch })=>dispatch($bo6Al.default('callbacks', ...args))
};
var $6b96e3e7d525ae65$export$2e2bcd8739ae039 = $6b96e3e7d525ae65$var$actions;

});



parcelRegister("5xg7E", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9654a90753bc931$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $iyT45 = parcelRequire("iyT45");
class $b9654a90753bc931$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            items: {
                boards: {},
                filters: {},
                dashboards: {},
                issues: {},
                projects: {},
                queues: {}
            },
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onAddClearImperativeApiCallback: ()=>{}
        };
    }
    constructor(){
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $iyT45.loadBridgeWeak)({
            name: 'jira/favouriteItems/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(this.getImperativeAPI());
        });
    }
    shouldComponentUpdate(nextProps) {
        return this.props.items !== nextProps.items;
    }
    componentDidUpdate() {
        if (!this.props.items) return;
        this.props.callbackRegistry.run(this.props.items);
    }
    componentWillUnmount() {
        this.props.callbackRegistry.clear();
    }
    getImperativeAPI() {
        return {
            // Update a favorite in Jira-Frontend (from Monolith)
            changeFavourite: async (item)=>this.props.changeFavorite(item),
            // Register a callback that gets executed in Monolith when a value in Jira-Frontend gets changed
            registerFavouriteChangeCallback: (callback)=>this.props.callbackRegistry.add(callback),
            unregisterFavouriteChangeCallback: (callback)=>this.props.callbackRegistry.remove(callback)
        };
    }
    render() {
        return null;
    }
}

});


parcelRegister("ct3q5", function(module, exports) {

$parcel$export(module.exports, "AsyncFeedbackCollectorRenderer", () => $3116e924f1e692d2$export$af648acab555078b);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// Note `renderer` here means a small wrapper/boilerplate which is used
// to render AK Feedback Collector dialog later.
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3116e924f1e692d2$var$LazyFeedbackCollectorRenderer = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("b6OiG")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/feedback-collector/src/ui/feedback-renderer/index.tsx"
});
const $3116e924f1e692d2$export$af648acab555078b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "asyncFeedbackCollector",
        packageName: "jiraFeedbackCollector",
        teamName: "magma"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-feedback-collector-renderer",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3116e924f1e692d2$var$LazyFeedbackCollectorRenderer, null)));

});
parcelRegister("b6OiG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4nRNr").then(()=>parcelRequire('dWzcN'));

});


parcelRegister("9nLOz", function(module, exports) {

$parcel$export(module.exports, "default", () => $feb12b79047e08aa$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gjeS9 = parcelRequire("gjeS9");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $2cfd4 = parcelRequire("2cfd4");

var $a8PVz = parcelRequire("a8PVz");

var $gj1Zb = parcelRequire("gj1Zb");

var $7YJei = parcelRequire("7YJei");
function $feb12b79047e08aa$export$2d8c840b82ad138f() {
    /* eslint-disable jira/wrm/no-load-bridge */ return (0, $7jTnu.fg)('load-wrm-resource-for-gic') ? (0, $iyT45.loadBridgeWeak) : (0, $gjeS9.loadBridge);
}
const $feb12b79047e08aa$var$LoadGICResources = ()=>{
    const locale = (0, $2cfd4.useLocale)();
    const isModernPreferred = (0, $7YJei.useIsModernGlobalIssueCreatePreferred)() && (0, $7jTnu.fg)('render_modern_global_issue_create_modal_experience');
    (0, $eJOHy.useEffect)(()=>{
        if (__SPA__) (isModernPreferred ? (0, $4T9yL.waitForHeritage)() : $feb12b79047e08aa$export$2d8c840b82ad138f()({
            name: 'wrm/require'
        }))?.then(()=>(0, $a8PVz.asyncWrmRequire)([
                'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue',
                'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
                'wrc!jira.create.issue',
                (0, $gj1Zb.default)(locale),
                'wrc!com.atlassian.jira.plugins.jira-dnd-attachment-plugin:shared-utility',
                'wrc!com.pyxis.greenhopper.jira:gh-issue-type-whitelist',
                'wrc!com.atlassian.jira.plugins.jira-wiki-editor:wiki-editor-resources-init',
                'wrc!com.pyxis.greenhopper.jira:gh-view-issue',
                'wrc!com.pyxis.greenhopper.jira:gh-custom-field-pickers',
                'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
            ])).catch((error)=>{
            (0, $gYnSx.default)({
                meta: {
                    id: 'LoadGICResources',
                    packageName: 'jiraGlobalIssueCreateResources',
                    teamName: 'gryffindor'
                },
                error: error
            });
        });
    }, [
        isModernPreferred,
        locale
    ]);
    return null;
};
var $feb12b79047e08aa$export$2e2bcd8739ae039 = $feb12b79047e08aa$var$LoadGICResources;

});
parcelRegister("gj1Zb", function(module, exports) {

$parcel$export(module.exports, "default", () => $de48dadf4589d810$export$2e2bcd8739ae039);
/*
 * There are components in Issue and Service Desk that invoke legacy UI components. Some of these
 * components require Jira Calendar resources, but only two of the three required resources are
 * loaded implicitly. The third resource must be loaded dynamically because it depends on the
 * current user's locale.
 *
 * Here we generate the resource name for that calendar locale dependency, for loading through WRM.
 *
 * For more context in Jira, see:
 * - com.atlassian.jira.web.action.util.CalendarResourceIncluder
 * - jira-components/jira-webapp-resources/src/main/webapp/includes/lib/calendar
 * - system-webresources-plugin.xml
 */ const $de48dadf4589d810$var$calendarLocaleMap = {
    cs_CZ: 'calendar-cs',
    da_DK: 'calendar-da',
    de_DE: 'calendar-de',
    en_GB: 'calendar-en',
    en_UK: 'calendar-en',
    en_ZZ: 'calendar-en',
    en_US: 'calendar-en',
    es_ES: 'calendar-es',
    et_EE: 'calendar-en',
    fi_FI: 'calendar-fi',
    fr_FR: 'calendar-fr',
    hu_HU: 'calendar-hu',
    is_IS: 'calendar-en',
    it_IT: 'calendar-it',
    ja_JP: 'calendar-jp',
    ko_KR: 'calendar-ko',
    nb_NO: 'calendar-no',
    nl_NL: 'calendar-nl',
    pl_PL: 'calendar-pl',
    pt_BR: 'calendar-pt',
    pt_PT: 'calendar-pt',
    ro_RO: 'calendar-ro',
    ru_RU: 'calendar-ru',
    sk_SK: 'calendar-sk',
    sv_SE: 'calendar-sv',
    tr_TR: 'calendar-tr',
    zh_CN: 'calendar-zh',
    zh_TW: 'calendar-zh'
};
const $de48dadf4589d810$var$getCalendarResource = (locale)=>$de48dadf4589d810$var$calendarLocaleMap[locale] || $de48dadf4589d810$var$calendarLocaleMap.en_US;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$de48dadf4589d810$export$2e2bcd8739ae039 = (locale)=>`wrc!jira.webresources:${$de48dadf4589d810$var$getCalendarResource(locale)}`;

});

parcelRegister("7YJei", function(module, exports) {

$parcel$export(module.exports, "useIsModernGlobalIssueCreatePreferred", () => $038f60718f83cdd7$export$92258d85324089e5);

var $dRfS0 = parcelRequire("dRfS0");

var $eJrcF = parcelRequire("eJrcF");
const $038f60718f83cdd7$export$92258d85324089e5 = ()=>(0, $eJrcF.useResource)((0, $dRfS0.gicOptInStatusResources)).data?.gicOptInStatus?.isEnabled ?? false;

});


parcelRegister("1aFj8", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModal", () => $3c8f9f7badf7d92a$export$e3ec81c4d0451f63);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");
var $fathc = parcelRequire("fathc");

var $lMRlJ = parcelRequire("lMRlJ");

const $3c8f9f7badf7d92a$export$a8041cefa08382b = (0, $bQWwW.lazy)(()=>(parcelRequire("5sVcX")), {
    moduleId: "./src/packages/invite-people/src/ui/content/index.tsx"
});
const $3c8f9f7badf7d92a$var$InvitePeopleModalInternal = ({ disableNoInviteError: disableNoInviteError })=>{
    const [{ isOpen: isOpen, inviteFlow: inviteFlow, continueUrl: continueUrl, source: source, subProduct: subProduct }, { closeModal: closeModal }] = (0, $lMRlJ.useInvitePeopleModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fathc.LazyWait), {
        until: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3c8f9f7badf7d92a$export$a8041cefa08382b, {
        inviteFlow: inviteFlow,
        isOpen: isOpen,
        onClose: closeModal,
        continueUrl: continueUrl,
        disableNoInviteError: disableNoInviteError,
        source: source,
        subProduct: subProduct
    })));
};
$3c8f9f7badf7d92a$var$InvitePeopleModalInternal.displayName = 'InvitePeopleModalInternal';
const $3c8f9f7badf7d92a$export$e3ec81c4d0451f63 = ({ disableNoInviteError: disableNoInviteError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "invite-people-modal",
        packageName: "jiraInvitePeopleModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3c8f9f7badf7d92a$var$InvitePeopleModalInternal, {
        disableNoInviteError: disableNoInviteError
    }));

});
parcelRegister("lMRlJ", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $4e329b8cb1486bd7$export$b9ec44715ae5ad99);
$parcel$export(module.exports, "triggerOpenModal", () => $4e329b8cb1486bd7$export$3da9a54757b29739);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
var $14kUX = parcelRequire("14kUX");

var $ec6Db = parcelRequire("ec6Db");
const $4e329b8cb1486bd7$var$CONTROLLER_NAME = 'invite-people-modal';
const $4e329b8cb1486bd7$var$initialState = {
    isOpen: false,
    inviteFlow: 'unknown',
    continueUrl: undefined,
    source: undefined,
    subProduct: undefined
};
const $4e329b8cb1486bd7$var$Store = (0, $GtRbT.createStore)({
    name: $4e329b8cb1486bd7$var$CONTROLLER_NAME,
    initialState: $4e329b8cb1486bd7$var$initialState,
    actions: {
        openModal: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl, source: source, subProduct: subProduct })=>({ setState: setState })=>{
                (0, $ec6Db.fireAddTeammatetoJiraAnalytics)(createAnalyticsEvent, analyticsSource);
                (0, $ec6Db.fireModalTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, analyticsSource, source);
                setState({
                    isOpen: true,
                    inviteFlow: inviteFlow,
                    continueUrl: continueUrl,
                    source: source,
                    subProduct: subProduct
                });
            },
        closeModal: ()=>({ setState: setState })=>setState($4e329b8cb1486bd7$var$initialState)
    }
});
const $4e329b8cb1486bd7$export$b9ec44715ae5ad99 = (0, $iJq0l.createHook)($4e329b8cb1486bd7$var$Store);
const $4e329b8cb1486bd7$export$42437f35b39968af = (0, $6E16M.createContainer)($4e329b8cb1486bd7$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
            setState({
                isOpen: isOpen
            });
        }
});
const $4e329b8cb1486bd7$export$c109a2947e32aee9 = (0, $ht3nQ.createSubscriber)($4e329b8cb1486bd7$var$Store, {
    displayName: 'InvitePeopleModalSubscriber',
    selector: (state)=>state.isOpen
});
const $4e329b8cb1486bd7$export$3da9a54757b29739 = (createAnalyticsEvent, contextConfig)=>{
    (0, $14kUX.defaultRegistry).getStore($4e329b8cb1486bd7$var$Store)?.actions.openModal(createAnalyticsEvent, contextConfig);
};

});
parcelRegister("ec6Db", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $f0e7c62e1985a15a$export$1b581a2ec13e37f1);
$parcel$export(module.exports, "fireModalTriggeredAnalytics", () => $f0e7c62e1985a15a$export$6815765da918b983);
$parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", () => $f0e7c62e1985a15a$export$21b810258e82d438);

var $eJOHy = parcelRequire("eJOHy");

var $8QoO2 = parcelRequire("8QoO2");

var $gCeeo = parcelRequire("gCeeo");
var $1WOGD = parcelRequire("1WOGD");

var $2Mqjh = parcelRequire("2Mqjh");

var $bDk9X = parcelRequire("bDk9X");
const $f0e7c62e1985a15a$var$useAnalyticsClient = ()=>{
    const analyticsWebClientRef = (0, $eJOHy.useRef)((0, $2Mqjh.getAnalyticsWebClientPromise)());
    return {
        sendEvent: (analyticsEvent)=>{
            analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, $1WOGD.getEvent)(analyticsEvent)));
        }
    };
};
const $f0e7c62e1985a15a$export$1b581a2ec13e37f1 = ({ children: children })=>{
    const { sendEvent: sendEvent } = $f0e7c62e1985a15a$var$useAnalyticsClient();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8QoO2.default), {
        channel: "peopleAndTeams",
        onEvent: sendEvent
    }, children);
};
const $f0e7c62e1985a15a$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
    if (createAnalyticsEvent) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), // @ts-expect-error Argument of type '[string, string, Attributes | undefined]' is not assignable to parameter of type 'RestArguments'.
    `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId || '', analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $2Mqjh.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
    }
};
const $f0e7c62e1985a15a$export$6815765da918b983 = async (createAnalyticsEvent, inviteFlow, analyticsSource, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'modal',
        actionSubjectId: 'invitePeopleModal',
        attributes: {
            source: inviteFlow ? (0, $bDk9X.getSourceByInviteFlow)(inviteFlow) : source
        },
        source: analyticsSource != null && analyticsSource !== '' ? analyticsSource : 'unknown'
    };
    $f0e7c62e1985a15a$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $f0e7c62e1985a15a$export$21b810258e82d438 = async (createAnalyticsEvent, source)=>{
    const analyticsPayload = {
        action: 'clicked',
        actionSubject: 'addTeammatetoJira',
        product: 'jira',
        source: source != null && source !== '' ? source : 'unknown'
    };
    $f0e7c62e1985a15a$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};

});
parcelRegister("bDk9X", function(module, exports) {

$parcel$export(module.exports, "getSourceByInviteFlow", () => $7650e673c142be40$export$c35cd18e9d0123e3);
const $7650e673c142be40$export$c35cd18e9d0123e3 = (inviteFlow)=>{
    let source = inviteFlow;
    if (inviteFlow === 'mention') source = 'mentionInEditor';
    else if (inviteFlow === 'assignee') source = 'assigneeField';
    return source;
};

});



parcelRegister("5sVcX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ilD4k")
]).then(()=>parcelRequire('8SFVn'));

});


parcelRegister("3j8Fu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5ae69612ccce676$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $henBf = parcelRequire("henBf");

var $lks4g = parcelRequire("lks4g");
const $d5ae69612ccce676$var$runtimeProps = {};
const $d5ae69612ccce676$var$entryPointParams = {};
const $d5ae69612ccce676$var$AsyncArchiveIssueModal = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $lks4g.archiveModalEntryPoint), $d5ae69612ccce676$var$entryPointParams);
    const { isArchiveIssueModalOpen: isArchiveIssueModalOpen } = (0, $henBf.useArchiveIssueModalStates)();
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isArchiveIssueModalOpen) {
            entryPointActions.load();
            return ()=>{
                entryPointActions.unload();
            };
        }
    }, [
        entryPointActions,
        isArchiveIssueModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira-issue-archival-modal",
        packageName: "jiraIssueArchiveModal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $d5ae69612ccce676$var$runtimeProps
    });
};
var $d5ae69612ccce676$export$2e2bcd8739ae039 = $d5ae69612ccce676$var$AsyncArchiveIssueModal;

});
parcelRegister("henBf", function(module, exports) {

$parcel$export(module.exports, "useArchiveIssueModalStates", () => $745ec8688da39b74$export$6b0867d94ec2f290);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $1jlQo = parcelRequire("1jlQo");
const $745ec8688da39b74$export$6b0867d94ec2f290 = (0, $iJq0l.createStateHook)((0, $1jlQo.ArchiveIssueModalStore));

});
parcelRegister("1jlQo", function(module, exports) {

$parcel$export(module.exports, "ArchiveIssueModalStore", () => $1f0dc38b9d91d9f3$export$c5cad849002b274b);
$parcel$export(module.exports, "useArchiveIssueModalActions", () => $1f0dc38b9d91d9f3$export$b7e685898567f722);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $1gxLs = parcelRequire("1gxLs");

var $k3WVB = parcelRequire("k3WVB");
const $1f0dc38b9d91d9f3$export$c5cad849002b274b = (0, $GtRbT.createStore)({
    initialState: $k3WVB.initialState,
    actions: (0, $1gxLs.ArchiveIssueModalActions),
    name: 'archiveIssueModalStore'
});
const $1f0dc38b9d91d9f3$export$b7e685898567f722 = (0, $iJq0l.createActionsHook)($1f0dc38b9d91d9f3$export$c5cad849002b274b);

});
parcelRegister("1gxLs", function(module, exports) {

$parcel$export(module.exports, "ArchiveIssueModalActions", () => $9ee98558093ad151$export$69579d834733fb34);
const $9ee98558093ad151$export$69579d834733fb34 = {
    openArchiveIssueModal: ({ issueKey: issueKey, issueId: issueId, onIssueArchiveSuccess: onIssueArchiveSuccess, onChildIssuesArchiveSuccess: onChildIssuesArchiveSuccess, onCloseIssueViewModal: onCloseIssueViewModal, triggerPointKey: triggerPointKey, workType: workType, issueHierarchyLevel: issueHierarchyLevel })=>({ setState: setState })=>{
            setState({
                isArchiveIssueModalOpen: true,
                issueKey: issueKey,
                issueId: issueId,
                onIssueArchiveSuccess: onIssueArchiveSuccess,
                onChildIssuesArchiveSuccess: onChildIssuesArchiveSuccess,
                onCloseIssueViewModal: onCloseIssueViewModal,
                triggerPointKey: triggerPointKey,
                workType: workType,
                issueHierarchyLevel: issueHierarchyLevel
            });
        },
    closeArchiveIssueModal: ()=>({ setState: setState })=>{
            setState({
                isArchiveIssueModalOpen: false,
                issueKey: null,
                issueId: null,
                onIssueArchiveSuccess: null,
                onChildIssuesArchiveSuccess: null,
                onCloseIssueViewModal: null,
                triggerPointKey: null,
                workType: null
            });
        }
};

});

parcelRegister("k3WVB", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $99d9d2d78573a32f$export$d4c72bab9d6cc13a);
const $99d9d2d78573a32f$export$d4c72bab9d6cc13a = {
    isArchiveIssueModalOpen: false,
    issueKey: null,
    issueId: null,
    onIssueArchiveSuccess: null,
    onChildIssuesArchiveSuccess: null,
    onCloseIssueViewModal: null,
    triggerPointKey: null,
    workType: null
};

});



parcelRegister("lks4g", function(module, exports) {

$parcel$export(module.exports, "archiveModalEntryPoint", () => $42638695c882aaf4$export$30191a6aa5a8420a);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $42638695c882aaf4$export$30191a6aa5a8420a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("5Cej8")), {
        moduleId: "95ca667b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5Cej8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hYMkZ").then(()=>parcelRequire('cpvId'));

});



parcelRegister("6pm44", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueCreateModal", () => $d5b1bf1f39f4f41b$export$2eb2fdb04fff9db3);

var $eJOHy = parcelRequire("eJOHy");

var $4NEt5 = parcelRequire("4NEt5");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $bJscI = parcelRequire("bJscI");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $jipjz = parcelRequire("jipjz");

var $MBWwk = parcelRequire("MBWwk");

var $7jTnu = parcelRequire("7jTnu");

var $h8WcZ = parcelRequire("h8WcZ");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d5b1bf1f39f4f41b$var$IssueCreateModalLazyAfterPaint = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("zSPEj")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-modal/src/index.tsx"
});
const $d5b1bf1f39f4f41b$var$IssueCreateModal = (0, $MBWwk.renderInBackgroundPriority)($d5b1bf1f39f4f41b$var$IssueCreateModalLazyAfterPaint, ()=>!(0, $7jTnu.fg)('jiv-after-paint-issue-create-bundle'));
const $d5b1bf1f39f4f41b$export$9d3f64b6e1f78ec2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        id: "async.jira.issue-create-modal",
        packageName: "jiraIssueCreate",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-create-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5b1bf1f39f4f41b$var$IssueCreateModal, null)));
};
const $d5b1bf1f39f4f41b$var$runtimeProps = {};
const $d5b1bf1f39f4f41b$var$entryPointParams = {};
const $d5b1bf1f39f4f41b$var$useIssueCreateModalEntrypoint = ()=>{
    const hasLoadedEntrypoint = (0, $eJOHy.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $h8WcZ.issueCreateModalEntryPoint), $d5b1bf1f39f4f41b$var$entryPointParams);
    const [{ isModalOpen: isModalOpen }] = (0, $jipjz.useTriggerIssueCreateModal)();
    // NOTE: this is a incremental step in properly adopting entrypoints for GIC
    // Do not copy this pattern in other places before giving #help-fe-loading proper reasoning
    // LDR: https://hello.atlassian.net/wiki/spaces/JIE/pages/4772823699/LDR+Entrypoint+Load+Via+Hooks+For+Faster+Experimentation
    if (!hasLoadedEntrypoint.current && isModalOpen) {
        entryPointActions.load();
        hasLoadedEntrypoint.current = true;
    }
    return {
        entryPointReferenceSubject: entryPointReferenceSubject
    };
};
const $d5b1bf1f39f4f41b$export$76bdbe008e758dac = ()=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = $d5b1bf1f39f4f41b$var$useIssueCreateModalEntrypoint();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "async.jira.issue-create-modal",
        packageName: "jiraIssueCreate",
        placeholderName: "issue-create-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $d5b1bf1f39f4f41b$var$runtimeProps
    });
};
const $d5b1bf1f39f4f41b$export$2eb2fdb04fff9db3 = (0, $bJscI.componentWithFG)('issue-create-modal-iv-llc-unnecessary-bundles', $d5b1bf1f39f4f41b$export$76bdbe008e758dac, $d5b1bf1f39f4f41b$export$9d3f64b6e1f78ec2);

});
parcelRegister("4NEt5", function(module, exports) {

$parcel$export(module.exports, "JiraIssueCreateErrorBoundary", () => $8e71aec117977467$export$fe891cbe61d9bf7b);

var $eJOHy = parcelRequire("eJOHy");

var $4vm01 = parcelRequire("4vm01");

var $1KdDN = parcelRequire("1KdDN");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $8e71aec117977467$export$fe891cbe61d9bf7b = (props)=>{
    const { children: children, attributes: attributes, onError: onError, taskName: taskName, ...otherProps } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const getAttributes = (0, $eJOHy.useCallback)((error)=>{
        // TODO: add additional attributes in that we need for issue create.
        const attributesPassed = typeof attributes === 'function' ? attributes(error) : attributes;
        return {
            ...attributesPassed
        };
    }, [
        attributes
    ]);
    const handleOnError = (0, $eJOHy.useCallback)((location, error, errorAttributes)=>{
        if (taskName) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $gCeeo.fireOperationalAnalyticsDeferred)(analyticsEvent, 'ui taskFail', {
                task: taskName
            });
        }
        onError?.(location, error, errorAttributes);
    }, [
        createAnalyticsEvent,
        onError,
        taskName
    ]);
    if ((0, $7jTnu.fg)('jira-issue-create-error-boundary-enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4vm01.IssueCommonErrorBoundary), {
        ...otherProps,
        attributes: getAttributes,
        onError: handleOnError
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        ...otherProps,
        onError: handleOnError
    }, children);
};

});
parcelRegister("4vm01", function(module, exports) {

$parcel$export(module.exports, "IssueCommonErrorBoundary", () => $7f78243e9971b663$export$eda988af1aea453d);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $gsYGk = parcelRequire("gsYGk");

var $8q7lT = parcelRequire("8q7lT");

var $gYnSx = parcelRequire("gYnSx");

var $k2nOs = parcelRequire("k2nOs");
const $7f78243e9971b663$export$eda988af1aea453d = ({ children: children, fallback: fallback, fireErrorEventWhenNetworkError: fireErrorEventWhenNetworkError, getErrorAttributes: getErrorAttributes, attributes: attributes, ...otherProps })=>{
    // TODO: understand what more common attributes can be common in all of issue domain
    // TODO: understand what is more common for issue view and create and transition.
    const accountIdLoggedInUser = (0, $8q7lT.useAccountId)();
    const getAttributes = (0, $eJOHy.useCallback)((error)=>{
        const attributesPassed = typeof attributes === 'function' ? attributes(error) : attributes;
        const tenantAttributes = (0, $k2nOs.getTenantAttributes)();
        const { errorAttributes: errorAttributes } = (0, $gsYGk.getIssueErrorAttributes)(error, accountIdLoggedInUser);
        return {
            ...attributesPassed,
            ...tenantAttributes,
            ...errorAttributes
        };
    }, [
        attributes,
        accountIdLoggedInUser
    ]);
    const isFallbackString = typeof fallback === 'string';
    const fallbackMethod = (0, $eJOHy.useCallback)((errorProps)=>{
        const { errorAttributes: errorAttributes } = (0, $gsYGk.getIssueErrorAttributes)(errorProps.error, accountIdLoggedInUser);
        if (errorAttributes.statusCode && errorAttributes.statusCode >= 400 && errorAttributes.statusCode < 500) {
            (0, $gYnSx.default)({
                error: errorProps.error,
                meta: {
                    id: 'issue.issue-view.viewIssue',
                    teamName: 'Bento'
                },
                attributes: {
                    ...attributes,
                    ...getErrorAttributes?.(errorProps.error),
                    statusCode: errorAttributes.statusCode,
                    traceId: errorAttributes.traceId || undefined
                }
            });
            return !isFallbackString && fallback?.(errorProps);
        }
    }, [
        accountIdLoggedInUser,
        attributes,
        fallback,
        getErrorAttributes,
        isFallbackString
    ]);
    const fallbackAbstracted = fireErrorEventWhenNetworkError && !isFallbackString ? fallbackMethod : fallback;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        ...otherProps,
        attributes: getAttributes,
        fallback: fallbackAbstracted
    }, children);
};

});
parcelRegister("gsYGk", function(module, exports) {

$parcel$export(module.exports, "statusCodesNotImpactingReliability", () => $978ae9edf0f65709$export$501df64f0fda1d63);
$parcel$export(module.exports, "getIssueErrorAttributes", () => $978ae9edf0f65709$export$23bbdbaa14274cfd);
$parcel$export(module.exports, "loginViaRedirectUrl", () => $978ae9edf0f65709$export$796a2c2756dc1f12);
$parcel$export(module.exports, "getIssueLimitErrorField", () => $978ae9edf0f65709$export$aba25149bb9fdf05);


var $1uIew = parcelRequire("1uIew");

var $8KUFq = parcelRequire("8KUFq");


var $bTB0V = parcelRequire("bTB0V");

var $jXX71 = parcelRequire("jXX71");

var $17NJ6 = parcelRequire("17NJ6");
const $978ae9edf0f65709$var$isIssueNetworkError = (error)=>(0, $8KUFq.isClientFetchError)(error) || (0, $8KUFq.isHttpClientErrorResponse)(error) || error instanceof (0, $1uIew.default) || error instanceof (0, $17NJ6.IssueViewFetchError);
const $978ae9edf0f65709$export$d3ca0619504206aa = new Set([
    (0, $86772b2bee686036$export$99405616af30f11f),
    (0, $86772b2bee686036$export$683dbe11f74cd161),
    (0, $86772b2bee686036$export$4e094d34a5cb1872),
    (0, $86772b2bee686036$export$f10b32dfda12e96e)
]);
const $978ae9edf0f65709$export$501df64f0fda1d63 = [
    (0, $44ccf6b895337c89$export$9de493bcd9b1d977),
    (0, $44ccf6b895337c89$export$4a3cb39801694eee),
    (0, $44ccf6b895337c89$export$fa405bbf47d510e2),
    (0, $44ccf6b895337c89$export$3b48aba8957000cd),
    (0, $44ccf6b895337c89$export$6763168a631449a2)
];
const $978ae9edf0f65709$var$isPreCalculatedErrorType = (error)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $978ae9edf0f65709$export$d3ca0619504206aa.has(error.message);
const $978ae9edf0f65709$export$23bbdbaa14274cfd = (error, accountIdLoggedInUser)=>{
    // TODO Cleanup with JIV-14818
    if ($978ae9edf0f65709$var$isPreCalculatedErrorType(error)) return {
        errorType: error.message,
        errorAttributes: error.errorAttributes
    };
    const errorType = (0, $86772b2bee686036$export$f10b32dfda12e96e);
    const errorAttributes = {
        errorMessage: error.message
    };
    if ($978ae9edf0f65709$var$isIssueNetworkError(error)) {
        const { statusCode: statusCode, traceId: traceId } = error;
        Object.assign(errorAttributes, {
            statusCode: statusCode,
            traceId: traceId
        });
        if (!accountIdLoggedInUser || statusCode === (0, $44ccf6b895337c89$export$67d19e9a991baa07)) return {
            errorType: (0, $86772b2bee686036$export$99405616af30f11f),
            errorAttributes: errorAttributes
        };
        if (statusCode === (0, $44ccf6b895337c89$export$8bca792d963eb0ef) || statusCode === (0, $44ccf6b895337c89$export$a3269a3914b007e3)) return {
            errorType: (0, $86772b2bee686036$export$4e094d34a5cb1872),
            errorAttributes: errorAttributes
        };
        // Relay Error - could be mainIssueAggQuery
        if (error instanceof (0, $17NJ6.IssueViewFetchError) && error?.getIsRelayError()) {
            if ((0, $8KUFq.isClientFetchError)(error) || statusCode && $978ae9edf0f65709$export$501df64f0fda1d63.includes(statusCode)) return {
                errorType: (0, $86772b2bee686036$export$683dbe11f74cd161),
                errorAttributes: errorAttributes
            };
            Object.assign(errorAttributes, {
                userExperience: error.userExperience || 'unknownExperience'
            });
            Object.assign(errorAttributes, {
                errorMessage: `${error.message}, endpoint: ${error.endpoint || 'unknown'}`,
                endpoint: error.endpoint || 'unknown'
            });
            Object.assign(errorAttributes, {
                additionalErrors: error.additionalErrors
            });
            // If the statusCode is undefine for Relay Error we want to set it as UNKNOWN_ERROR to (taskFail)
            return {
                errorType: (0, $86772b2bee686036$export$f10b32dfda12e96e),
                errorAttributes: errorAttributes
            };
        }
        // Return CONNECTIVITY_ERROR if the statusCode is undefined for un-relay error
        if (!statusCode || $978ae9edf0f65709$export$501df64f0fda1d63.includes(statusCode)) return {
            errorType: (0, $86772b2bee686036$export$683dbe11f74cd161),
            errorAttributes: errorAttributes
        };
    }
    return {
        errorType: errorType,
        errorAttributes: errorAttributes
    };
};
const $978ae9edf0f65709$export$796a2c2756dc1f12 = async (loginRedirectUrl)=>{
    if (!loginRedirectUrl) return;
    const encodedRedirectUrl = encodeURIComponent(loginRedirectUrl);
    const logInUrl = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.open(logInUrl, '_blank');
};
const $978ae9edf0f65709$export$aba25149bb9fdf05 = (error)=>{
    const errorMessagesList = error.message.split('; ');
    if (errorMessagesList.length === 0) return undefined;
    const fieldLimitErrorList = (0, $bTB0V.ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST).filter((fieldLimitErrorMessage)=>errorMessagesList.some((message)=>message.includes(fieldLimitErrorMessage)));
    // we prioritise comments/worklogs, if there are limits for both comments/worklogs and attachments.
    if (fieldLimitErrorList.includes((0, $bTB0V.COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE))) return 0, $jXX71.COMMENTS_PER_ISSUE_LIMIT_EXCEEDED;
    if (fieldLimitErrorList.includes((0, $bTB0V.WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE))) return 0, $jXX71.WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED;
    if (fieldLimitErrorList.includes((0, $bTB0V.ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE))) return 0, $jXX71.ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED;
    if (fieldLimitErrorList.includes((0, $bTB0V.REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE))) return 0, $jXX71.ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED;
    return undefined;
};

});
const $44ccf6b895337c89$export$ff39ebd4bb12b718 = 201;
const $44ccf6b895337c89$export$3288b14b6745c572 = 204;
const $44ccf6b895337c89$export$9de493bcd9b1d977 = 400;
const $44ccf6b895337c89$export$67d19e9a991baa07 = 401;
const $44ccf6b895337c89$export$a3269a3914b007e3 = 403;
const $44ccf6b895337c89$export$8bca792d963eb0ef = 404;
const $44ccf6b895337c89$export$4a3cb39801694eee = 407;
const $44ccf6b895337c89$export$fa405bbf47d510e2 = 408;
const $44ccf6b895337c89$export$c09e7ea0fc79f34f = 409;
const $44ccf6b895337c89$export$5244030134e99 = 412;
const $44ccf6b895337c89$export$f90ac1df0b60853d = 413;
const $44ccf6b895337c89$export$a447d0a965e16776 = 422;
const $44ccf6b895337c89$export$3b48aba8957000cd = 426;
const $44ccf6b895337c89$export$6763168a631449a2 = 429;
const $44ccf6b895337c89$export$e813cd7045fcc98d = 500;
const $44ccf6b895337c89$export$2ce38d41a306034e = 502;
const $44ccf6b895337c89$export$974c37534b0191b1 = 503;
const $44ccf6b895337c89$export$5400e8dddac3fcf3 = 504;

const $86772b2bee686036$export$99405616af30f11f = 'AUTHENTICATION_ERROR';
const $86772b2bee686036$export$683dbe11f74cd161 = 'CONNECTIVITY_ERROR';
const $86772b2bee686036$export$4e094d34a5cb1872 = 'NOT_FOUND_OR_NO_PERMISSION_ERROR';
const $86772b2bee686036$export$f10b32dfda12e96e = 'UNKNOWN_ERROR';

parcelRegister("bTB0V", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $418d903d5460862b$export$dd2d62bc7ec6ce51);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $418d903d5460862b$export$db1ab2b83dc17aa9);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $418d903d5460862b$export$940ce115dba33e55);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $418d903d5460862b$export$4ec1f3604b85d553);
$parcel$export(module.exports, "GROUP_VISIBILITY_SETTING_NOT_ENABLED", () => $418d903d5460862b$export$69483322ede4b803);
$parcel$export(module.exports, "NON_EDITABLE_WORKFLOW_STATE", () => $418d903d5460862b$export$c3d43a40ad9e5b50);
$parcel$export(module.exports, "ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST", () => $418d903d5460862b$export$e65b95e776ce6f27);
const $418d903d5460862b$export$dd2d62bc7ec6ce51 = 'ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $418d903d5460862b$export$db1ab2b83dc17aa9 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED: 5000';
const $418d903d5460862b$export$940ce115dba33e55 = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED: 10000';
const $418d903d5460862b$export$4ec1f3604b85d553 = 'REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $418d903d5460862b$export$69483322ede4b803 = 'GROUP_VISIBILITY_SETTING_NOT_ENABLED';
const $418d903d5460862b$export$c3d43a40ad9e5b50 = 'issue is in a non-editable workflow state.';
const $418d903d5460862b$export$e65b95e776ce6f27 = [
    $418d903d5460862b$export$dd2d62bc7ec6ce51,
    $418d903d5460862b$export$db1ab2b83dc17aa9,
    $418d903d5460862b$export$940ce115dba33e55,
    $418d903d5460862b$export$4ec1f3604b85d553
];

});

parcelRegister("jXX71", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_WATCHING_ERROR", () => $7d95a623c6b7866a$export$ec8031e221d27341);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_GENERIC", () => $7d95a623c6b7866a$export$78f84210a13989cb);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_INVALID", () => $7d95a623c6b7866a$export$10b0b01977598ffc);
$parcel$export(module.exports, "COMMENT_ACTION_ERROR_INVALID_PERMISSION", () => $7d95a623c6b7866a$export$8443c3b41d7f09d8);
$parcel$export(module.exports, "COMMENT_ACTION_ERROR_NON_EDITABLE_WORKFLOW_STATE", () => $7d95a623c6b7866a$export$2d541e654485e45b);
$parcel$export(module.exports, "COMMENT_DELETE_ERROR_NON_EDITABLE_WORKFLOW_STATE", () => $7d95a623c6b7866a$export$5fcc12322c6ff365);
$parcel$export(module.exports, "COMMENT_CONTENT_EXCEEDED_ERROR", () => $7d95a623c6b7866a$export$9b38ca770beaf3d0);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS_FLAG_MESSAGE", () => $7d95a623c6b7866a$export$eef81693e817e3a6);
$parcel$export(module.exports, "COMMENT_FUTURE_TIME_ERROR", () => $7d95a623c6b7866a$export$a0d4d86bde270ad6);
$parcel$export(module.exports, "COMMENT_DELETE_ERROR", () => $7d95a623c6b7866a$export$6b6cd1b99772a4a1);
$parcel$export(module.exports, "EDITOR_ERROR", () => $7d95a623c6b7866a$export$2e48be8618f1b4f8);
$parcel$export(module.exports, "ATTACHMENT_ADD_ERROR", () => $7d95a623c6b7866a$export$c060b7873ebc2eb3);
$parcel$export(module.exports, "ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR", () => $7d95a623c6b7866a$export$1f8e6f6f8d64a715);
$parcel$export(module.exports, "ATTACHMENT_ADD_SUCCESS", () => $7d95a623c6b7866a$export$1f92a25b34c4df93);
$parcel$export(module.exports, "DELETE_LINKED_ISSUE_ERROR", () => $7d95a623c6b7866a$export$d8750340852b965e);
$parcel$export(module.exports, "REMOTE_LINK_VALIDATION_ERROR", () => $7d95a623c6b7866a$export$f0962d071c2a358a);
$parcel$export(module.exports, "ATTACHMENT_DELETE_ERROR", () => $7d95a623c6b7866a$export$ef7767ceecf9097c);
$parcel$export(module.exports, "WATCH_TOGGLE_UPDATE_ERROR", () => $7d95a623c6b7866a$export$516af79f4e3b8794);
$parcel$export(module.exports, "FETCH_WATCHERS_ERROR", () => $7d95a623c6b7866a$export$cde4105f7711a10a);
$parcel$export(module.exports, "STOP_WATCHING_SUCCESS", () => $7d95a623c6b7866a$export$f674d1f44f57f99d);
$parcel$export(module.exports, "START_WATCHING_SUCCESS", () => $7d95a623c6b7866a$export$bff6b5ab70bcec53);
$parcel$export(module.exports, "REMOVE_WATCHER_ERROR", () => $7d95a623c6b7866a$export$37934e343a22c4e6);
$parcel$export(module.exports, "ADD_WATCHER_ERROR", () => $7d95a623c6b7866a$export$6a1827094c1ef6d8);
$parcel$export(module.exports, "ADD_WATCHER_PERMISSION_ERROR", () => $7d95a623c6b7866a$export$ff2029b86d44f1d4);
$parcel$export(module.exports, "SUBTASKS_REORDER_ERROR_GENERIC", () => $7d95a623c6b7866a$export$bb96d519395e5dcc);
$parcel$export(module.exports, "LOG_WORK_CONFIRM_ERROR", () => $7d95a623c6b7866a$export$18bd55ba676f8b6d);
$parcel$export(module.exports, "ASSIGN_TO_ME_SUCCESS", () => $7d95a623c6b7866a$export$1249a100986a9489);
$parcel$export(module.exports, "REMOVE_FROM_ME_SUCCESS", () => $7d95a623c6b7866a$export$6b737093486e5a4e);
$parcel$export(module.exports, "CREATE_CHILD_ISSUE_ERROR", () => $7d95a623c6b7866a$export$a2723f15441225d0);
$parcel$export(module.exports, "LINK_CHILD_ISSUE_ERROR", () => $7d95a623c6b7866a$export$569f7258d337be55);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_SUCCESS", () => $7d95a623c6b7866a$export$f92af4e9761d23b9);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_ERROR", () => $7d95a623c6b7866a$export$16dc9ff6a8822a90);
$parcel$export(module.exports, "DELETE_ISSUE_ERROR", () => $7d95a623c6b7866a$export$d4030883b7b7a04);
$parcel$export(module.exports, "ADD_WORKLOG_SUCCESS", () => $7d95a623c6b7866a$export$2519b72aefd62ee3);
$parcel$export(module.exports, "ADD_WORKLOG_FAILURE", () => $7d95a623c6b7866a$export$190e4e4a6ee2a0a2);
$parcel$export(module.exports, "ADD_WORKLOG_NON_EDITABLE_FAILURE", () => $7d95a623c6b7866a$export$2fc2c0027e184f83);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED", () => $7d95a623c6b7866a$export$f1709ebef49207cc);
$parcel$export(module.exports, "UPDATE_TIME_REMAINING_FAILURE", () => $7d95a623c6b7866a$export$bde55584c7518e8d);
$parcel$export(module.exports, "EDIT_WORKLOG_SUCCESS", () => $7d95a623c6b7866a$export$cf8d549e537c67d3);
$parcel$export(module.exports, "EDIT_WORKLOG_FAILURE", () => $7d95a623c6b7866a$export$2d33e591258e36a8);
$parcel$export(module.exports, "DELETE_WORKLOG_SUCCESS", () => $7d95a623c6b7866a$export$b595535e9bb1a2a2);
$parcel$export(module.exports, "DELETE_WORKLOG_FAILURE", () => $7d95a623c6b7866a$export$c3739a68f63b7e09);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_CONFIRM_ERROR", () => $7d95a623c6b7866a$export$6ba6cb22d5a3c521);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR", () => $7d95a623c6b7866a$export$b1a41c9183097dc);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_REQUIRED_ERROR", () => $7d95a623c6b7866a$export$67544887e2b37fbc);
$parcel$export(module.exports, "DELETE_CONFLUENCE_PAGE_LINK_FAILED", () => $7d95a623c6b7866a$export$67566c205c72838a);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_ERROR", () => $7d95a623c6b7866a$export$733fe45ab8c75209);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_SUCCESS", () => $7d95a623c6b7866a$export$9d1386a2d0651ca9);
$parcel$export(module.exports, "EDIT_EPIC_COLOUR_ERROR", () => $7d95a623c6b7866a$export$56094d7f6af14eac);
$parcel$export(module.exports, "EDIT_ISSUE_COLOUR_ERROR", () => $7d95a623c6b7866a$export$92d58445895900f9);
$parcel$export(module.exports, "FETCH_JIRA_APP_LINKS_ERROR", () => $7d95a623c6b7866a$export$75d850be4d27b98e);
$parcel$export(module.exports, "CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $7d95a623c6b7866a$export$9030bf81702823b8);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $7d95a623c6b7866a$export$a2a71fb6b193e549);
$parcel$export(module.exports, "ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $7d95a623c6b7866a$export$8c5e4d3dfe9a1c32);
$parcel$export(module.exports, "ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $7d95a623c6b7866a$export$49d11338d75de478);
$parcel$export(module.exports, "ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $7d95a623c6b7866a$export$3573d8ff428b4c8f);
$parcel$export(module.exports, "COMMENTS_LIMIT_EXCEEDED_FIELDS_LIST", () => $7d95a623c6b7866a$export$c0657c5ed1bbfed4);
const $7d95a623c6b7866a$export$ec8031e221d27341 = 'TOGGLE_WATCHING_ERROR';
const $7d95a623c6b7866a$export$78f84210a13989cb = 'COMMENT_ADD_ERROR_GENERIC';
const $7d95a623c6b7866a$export$10b0b01977598ffc = 'COMMENT_ADD_ERROR_INVALID';
const $7d95a623c6b7866a$export$8443c3b41d7f09d8 = 'COMMENT_ACTION_ERROR_INVALID_PERMISSION';
const $7d95a623c6b7866a$export$2d541e654485e45b = 'COMMENT_ACTION_ERROR_NON_EDITABLE_WORKFLOW_STATE';
const $7d95a623c6b7866a$export$5fcc12322c6ff365 = 'COMMENT_DELETE_ERROR_NON_EDITABLE_WORKFLOW_STATE';
const $7d95a623c6b7866a$export$9b38ca770beaf3d0 = 'COMMENT_CONTENT_EXCEEDED_ERROR';
const $7d95a623c6b7866a$export$eef81693e817e3a6 = 'SAVE_COMMENT_SUCCESS_FLAG_MESSAGE';
const $7d95a623c6b7866a$export$a0d4d86bde270ad6 = 'COMMENT_FUTURE_TIME_ERROR';
const $7d95a623c6b7866a$export$6b6cd1b99772a4a1 = 'COMMENT_DELETE_ERROR';
const $7d95a623c6b7866a$export$2e48be8618f1b4f8 = 'EDITOR_ERROR';
const $7d95a623c6b7866a$export$c060b7873ebc2eb3 = 'ATTACHMENT_ADD_ERROR';
const $7d95a623c6b7866a$export$1f8e6f6f8d64a715 = 'ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR';
const $7d95a623c6b7866a$export$1f92a25b34c4df93 = 'ATTACHMENT_ADD_SUCCESS';
const $7d95a623c6b7866a$export$d8750340852b965e = 'DELETE_LINKED_ISSUE_ERROR';
const $7d95a623c6b7866a$export$f0962d071c2a358a = 'REMOTE_LINK_VALIDATION_ERROR';
const $7d95a623c6b7866a$export$ef7767ceecf9097c = 'ATTACHMENT_DELETE_ERROR';
const $7d95a623c6b7866a$export$516af79f4e3b8794 = 'WATCH_TOGGLE_UPDATE_ERROR';
const $7d95a623c6b7866a$export$cde4105f7711a10a = 'FETCH_WATCHERS_ERROR';
const $7d95a623c6b7866a$export$f674d1f44f57f99d = 'STOP_WATCHING_SUCCESS';
const $7d95a623c6b7866a$export$bff6b5ab70bcec53 = 'START_WATCHING_SUCCESS';
const $7d95a623c6b7866a$export$37934e343a22c4e6 = 'REMOVE_WATCHER_ERROR';
const $7d95a623c6b7866a$export$6a1827094c1ef6d8 = 'ADD_WATCHER_ERROR';
const $7d95a623c6b7866a$export$ff2029b86d44f1d4 = 'ADD_WATCHER_PERMISSION_ERROR';
const $7d95a623c6b7866a$export$bb96d519395e5dcc = 'SUBTASKS_REORDER_ERROR_GENERIC';
const $7d95a623c6b7866a$export$18bd55ba676f8b6d = 'LOG_WORK_CONFIRM_ERROR';
const $7d95a623c6b7866a$export$1249a100986a9489 = 'ASSIGN_TO_ME_SUCCESS';
const $7d95a623c6b7866a$export$6b737093486e5a4e = 'REMOVE_FROM_ME_SUCCESS';
const $7d95a623c6b7866a$export$a2723f15441225d0 = 'CREATE_CHILD_ISSUE_ERROR';
const $7d95a623c6b7866a$export$569f7258d337be55 = 'LINK_CHILD_ISSUE_ERROR';
const $7d95a623c6b7866a$export$f92af4e9761d23b9 = 'CHANGE_ISSUE_TYPE_SUCCESS';
const $7d95a623c6b7866a$export$16dc9ff6a8822a90 = 'CHANGE_ISSUE_TYPE_ERROR';
const $7d95a623c6b7866a$export$d4030883b7b7a04 = 'DELETE_ISSUE_ERROR';
const $7d95a623c6b7866a$export$2519b72aefd62ee3 = 'ADD_WORKLOG_SUCCESS';
const $7d95a623c6b7866a$export$190e4e4a6ee2a0a2 = 'ADD_WORKLOG_FAILURE';
const $7d95a623c6b7866a$export$2fc2c0027e184f83 = 'ADD_WORKLOG_NON_EDITABLE_FAILURE';
const $7d95a623c6b7866a$export$f1709ebef49207cc = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED';
const $7d95a623c6b7866a$export$2357f9add92f1c9b = 'UPDATE_TIME_REMAINING_SUCCESS';
const $7d95a623c6b7866a$export$bde55584c7518e8d = 'UPDATE_TIME_REMAINING_FAILURE';
const $7d95a623c6b7866a$export$cf8d549e537c67d3 = 'EDIT_WORKLOG_SUCCESS';
const $7d95a623c6b7866a$export$2d33e591258e36a8 = 'EDIT_WORKLOG_FAILURE';
const $7d95a623c6b7866a$export$b595535e9bb1a2a2 = 'DELETE_WORKLOG_SUCCESS';
const $7d95a623c6b7866a$export$c3739a68f63b7e09 = 'DELETE_WORKLOG_FAILURE';
const $7d95a623c6b7866a$export$6ba6cb22d5a3c521 = 'RICH_CONTENT_FIELD_CONFIRM_ERROR';
const $7d95a623c6b7866a$export$b1a41c9183097dc = 'RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR';
const $7d95a623c6b7866a$export$67544887e2b37fbc = 'RICH_CONTENT_FIELD_REQUIRED_ERROR';
const $7d95a623c6b7866a$export$67566c205c72838a = 'DELETE_CONFLUENCE_PAGE_LINK_FAILED';
const $7d95a623c6b7866a$export$e3245a362f751a4a = 'DELETE_WEB_LINK_FAILED';
const $7d95a623c6b7866a$export$3408969e4d418350 = 'CLICKTHROUGH_BANNER_DISMISS_SUCCESS';
const $7d95a623c6b7866a$export$733fe45ab8c75209 = 'SAVE_APPROVAL_ANSWER_ERROR';
const $7d95a623c6b7866a$export$9d1386a2d0651ca9 = 'SAVE_APPROVAL_ANSWER_SUCCESS';
const $7d95a623c6b7866a$export$56094d7f6af14eac = 'EDIT_EPIC_COLOUR_ERROR';
const $7d95a623c6b7866a$export$92d58445895900f9 = 'EDIT_ISSUE_COLOUR_ERROR';
const $7d95a623c6b7866a$export$75d850be4d27b98e = 'FETCH_JIRA_APP_LINKS_ERROR';
const $7d95a623c6b7866a$export$9030bf81702823b8 = 'CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $7d95a623c6b7866a$export$a2a71fb6b193e549 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $7d95a623c6b7866a$export$2dd786d54c8f9397 = 'COMMENTS_INTERNAL_SERVER_ERROR';
const $7d95a623c6b7866a$export$8c5e4d3dfe9a1c32 = 'ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $7d95a623c6b7866a$export$49d11338d75de478 = 'ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $7d95a623c6b7866a$export$3573d8ff428b4c8f = 'ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $7d95a623c6b7866a$export$c0657c5ed1bbfed4 = [
    $7d95a623c6b7866a$export$a2a71fb6b193e549,
    $7d95a623c6b7866a$export$3573d8ff428b4c8f
];

});

parcelRegister("17NJ6", function(module, exports) {

$parcel$export(module.exports, "IssueViewFetchError", () => $c4c9d02822a05b1d$export$4802e881d6c7820d);

var $fJuTR = parcelRequire("fJuTR");

var $1uIew = parcelRequire("1uIew");
class $c4c9d02822a05b1d$export$4802e881d6c7820d extends (0, $fJuTR.default) {
    constructor(error, endpoint, traceId, isRelayError, userExperience, additionalErrors){
        super(error.message), this.error = error, this.endpoint = endpoint, this.traceId = traceId, this.isRelayError = isRelayError, this.userExperience = userExperience, this.additionalErrors = additionalErrors;
        this.endpoint = endpoint;
        this.error = error;
        this.message = error.message;
        if (error instanceof (0, $1uIew.default)) {
            if (error.traceId != null) this.traceId = error.traceId;
            this.statusCode = error.statusCode;
        }
        if (error instanceof $c4c9d02822a05b1d$export$4802e881d6c7820d) {
            this.error = error.error;
            this.statusCode = error.statusCode;
            this.traceId = error.traceId;
        }
        // set traceId from AGG, only if not set already
        if (!this.traceId && traceId && traceId !== '') this.traceId = traceId;
    }
    getIsRelayError() {
        return this.isRelayError === true;
    }
}

});


parcelRegister("k2nOs", function(module, exports) {

$parcel$export(module.exports, "getTenantAttributes", () => $6d869a890ae8f6bb$export$bc31ff13a0bbe592);

var $hWeHP = parcelRequire("hWeHP");

var $lopBx = parcelRequire("lopBx");
const $6d869a890ae8f6bb$export$bc31ff13a0bbe592 = ()=>{
    const shard = (0, $hWeHP.default)('ajs-shard');
    const region = (0, $hWeHP.default)('ajs-region');
    return {
        shard: shard,
        region: region,
        isFedRamp: (0, $lopBx.isFedRamp)()
    };
};

});



parcelRegister("h8WcZ", function(module, exports) {

$parcel$export(module.exports, "issueCreateModalEntryPoint", () => $e91ec0f4d3279950$export$62a0f9f7d7af1cac);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $e91ec0f4d3279950$export$62a0f9f7d7af1cac = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("zSPEj")).then((module)=>module.IssueCreateAppWithApolloProviderEntrypoint), {
        moduleId: "88c615ca",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("zSPEj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3yAl4"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("fliVL"),
    $ewTvA("2h1uS")
]).then(()=>parcelRequire('6kSlS'));

});



parcelRegister("aS7Qh", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueTransitionModal", () => $298e30cef62fa906$export$5156c94e3e50c841);

var $eJOHy = parcelRequire("eJOHy");

var $cystD = parcelRequire("cystD");

var $bbdV2 = parcelRequire("bbdV2");

var $7jTnu = parcelRequire("7jTnu");

var $8KF4L = parcelRequire("8KF4L");

var $9VNXy = parcelRequire("9VNXy");

var $f9jBk = parcelRequire("f9jBk");

var $kEUB1 = parcelRequire("kEUB1");


var $iVKTW = parcelRequire("iVKTW");
// this is just a place holder, if issueId is not available, we will not use issue ari but instead use the issue Key.
// How ever relay need this to be defined, so we are using a default value.
const $298e30cef62fa906$var$DEFAULT_ISSUE_ARI = 'ari:cloud:jira::issue/';
const $298e30cef62fa906$var$runtimeProps = {};
const $298e30cef62fa906$export$5156c94e3e50c841 = ()=>{
    const [{ isModalOpen: isModalOpen, payload: payload, isBenefitsModalOpen: isBenefitsModalOpen }] = (0, $f9jBk.useTriggerIssueTransitionModal)();
    const { transitionId: transitionId, issueId: issueId, issueKey: issueKey } = payload;
    /**
	 * Creating ari's which may be incorrect.
	 * This is not used in the query apart from verifying issueId,
	 */ const cloudId = (0, $kEUB1.useCloudId)();
    const defautIssueAri = $298e30cef62fa906$var$DEFAULT_ISSUE_ARI;
    const updatedIssueAriId = issueId ?? defautIssueAri;
    /* End of code which should not be used for any other thing
	 */ const variables = (0, $eJOHy.useMemo)(()=>{
        const shouldUseIssueKey = !issueId;
        const issueInput = shouldUseIssueKey ? {
            issueKey: issueKey
        } : {
            issueId: issueId
        };
        return {
            transitionId: transitionId,
            issueId: updatedIssueAriId,
            issueKey: issueKey,
            cloudId: cloudId,
            moveGicFieldToDecomp: true,
            useForgeExtensionsWithModuleId: (0, $7jTnu.fg)('forge-extensions-module-id-for-relay'),
            shouldUseIssueKey: !issueId,
            issueInput: issueInput,
            forgeExtensionRenderingContext: {
                issueKey: issueKey
            },
            uiModificationsContext: {
                issueKey: issueKey,
                viewType: (0, $bcddf6968ff42ad8$export$a415896b28cb78d7)
            }
        };
    }, [
        transitionId,
        updatedIssueAriId,
        issueKey,
        cloudId,
        issueId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $iVKTW.asyncIssueTransitionModal), variables);
    (0, $9VNXy.useSubscribeOpenIssueTransitionModalPubSub)();
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isModalOpen && transitionId && (issueKey || issueId)) entryPointActions.load();
        else entryPointActions.unload();
    }, [
        entryPointActions,
        isModalOpen,
        issueKey,
        issueId,
        transitionId
    ]);
    const { entryPointActions: benefitsModalentryPointActions, entryPointReferenceSubject: benefitsModalEntryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $8KF4L.asyncTransitionBenefitsModal), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal')) return;
        if (isBenefitsModalOpen) benefitsModalentryPointActions.load();
        else benefitsModalentryPointActions.unload();
    }, [
        benefitsModalentryPointActions,
        isBenefitsModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cystD.ModalEntryPointContainer), {
        entryPointReferenceSubject: benefitsModalEntryPointReferenceSubject,
        id: "async.jira.benefits-transition-modal",
        packageName: "jiraIssueTransitionModal",
        teamName: "Gryffindor",
        runtimeProps: $298e30cef62fa906$var$runtimeProps,
        entryPointActions: benefitsModalentryPointActions,
        errorFallback: "flag"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cystD.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "async.jira.issue-transition-modal",
        packageName: "jiraIssueTransitionModal",
        teamName: "Gryffindor",
        runtimeProps: $298e30cef62fa906$var$runtimeProps,
        entryPointActions: entryPointActions,
        errorFallback: "flag"
    }));
};

});
parcelRegister("8KF4L", function(module, exports) {

$parcel$export(module.exports, "asyncTransitionBenefitsModal", () => $d94ed6763e84b59c$export$5afe60117d97d43d);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $d94ed6763e84b59c$export$5afe60117d97d43d = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("f1HVf")), {
        moduleId: "164e3e4b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("f1HVf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("klHyh").then(()=>parcelRequire('8Jdvp'));

});


parcelRegister("9VNXy", function(module, exports) {

$parcel$export(module.exports, "useSubscribeOpenIssueTransitionModalPubSub", () => $f82a9ebf357fe69b$export$6f604f2d83486070);

var $eJOHy = parcelRequire("eJOHy");

var $f9jBk = parcelRequire("f9jBk");

var $3FNro = parcelRequire("3FNro");


var $bZa4R = parcelRequire("bZa4R");
const $f82a9ebf357fe69b$export$6f604f2d83486070 = ()=>{
    const [{ isModalOpen: isModalOpen }] = (0, $f9jBk.default)();
    const { openIssueTransitionModal: openIssueTransitionModalAction } = (0, $3FNro.useTriggerIssueTransitionModalActions)();
    (0, $eJOHy.useEffect)(()=>{
        const handleMessage = (message)=>{
            if (!isModalOpen) openIssueTransitionModalAction(message.payload, message.isEnabled);
        };
        (0, $bZa4R.ITSPubSub).subscribe((0, $3c718c856dd4cbdb$export$283bfc4a4b25707a), handleMessage);
        return ()=>{
            (0, $bZa4R.ITSPubSub).unsubscribe((0, $3c718c856dd4cbdb$export$283bfc4a4b25707a), handleMessage);
        };
    }, [
        isModalOpen,
        openIssueTransitionModalAction
    ]);
    return null;
};

});
parcelRegister("f9jBk", function(module, exports) {

$parcel$export(module.exports, "useOpenIssueTransitionModal", () => $203e3d1400c85c11$export$736bd10472c63b49);
$parcel$export(module.exports, "useCloseIssueTransitionModal", () => $203e3d1400c85c11$export$4629f18d511ad32e);
$parcel$export(module.exports, "useTriggerIssueTransitionModal", () => $203e3d1400c85c11$export$95a1e9702d78f223);
$parcel$export(module.exports, "default", () => $203e3d1400c85c11$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2EgxC = parcelRequire("2EgxC");

var $7jTnu = parcelRequire("7jTnu");

var $6hw9S = parcelRequire("6hw9S");

var $bmoS1 = parcelRequire("bmoS1");

var $2Z9P0 = parcelRequire("2Z9P0");

var $l4UT4 = parcelRequire("l4UT4");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $5yVUD = parcelRequire("5yVUD");

var $aYBjl = parcelRequire("aYBjl");

var $4xxMe = parcelRequire("4xxMe");

var $3FNro = parcelRequire("3FNro");

var $7SyqX = parcelRequire("7SyqX");

var $axEN1 = parcelRequire("axEN1");
const $203e3d1400c85c11$export$736bd10472c63b49 = ()=>{
    const { openIssueTransitionModal: openIssueTransitionModalAction, openIssueTransitionModalNew: openIssueTransitionModalNew } = (0, $3FNro.useTriggerIssueTransitionModalActions)();
    const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, $aYBjl.useIssueTransitionLabsOptIn)();
    const publish = (0, $4xxMe.usePublishOpenIssueTransitionModalPubSub)();
    const source = (0, $bmoS1.useAnalyticsSource)();
    const { fireUIEvent: fireUIEvent } = (0, $l4UT4.useIssueTransitionUIAnalyticsEvent)();
    const { stateGet: { state: state } } = (0, $5yVUD.useIssueTransitionChangeboardingPreferences)();
    const { fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened } = (0, $2Z9P0.useIssueTransitionsOperationalAnalyticsEvent)();
    const benefitsModal = typeof state !== 'number' ? state?.benefitsModal : undefined;
    const { isDisabled: isDisabled, nextDateToShowBenefitsModal: nextDateToShowBenefitsModal } = benefitsModal || {};
    return (0, $eJOHy.useCallback)((nextState)=>{
        try {
            const { triggerPointKey: triggerPointKey } = nextState || {};
            const isNewITSEnabled = (0, $axEN1.isNewTransitionScreenEnabled)(isEnabled, triggerPointKey);
            if ((0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal')) {
                fireOperationalAnalyticsTransitionScreenOpened({
                    actionSubject: 'issueTransition triggered',
                    isBenefitsModalFGEneabled: (0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal'),
                    preferNewIssueTransitionScreen: isEnabled,
                    issueViewAnalyticsSource: source,
                    isBenefitsModalDisabled: isDisabled,
                    dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined
                });
                openIssueTransitionModalNew({
                    nextState: nextState,
                    preferNewIssueTransitionScreen: isEnabled,
                    issueViewAnalyticsSource: source,
                    publishTriggerToOpenTransitions: publish,
                    isBenefitsModalDisabled: isDisabled,
                    dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined,
                    fireUIEvent: fireUIEvent
                });
                return;
            }
            if ((0, $7jTnu.fg)('fix-connect-app-not-loading')) {
                if (isNewITSEnabled && source === 'connect-issue') {
                    // fire UI event when issue transition is opened via connect API
                    fireUIEvent({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    publish(nextState, isEnabled);
                } else openIssueTransitionModalAction(nextState, isEnabled);
            } else if (source === 'connect-issue') {
                // fire UI event when issue transition is opened via connect API
                fireUIEvent({
                    actionSubject: 'issueTransition',
                    actionSubjectId: 'connectIssue',
                    action: 'opened'
                });
                publish(nextState, isEnabled);
            } else openIssueTransitionModalAction(nextState, isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2EgxC.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                attributes: {
                    transitionModalVersion: 'NEW'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, [
        fireOperationalAnalyticsTransitionScreenOpened,
        isEnabled,
        source,
        isDisabled,
        nextDateToShowBenefitsModal,
        openIssueTransitionModalNew,
        publish,
        fireUIEvent,
        openIssueTransitionModalAction
    ]);
};
const $203e3d1400c85c11$export$4629f18d511ad32e = ()=>{
    const [, { resetState: resetState }] = (0, $6hw9S.useInlineFieldsActions)();
    const { closeIssueTransitionModal: closeIssueTransitionModalAction } = (0, $3FNro.useTriggerIssueTransitionModalActions)();
    const { payload: { issueKey: issueKey, transitionId: transitionId }, onDialogCancel: onDialogCancel, onDialogError: onDialogError, onDialogSuccess: onDialogSuccess } = (0, $3FNro.useTriggerIssueTransitionModalState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((shouldOpenLegacyModal = false)=>{
        closeIssueTransitionModalAction();
        resetState();
        if (shouldOpenLegacyModal) {
            const onOpenDialog = ()=>{
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'legacyTransitionsScreen Switched');
            };
            (0, $7SyqX.openLegacyIssueTransitionModal)({
                issueKey: issueKey,
                isReopenScenario: true,
                transitionId: transitionId,
                onDialogCancel: onDialogCancel,
                onDialogError: onDialogError,
                onDialogSuccess: onDialogSuccess,
                onOpenDialog: onOpenDialog
            });
        }
    }, [
        closeIssueTransitionModalAction,
        createAnalyticsEvent,
        issueKey,
        onDialogCancel,
        onDialogError,
        onDialogSuccess,
        transitionId,
        resetState
    ]);
};
const $203e3d1400c85c11$export$95a1e9702d78f223 = ()=>{
    const state = (0, $3FNro.useTriggerIssueTransitionModalState)();
    const actions = (0, $3FNro.useTriggerIssueTransitionModalActions)();
    const { openIssueTransitionModalNew: openIssueTransitionModalNew, ...restActions } = actions;
    const openIssueTransitionModal = $203e3d1400c85c11$export$736bd10472c63b49();
    return [
        state,
        {
            ...restActions,
            openIssueTransitionModal: openIssueTransitionModal
        }
    ];
};
var $203e3d1400c85c11$export$2e2bcd8739ae039 = $203e3d1400c85c11$export$95a1e9702d78f223;

});
parcelRegister("2EgxC", function(module, exports) {

$parcel$export(module.exports, "fireIssueTransitionErrorAnalytics", () => $afba0e2c09012241$export$3839c9497170b08f);

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $bguQO = parcelRequire("bguQO");
const $afba0e2c09012241$export$3839c9497170b08f = (payload)=>{
    if (!(0, $7jTnu.fg)('issue-transition-fire-error-analytics-refactor')) return (0, $gYnSx.default)(payload);
    const { attributes: attributes = {}, error: error, ...otherPayload } = payload;
    (0, $bguQO.fireErrorAnalyticsCommon)({
        ...otherPayload,
        attributes: {
            ...attributes
        },
        error: error
    });
};

});
parcelRegister("bguQO", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalyticsCommon", () => $ae9ed2f07255b016$export$51f199f6846377f7);

var $gYnSx = parcelRequire("gYnSx");

var $k2nOs = parcelRequire("k2nOs");
const $ae9ed2f07255b016$export$51f199f6846377f7 = (payload)=>{
    const { skipSentry: skipSentry = true, attributes: attributes, ...otherPayload } = payload;
    (0, $gYnSx.default)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...(0, $k2nOs.getTenantAttributes)()
        },
        skipSentry: // skiping sentry as true for fireErrorAnalytics
        skipSentry
    });
};

});


parcelRegister("6hw9S", function(module, exports) {

$parcel$export(module.exports, "useInlineFields", () => $36772de20b38f9e3$export$71d5b5acb7d7f5ce);
$parcel$export(module.exports, "useInlineField", () => $36772de20b38f9e3$export$14c9655e9d9e873c);
$parcel$export(module.exports, "useInlineFieldsActions", () => $36772de20b38f9e3$export$cdb4b503c6154b35);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9pP3F = parcelRequire("9pP3F");
// Inline fields state tracks field states in create issue view as the user interacts with them
// this is particularly needed as we want to save the field's value when the user
// unfocuses the field
const $36772de20b38f9e3$var$store = (0, $GtRbT.createStore)({
    name: 'forge.inline-fields-state',
    initialState: {},
    actions: $9pP3F.default
});
const $36772de20b38f9e3$export$71d5b5acb7d7f5ce = (0, $iJq0l.createHook)($36772de20b38f9e3$var$store);
const $36772de20b38f9e3$export$14c9655e9d9e873c = (0, $iJq0l.createHook)($36772de20b38f9e3$var$store, {
    selector: (state, fieldId)=>state[fieldId]
});
const $36772de20b38f9e3$export$cdb4b503c6154b35 = (0, $iJq0l.createHook)($36772de20b38f9e3$var$store, {
    selector: null
});

});
parcelRegister("9pP3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $29c5e55e7c9295c3$export$2e2bcd8739ae039);

var $daw73 = parcelRequire("daw73");
const $29c5e55e7c9295c3$var$actions = {
    setFieldState: $daw73.setFieldState,
    resetState: $daw73.resetState,
    dispatchRetryFunction: $daw73.dispatchRetryFunction,
    dispatchFormSubmits: $daw73.dispatchFormSubmits
};
var $29c5e55e7c9295c3$export$2e2bcd8739ae039 = $29c5e55e7c9295c3$var$actions;

});
parcelRegister("daw73", function(module, exports) {

$parcel$export(module.exports, "setFieldState", () => $21c19e4f95046684$export$80fd62d9217dd703);
$parcel$export(module.exports, "resetState", () => $21c19e4f95046684$export$8e84bad0b35de9e8);
$parcel$export(module.exports, "dispatchRetryFunction", () => $21c19e4f95046684$export$27c59f06a7c1fe26);
$parcel$export(module.exports, "dispatchFormSubmits", () => $21c19e4f95046684$export$42fd5e650971333b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7jTnu = parcelRequire("7jTnu");


var $21Y41 = parcelRequire("21Y41");
const $21c19e4f95046684$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const stateObject = {
            status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
            formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
            retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction,
            ...(0, $7jTnu.fg)('fcf-new-submit-on-gic-and-tv') ? {
                onFormSubmit: data.onFormSubmit !== undefined ? data.onFormSubmit : currentState[data.fieldId]?.onFormSubmit
            } : {}
        };
        setState({
            ...getState(),
            [data.fieldId]: stateObject
        });
    };
const $21c19e4f95046684$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateToOverride = {};
        Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
            stateToOverride[fieldId] = {
                status: (0, $dfc00c8d0d7fbcf9$export$bbf78c43fa5268c8)
            };
        });
        setState(stateToOverride);
    };
const $21c19e4f95046684$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
        const currentState = getState();
        const fieldData = currentState[fieldId];
        const retryFunction = fieldData?.retryFunction;
        retryFunction && retryFunction();
    };
const $21c19e4f95046684$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
        const currentState = getState();
        Object.keys(currentState).forEach((fieldId)=>{
            if (currentState[fieldId]?.status === (0, $dfc00c8d0d7fbcf9$export$32bbcfb76243a487)) {
                if ((0, $7jTnu.fg)('fcf-new-submit-on-gic-and-tv')) currentState[fieldId]?.onFormSubmit?.();
                else {
                    const formRef = currentState[fieldId]?.formRef;
                    (0, $21Y41.dispatchFormSubmitAndBlurElements)(formRef);
                }
            }
        });
    };

});
const $dfc00c8d0d7fbcf9$export$32bbcfb76243a487 = 'FOCUSED';
const $dfc00c8d0d7fbcf9$export$f81c1d6b9217380c = 'PENDING';
const $dfc00c8d0d7fbcf9$export$2ace7d3737836262 = 'RESOLVED';
const $dfc00c8d0d7fbcf9$export$9956c6a700e724c4 = 'STORED';
const $dfc00c8d0d7fbcf9$export$742c877aeb0f3dbd = 'FAILED';
const $dfc00c8d0d7fbcf9$export$bbf78c43fa5268c8 = 'IDLE';
const $dfc00c8d0d7fbcf9$export$ae7c16bdba5e2e15 = 10000;
const $dfc00c8d0d7fbcf9$export$30daef8830f2505d = 'WAIT';
const $dfc00c8d0d7fbcf9$export$f86e250f1a7b07c8 = 'PROCEED';
const $dfc00c8d0d7fbcf9$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("21Y41", function(module, exports) {

$parcel$export(module.exports, "submitForgeFormField", () => $52b8ad5d67eac13b$export$7e50fee868362aa2);
$parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", () => $52b8ad5d67eac13b$export$4d639a8e0790daf2);
$parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", () => $52b8ad5d67eac13b$export$ee23412a8bea9333);

const $52b8ad5d67eac13b$export$7e50fee868362aa2 = (formRef)=>{
    formRef?.current?.requestSubmit();
};
const $52b8ad5d67eac13b$export$4d639a8e0790daf2 = (formRef)=>{
    $52b8ad5d67eac13b$export$7e50fee868362aa2(formRef);
    if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
        if ('blur' in element && typeof element.blur === 'function') element?.blur();
    });
};
const $52b8ad5d67eac13b$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $dfc00c8d0d7fbcf9$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);

});




parcelRegister("2Z9P0", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionsOperationalAnalyticsEvent", () => $61f1a0bd70160d80$export$4d10663856b750d0);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $61f1a0bd70160d80$export$4d10663856b750d0 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireOperationalEventIssueTransitionFieldsCount = (0, $eJOHy.useCallback)(({ actionSubject: actionSubject, fieldCount: fieldCount })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            fieldCount: fieldCount
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsPermissionsUnAvailable = (0, $eJOHy.useCallback)(({ actionSubject: actionSubject })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject);
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsTransitionScreenOpened = (0, $eJOHy.useCallback)(({ actionSubject: actionSubject, isBenefitsModalFGEneabled: isBenefitsModalFGEneabled, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen, issueViewAnalyticsSource: issueViewAnalyticsSource, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            isBenefitsModalFGEneabled: isBenefitsModalFGEneabled,
            preferNewIssueTransitionScreen: preferNewIssueTransitionScreen,
            issueViewAnalyticsSource: issueViewAnalyticsSource,
            isBenefitsModalDisabled: isBenefitsModalDisabled,
            dateToShowBenefitsModal: dateToShowBenefitsModal
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireOperationalEventIssueTransitionFieldsCount: fireOperationalEventIssueTransitionFieldsCount,
        fireOperationalAnalyticsPermissionsUnAvailable: fireOperationalAnalyticsPermissionsUnAvailable,
        fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened
    };
};

});

parcelRegister("l4UT4", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionUIAnalyticsEvent", () => $8ffdc81ff1362a6d$export$d0823e3d2e087672);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $8ffdc81ff1362a6d$export$d0823e3d2e087672 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireUIEvent = (0, $eJOHy.useCallback)(({ analyticsEvent: analyticsEvent, actionSubjectId: actionSubjectId, action: action = 'clicked', actionSubject: actionSubject, attributes: attributes = {} })=>{
        if (analyticsEvent !== undefined) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
        else {
            const createdAnalyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            (0, $gCeeo.fireUIAnalytics)(createdAnalyticsEvent, actionSubjectId, attributes);
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireUIEvent: fireUIEvent
    };
};

});

parcelRegister("4xxMe", function(module, exports) {

$parcel$export(module.exports, "usePublishOpenIssueTransitionModalPubSub", () => $4322ecec3e9446dc$export$76b6328962c9935f);

var $eJOHy = parcelRequire("eJOHy");


var $bZa4R = parcelRequire("bZa4R");
const $4322ecec3e9446dc$export$76b6328962c9935f = ()=>(0, $eJOHy.useCallback)((payload, isEnabled)=>{
        (0, $bZa4R.ITSPubSub).publish((0, $3c718c856dd4cbdb$export$283bfc4a4b25707a), {
            payload: payload,
            isEnabled: isEnabled
        });
    }, []);

});
const $3c718c856dd4cbdb$export$283bfc4a4b25707a = 'open-issue-transition-modal';

parcelRegister("bZa4R", function(module, exports) {

$parcel$export(module.exports, "ITSPubSub", () => $d8182c339189cae2$export$a3877931259d622e);

var $eyAys = parcelRequire("eyAys");
const $d8182c339189cae2$export$a3877931259d622e = new (0, $eyAys.PubSubHub)();
const $d8182c339189cae2$export$58b86c4766378620 = ()=>({
        ...$d8182c339189cae2$export$a3877931259d622e
    });

});
parcelRegister("eyAys", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $3f91a97de5262c97$export$e3607828f8f2c01e);
class $3f91a97de5262c97$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});



parcelRegister("3FNro", function(module, exports) {

$parcel$export(module.exports, "TriggerIssueTransitionModalContainer", () => $02ead0d1b558cb0d$export$8ad65e459a406a8a);
$parcel$export(module.exports, "useTriggerIssueTransitionModalActions", () => $02ead0d1b558cb0d$export$68de001c738e4145);
$parcel$export(module.exports, "useTriggerIssueTransitionModalState", () => $02ead0d1b558cb0d$export$d3aceeec551eaab5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $2ZWxz = parcelRequire("2ZWxz");

var $3kNiX = parcelRequire("3kNiX");
const $02ead0d1b558cb0d$var$store = (0, $GtRbT.createStore)({
    name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
    initialState: $2ZWxz.initialState,
    actions: $3kNiX
});
const $02ead0d1b558cb0d$export$8ad65e459a406a8a = (0, $6E16M.createContainer)($02ead0d1b558cb0d$var$store);
const $02ead0d1b558cb0d$export$68de001c738e4145 = (0, $iJq0l.createActionsHook)($02ead0d1b558cb0d$var$store);
const $02ead0d1b558cb0d$export$d3aceeec551eaab5 = (0, $iJq0l.createStateHook)($02ead0d1b558cb0d$var$store);

});
parcelRegister("2ZWxz", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $93d963d2149f1f5f$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "OPEN_MODERN_TRANSITION_MODAL", () => $93d963d2149f1f5f$export$7320afd6d2c7276d);
$parcel$export(module.exports, "OPEN_LEGACY_TRANSITION_MODAL", () => $93d963d2149f1f5f$export$8ed7400ca8e89de2);

const $93d963d2149f1f5f$export$d4c72bab9d6cc13a = {
    isModalOpen: false,
    isBenefitsModalOpen: false,
    isSubsequentLoad: false,
    payload: {
        issueId: '',
        issueKey: '',
        transitionId: ''
    },
    id: 'issue-transition-dialog',
    title: null,
    fetchedIssueId: '',
    triggerPointKey: (0, $862d7962fb804c73$export$8d987f6e80b74000),
    openLegacyTransitionsDialog: null,
    onDialogSuccess: null,
    onDialogCancel: null,
    onDialogError: null
};
const $93d963d2149f1f5f$export$7320afd6d2c7276d = 'OPEN_MODERN_TRANSITION_MODAL';
const $93d963d2149f1f5f$export$8ed7400ca8e89de2 = 'OPEN_LEGACY_TRANSITION_MODAL';

});
const $862d7962fb804c73$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $862d7962fb804c73$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $862d7962fb804c73$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $862d7962fb804c73$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $862d7962fb804c73$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $862d7962fb804c73$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $862d7962fb804c73$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $862d7962fb804c73$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $862d7962fb804c73$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $862d7962fb804c73$export$2bf0e335b815a90b = 'comment';
const $862d7962fb804c73$export$1b8cc53b37a62399 = 'worklog';
const $862d7962fb804c73$export$d624b8367eb730df = 'issuelinks';


parcelRegister("3kNiX", function(module, exports) {

$parcel$export(module.exports, "closeIssueTransitionModal", () => (parcelRequire("bfHFG")).default);
$parcel$export(module.exports, "openIssueTransitionModal", () => (parcelRequire("6bdxh")).default);
$parcel$export(module.exports, "restoreState", () => (parcelRequire("76GoG")).default);
$parcel$export(module.exports, "setFetchedIssueId", () => (parcelRequire("edFG8")).default);
$parcel$export(module.exports, "hideBenefitsModal", () => (parcelRequire("6EG2b")).default);
$parcel$export(module.exports, "openIssueTransitionModalNew", () => (parcelRequire("bgUfW")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $bfHFG = parcelRequire("bfHFG");

var $6bdxh = parcelRequire("6bdxh");

var $76GoG = parcelRequire("76GoG");

var $edFG8 = parcelRequire("edFG8");

var $6EG2b = parcelRequire("6EG2b");

var $bgUfW = parcelRequire("bgUfW");

});
parcelRegister("bfHFG", function(module, exports) {

$parcel$export(module.exports, "default", () => $621b2e1d5352d14e$export$2e2bcd8739ae039);

var $2ZWxz = parcelRequire("2ZWxz");
const $621b2e1d5352d14e$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
        setState({
            ...(0, $2ZWxz.initialState),
            isModalOpen: false,
            isSubsequentLoad: true
        });
    };
var $621b2e1d5352d14e$export$2e2bcd8739ae039 = $621b2e1d5352d14e$var$closeIssueTransitionModal;

});

parcelRegister("6bdxh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2769a08690472f10$export$2e2bcd8739ae039);

var $12DRg = parcelRequire("12DRg");

var $23DdZ = parcelRequire("23DdZ");

var $9UaKE = parcelRequire("9UaKE");

var $2EgxC = parcelRequire("2EgxC");

var $lXLoB = parcelRequire("lXLoB");

var $axEN1 = parcelRequire("axEN1");
const $2769a08690472f10$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $axEN1.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                transitionModalVersion = 'NEW';
                (0, $lXLoB.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $9UaKE.timeToRenderTransitionModal).start();
                new (0, $23DdZ.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2EgxC.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $2769a08690472f10$export$2e2bcd8739ae039 = $2769a08690472f10$var$openIssueTransitionModal;

});
parcelRegister("23DdZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $48cd41f2280862c0$export$2e2bcd8739ae039);

var $12DRg = parcelRequire("12DRg");

var $gjeS9 = parcelRequire("gjeS9");
var $agkbU = parcelRequire("agkbU");
var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");
var $ligZL = parcelRequire("ligZL");

var $kIz4h = parcelRequire("kIz4h");

var $7jTnu = parcelRequire("7jTnu");

var $9UaKE = parcelRequire("9UaKE");
class $48cd41f2280862c0$export$2e2bcd8739ae039 {
    constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
        this.onDialogSuccessCallback = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
        this.onDialogErrorCallback = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
        this.onDialogCancelCallback = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
        this.issueId = issueId;
        this.transitionId = transitionId;
        this.issueKey = issueKey;
        this.issueKeys = issueKeys;
    }
    static{
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                (0, $9UaKE.timeToRenderTransitionModal).stop();
            });
        };
    }
    onDialogSuccess(onDialogSuccessCallback) {
        this.onDialogSuccessCallback = onDialogSuccessCallback;
        return this;
    }
    onDialogError(onDialogErrorCallback) {
        this.onDialogErrorCallback = onDialogErrorCallback;
        return this;
    }
    onDialogCancel(onDialogCancelCallback) {
        this.onDialogCancelCallback = onDialogCancelCallback;
        return this;
    }
    getIssueParam() {
        if (this.issueId != null) return `id=${this.issueId}`;
        if (this.issueKey != null) return `key=${this.issueKey}`;
        return '';
    }
    getUrl() {
        const { issueKeys: issueKeys } = this;
        if (issueKeys != null) // key= is needed to be sent together with keys= because of legacy API
        return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, $kIz4h.default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
        return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, $kIz4h.default)() || ''}&returnUrl=`;
    }
    async show() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogContentReady', $48cd41f2280862c0$export$2e2bcd8739ae039.onDialogContentReady);
        let FormDialog;
        /**
		 * Trying out different ways of load the AMD bundle for legacy issue transition dialog
		 */ /* eslint-disable jira/wrm/no-load-bridge */ if ((0, $7jTnu.fg)('legacy-its-modal-load-with-load-bridge-weak')) FormDialog = await (0, $iyT45.loadBridgeWeak)({
            name: 'jira/dialog/form-dialog'
        });
        else if ((0, $7jTnu.fg)('legacy-its-modal-load-with-load-bridge-strict')) {
            await (0, $4T9yL.waitForHeritage)();
            FormDialog = await (0, $97BGz.loadBridgeStrict)({
                name: 'jira/dialog/form-dialog',
                wrmKeys: [
                    'wrc!jira.webresources:dialogs'
                ]
            });
        } else if ((0, $7jTnu.fg)('legacy-issue-transition-load-bridge')) {
            await (0, $ligZL.wrmRequire)([
                'wrc!jira.webresources:dialogs'
            ]);
            FormDialog = await (0, $agkbU.loadBridgeRace)({
                name: 'jira/dialog/form-dialog',
                timeout: 2000
            });
        } else FormDialog = await (0, $gjeS9.loadBridge)({
            name: 'jira/dialog/form-dialog',
            wrmKeys: 'wrc!jira.webresources:dialogs'
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const dialog = new FormDialog({
            id: 'edit-issue-dialog',
            ajaxOptions: {
                url: this.getUrl(),
                dataType: 'json'
            },
            autoClose: true,
            widthClass: 'large',
            onDialogFinished: this.onDialogSuccessCallback,
            onUnSuccessfulSubmit: this.onDialogErrorCallback,
            shouldLoadHeritageFormDialogContext: true
        });
        const cancelNativeHandler = (event)=>{
            if (!(event instanceof CustomEvent)) return;
            const dialogElement = event.detail.popup;
            const { reason: reason } = event.detail;
            if (dialogElement.is(dialog.get$popup())) {
                if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogContentReady', $48cd41f2280862c0$export$2e2bcd8739ae039.onDialogContentReady);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
        dialog.show();
    }
}

});
parcelRegister("9UaKE", function(module, exports) {

$parcel$export(module.exports, "timeToRenderTransitionModal", () => $005484b577e7eb91$export$9d20a86383e90d09);

var $hqYEY = parcelRequire("hqYEY");
const $005484b577e7eb91$export$9d20a86383e90d09 = (0, $hqYEY.metrics).interaction({
    key: 'issue.time-to.render-issue-transition-screen',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2500_4000_7000_10000'
    }
});

});


parcelRegister("lXLoB", function(module, exports) {

$parcel$export(module.exports, "startIssueTransitionMetrics", () => $a25f9b403dcc7733$export$3fc439100e136a52);

var $h6i8k = parcelRequire("h6i8k");

var $54FlQ = parcelRequire("54FlQ");

var $lwx4S = parcelRequire("lwx4S");

var $55aXL = parcelRequire("55aXL");
const $a25f9b403dcc7733$export$3fc439100e136a52 = (isSubsequentLoad)=>{
    (0, $54FlQ.IssueTransitionLoadUFOExperience).start();
    (0, $54FlQ.IssueTransitionUFOExperience).start();
    const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, $lwx4S.issueTransittionModalLoadSubsequent) : (0, $lwx4S.issueTransitionModalLoad);
    if (isSubsequentLoad) (0, $h6i8k.default)('issue-transition.transition-modal-subsequent');
    else (0, $h6i8k.default)('issue-transition.transition-modal');
    issueTransitionModalLoadMetric.start();
    (0, $55aXL.startUimTTI)();
};

});
parcelRegister("54FlQ", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionLoadUFOExperience", () => $d3b5fdfe001070e2$export$8fb308d8abecd81a);
$parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", () => $d3b5fdfe001070e2$export$bd3bf8b90a131c50);
$parcel$export(module.exports, "IssueTransitionUFOExperience", () => $d3b5fdfe001070e2$export$2f3b26e8acf79182);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $d3b5fdfe001070e2$export$8fb308d8abecd81a = new (0, $f39LL.UFOExperience)('issue-transition-screen.transition-load', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-load'
});
const $d3b5fdfe001070e2$export$bd3bf8b90a131c50 = new (0, $f39LL.UFOExperience)('issue-transition-screen.transition-submit', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-sumbit'
});
const $d3b5fdfe001070e2$export$2f3b26e8acf79182 = new (0, $f39LL.UFOExperience)('issue-transition-screen.transition-issue', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-issue'
});

});

parcelRegister("lwx4S", function(module, exports) {

$parcel$export(module.exports, "issueTransitionModalLoad", () => $df727c28db2e450a$export$772fb4a8bd181fd6);
$parcel$export(module.exports, "issueTransittionModalLoadSubsequent", () => $df727c28db2e450a$export$afa89f024c56a00a);

var $hqYEY = parcelRequire("hqYEY");
const $df727c28db2e450a$export$772fb4a8bd181fd6 = (0, $hqYEY.metrics).interaction({
    key: 'issue-transition-modal'
});
const $df727c28db2e450a$export$afa89f024c56a00a = (0, $hqYEY.metrics).interaction({
    key: 'issue-transition-modal-subsequent'
});

});

parcelRegister("55aXL", function(module, exports) {

$parcel$export(module.exports, "startUimTTI", () => $a7c7a4f87935497a$export$ae34c17d9cd2c876);
$parcel$export(module.exports, "markIssueTransitionLoaded", () => $a7c7a4f87935497a$export$7cc1bb35860c7c25);
$parcel$export(module.exports, "stopTTI", () => $a7c7a4f87935497a$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $a7c7a4f87935497a$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $a7c7a4f87935497a$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $a7c7a4f87935497a$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $a7c7a4f87935497a$export$d86f4868694f2aa7);
/**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for issue-transition, such a move causes a circular dependency with @atlassian/jira-issue-transition-trigger package,
 * since view-specific/issue-transition imports trigger points related functionality from @atlassian/jira-issue-transition-trigger.
 * Therefore, for now, let's keep it here.
 */ 
var $hqYEY = parcelRequire("hqYEY");
const $a7c7a4f87935497a$var$uimInIssueTransitionTTI = (0, $hqYEY.metrics).interaction({
    key: 'ui-modifications-in-issue-transition',
    timings: [
        {
            key: 'issue-transition-tti-delta',
            startMark: 'issue-transition-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ]
});
const $a7c7a4f87935497a$export$ae34c17d9cd2c876 = ()=>{
    $a7c7a4f87935497a$var$uimInIssueTransitionTTI.start();
};
const $a7c7a4f87935497a$export$7cc1bb35860c7c25 = ()=>$a7c7a4f87935497a$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
const $a7c7a4f87935497a$export$30ca4c461fab486c = (customData)=>{
    $a7c7a4f87935497a$var$uimInIssueTransitionTTI.stop({
        customData: customData
    });
};
const $a7c7a4f87935497a$export$27f2445288b528c = ()=>{
    $a7c7a4f87935497a$var$uimInIssueTransitionTTI.cancel();
};
const $a7c7a4f87935497a$export$7a2709fc1e33401a = ()=>{
    $a7c7a4f87935497a$var$uimInIssueTransitionTTI.mark('iframe-load');
};
const $a7c7a4f87935497a$export$cf3893335c93e33b = ()=>{
    $a7c7a4f87935497a$var$uimInIssueTransitionTTI.mark('fields-registered');
};
const $a7c7a4f87935497a$export$d86f4868694f2aa7 = ()=>{
    $a7c7a4f87935497a$var$uimInIssueTransitionTTI.mark('oninit-resolved');
};

});


parcelRegister("axEN1", function(module, exports) {

$parcel$export(module.exports, "isNewTransitionScreenEnabled", () => $7c4eced4d65dd32f$export$1f5b72e7dbe0548d);

var $lopBx = parcelRequire("lopBx");

var $7jTnu = parcelRequire("7jTnu");
const $7c4eced4d65dd32f$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
    if ((0, $lopBx.isFedRamp)()) return true;
    if (!(0, $7jTnu.fg)('render-modern-issue-transition')) return false;
    if (!triggerPointKey) return false;
    return preferNewIssueTransitionScreen || (0, $7jTnu.fg)('issue-transition-customisation-for-srb');
};

});


parcelRegister("76GoG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7592117783ba8d3f$export$2e2bcd8739ae039);
const $7592117783ba8d3f$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
        setState(stateToRestore);
    };
var $7592117783ba8d3f$export$2e2bcd8739ae039 = $7592117783ba8d3f$var$restoreState;

});

parcelRegister("edFG8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b03af3d18e6b8f33$export$2e2bcd8739ae039);
/**
 *
 * @deprecated since we should not be using this in the log run
 * we should not call this method any where and should clean this up as soon as GIC-JIS migration is done
 * @param issueId
 * @returns
 */ const $b03af3d18e6b8f33$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { fetchedIssueId: fetchedIssueId } = currentState;
        if (issueId !== fetchedIssueId) setState({
            ...currentState,
            fetchedIssueId: issueId
        });
    };
var $b03af3d18e6b8f33$export$2e2bcd8739ae039 = $b03af3d18e6b8f33$var$setFetchedIssueId;

});

parcelRegister("6EG2b", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc4da86e1baaf3f5$export$2e2bcd8739ae039);

var $2ZWxz = parcelRequire("2ZWxz");

var $lXLoB = parcelRequire("lXLoB");
const $cc4da86e1baaf3f5$var$hideBenefitsModal = (nextAction)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (nextAction === (0, $2ZWxz.OPEN_MODERN_TRANSITION_MODAL)) {
            (0, $lXLoB.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: true
            });
        } else if (nextAction === (0, $2ZWxz.OPEN_LEGACY_TRANSITION_MODAL)) {
            const { openLegacyTransitionsDialog: openLegacyTransitionsDialog } = getState();
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: false
            });
            openLegacyTransitionsDialog?.();
        }
    };
var $cc4da86e1baaf3f5$export$2e2bcd8739ae039 = $cc4da86e1baaf3f5$var$hideBenefitsModal;

});

parcelRegister("bgUfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1cb7f5be815b3c4$export$2e2bcd8739ae039);

var $12DRg = parcelRequire("12DRg");

var $23DdZ = parcelRequire("23DdZ");

var $9UaKE = parcelRequire("9UaKE");

var $2EgxC = parcelRequire("2EgxC");

var $7jTnu = parcelRequire("7jTnu");

var $lXLoB = parcelRequire("lXLoB");

var $axEN1 = parcelRequire("axEN1");
const $d1cb7f5be815b3c4$var$openIssueTransitionModalNew = ({ nextState: nextState, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen = true, issueViewAnalyticsSource: issueViewAnalyticsSource, publishTriggerToOpenTransitions: publishTriggerToOpenTransitions, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal, fireUIEvent: fireUIEvent })=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $axEN1.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                if (issueViewAnalyticsSource === 'connect-issue') {
                    publishTriggerToOpenTransitions?.(nextState, preferNewIssueTransitionScreen);
                    fireUIEvent?.({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    return;
                }
                transitionModalVersion = 'NEW';
                (0, $lXLoB.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
                return;
            }
            const currentDate = new Date();
            const showBenefitsModalOnDate = dateToShowBenefitsModal && dateToShowBenefitsModal !== 'null' ? new Date(dateToShowBenefitsModal) : new Date(-1);
            const isDateToShowBenefitsModalLessThanCurrentDate = currentDate >= showBenefitsModalOnDate;
            if (!isBenefitsModalDisabled && issueViewAnalyticsSource !== 'connect-issue' && isDateToShowBenefitsModalLessThanCurrentDate && (0, $7jTnu.fg)('render-modern-issue-transition')) {
                // add condition to show BenefitsModal
                transitionModalVersion = 'NEW';
                const callback = ()=>{
                    (0, $9UaKE.timeToRenderTransitionModal).start();
                    new (0, $23DdZ.default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).show();
                };
                setState({
                    ...currentState,
                    isBenefitsModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState,
                    openLegacyTransitionsDialog: callback
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $9UaKE.timeToRenderTransitionModal).start();
                new (0, $23DdZ.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2EgxC.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $d1cb7f5be815b3c4$export$2e2bcd8739ae039 = $d1cb7f5be815b3c4$var$openIssueTransitionModalNew;

});



parcelRegister("7SyqX", function(module, exports) {

$parcel$export(module.exports, "openLegacyIssueTransitionModal", () => $c99c1512d35cb397$export$6bfef2005bd55204);

var $12DRg = parcelRequire("12DRg");

var $23DdZ = parcelRequire("23DdZ");

var $9UaKE = parcelRequire("9UaKE");

var $2EgxC = parcelRequire("2EgxC");
const $c99c1512d35cb397$export$6bfef2005bd55204 = ({ issueKey: issueKey, transitionId: transitionId, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, isReopenScenario: isReopenScenario = false, onOpenDialog: onOpenDialog })=>{
    try {
        (0, $9UaKE.timeToRenderTransitionModal).start();
        new (0, $23DdZ.default)({
            issueKey: issueKey,
            transitionId: transitionId
        }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).show();
        onOpenDialog?.();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2EgxC.fireIssueTransitionErrorAnalytics)({
            meta: {
                id: 'transitionIssueTrigger',
                packageName: 'jiraIssueTransitionTrigger',
                teamName: 'gryffindor'
            },
            error: error,
            attributes: {
                transitionModalVersion: 'OLD',
                isReopenScenario: isReopenScenario
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});



const $bcddf6968ff42ad8$export$a415896b28cb78d7 = 'IssueTransition';

parcelRegister("iVKTW", function(module, exports) {

$parcel$export(module.exports, "asyncIssueTransitionModal", () => $dc1bd0658c98c716$export$d06e6b324c2d867a);

var $4e1YE = parcelRequire("4e1YE");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $dc1bd0658c98c716$var$resource = (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("flwOR")), {
    moduleId: "ae3ffdfd",
    priority: "interaction"
});
const $dc1bd0658c98c716$var$getPreloadProps = (variables)=>({
        queries: {
            issueTransitionInitialQueryRef: {
                parameters: (0, $4e1YE.default),
                variables: variables,
                options: {
                    fetchPolicy: 'network-only'
                }
            }
        }
    });
const $dc1bd0658c98c716$export$d06e6b324c2d867a = (0, $3Bzqe.createEntryPoint)({
    root: $dc1bd0658c98c716$var$resource,
    getPreloadProps: $dc1bd0658c98c716$var$getPreloadProps
});

});
parcelRegister("4e1YE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21cf9bf3edc3a00$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98e75ef865b9feab12077800387891f6>>
 * @relayHash c542d13d0a5bd0aa600652070fdd90f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 759f3e60085bb6145df9935769c46fb69f7228fd0e430876b2646cfb9ef1df11

var $hRj2m = parcelRequire("hRj2m");
const $d21cf9bf3edc3a00$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "759f3e60085bb6145df9935769c46fb69f7228fd0e430876b2646cfb9ef1df11",
        "metadata": {},
        "name": "IssueTransitionModalQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default)
        }
    }
};
var $d21cf9bf3edc3a00$export$2e2bcd8739ae039 = $d21cf9bf3edc3a00$var$node;

});
parcelRegister("hRj2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c7ac58a937df639$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $1c7ac58a937df639$var$isFieldsByIdRemoved = {
    get () {
        return (0, $7jTnu.fg)('dfo_remove_fields_by_id');
    }
};
var $1c7ac58a937df639$export$2e2bcd8739ae039 = $1c7ac58a937df639$var$isFieldsByIdRemoved;

});


parcelRegister("flwOR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("dtPcG")
]).then(()=>parcelRequire('XVLRB'));

});



parcelRegister("9cK0j", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fa73f06625b3ead$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $7jTnu = parcelRequire("7jTnu");

var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");

var $eSnSE = parcelRequire("eSnSE");

var $dP2lv = parcelRequire("dP2lv");

var $3WZwp = parcelRequire("3WZwp");

var $jjvHX = parcelRequire("jjvHX");

var $hfTOr = parcelRequire("hfTOr");

var $jnAFb = parcelRequire("jnAFb");

var $9m1pG = parcelRequire("9m1pG");

var $l7mJK = parcelRequire("l7mJK");

var $cdz1Y = parcelRequire("cdz1Y");

var $faIsh = parcelRequire("faIsh");
const $7fa73f06625b3ead$export$87d0ca22edb7493a = 'page-container.navigation.legacy-async-modals';
class $7fa73f06625b3ead$export$ca935a4305b90cfe extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.state = {
            ModalComponent: undefined
        };
        const createHandler = (ModalComponent, method)=>(options)=>this.showModal(// @ts-expect-error - TS2322 - Type '{ onClose: () => void; onInitiateFailed?: (() => void) | undefined; onInitiateSuccess?: (() => void) | undefined; children?: ReactNode; } | { onClose: () => void; ... 6 more ...; isProjectSimplified: boolean; } | ... 5 more ... | { ...; }' is not assignable to type 'IntrinsicAttributes & CProps & { children?: ReactNode; }'.
                (modalProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ModalComponent, {
                        ...options,
                        ...modalProps
                    }), undefined, method);
        this.api = {
            showCreateDashboardModal: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            showCopyDashboardModal: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            showEditDashboardModal: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            showEditFilterModal: createHandler((0, $9m1pG.default), 'showEditFilterModal'),
            showEditPriorityMappingModal: createHandler((0, $l7mJK.default), 'showEditPriorityMappingModal'),
            showHardDeleteProjectModal: createHandler((0, $cdz1Y.default), 'showHardDeleteProjectModal'),
            showConfigureMailServerModal: createHandler((0, $3WZwp.default), 'showConfigureMailServerModal'),
            showSoftDeleteProjectModal: createHandler((0, $faIsh.default), 'showSoftDeleteProjectModal'),
            showArchiveProjectModal: createHandler((0, $dP2lv.default), 'showArchiveProjectModal'),
            showConnectIssueModal: createHandler((0, $jjvHX.default), 'showConnectIssueModal'),
            showCustomFieldContextDeleteModal: createHandler((0, $jnAFb.default), 'showCustomFieldContextDeleteModal'),
            showCreateDashboardGadgetModal: createHandler((0, $hfTOr.default), 'showCreateDashboardGadgetModal')
        };
    }
    componentDidMount() {
        if ((0, $7jTnu.fg)('firefox_issue_view_memory_leak_v1')) // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $4T9yL.waitForHeritage)()?.then(()=>// eslint-disable-next-line jira/wrm/no-load-bridge
            (0, $97BGz.loadBridgeStrict)({
                name: 'jira/async-modals/bridge',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-atlaskit-plugin:async-modals'
                ]
            })?.then((bridge)=>bridge(this.api)).catch((e)=>{
                (0, $eSnSE.default).safeErrorWithoutCustomerData($7fa73f06625b3ead$export$87d0ca22edb7493a, 'Cannot load the bridge', e);
            }));
        else // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $iyT45.loadBridgeWeak)({
            name: 'jira/async-modals/bridge'
        })// @ts-expect-error - TS2571 - Object is of type 'unknown'.
        .then((bridge)=>bridge(this.api)).catch((e)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData($7fa73f06625b3ead$export$87d0ca22edb7493a, 'Cannot load the bridge', e);
        });
    }
    showModal(ModalComponent, mountingPromise, method) {
        (0, $eSnSE.default).safeInfoWithoutCustomerData($7fa73f06625b3ead$export$87d0ca22edb7493a, 'showModal', {
            method: method
        });
        if (this.state.ModalComponent) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData($7fa73f06625b3ead$export$87d0ca22edb7493a, 'Tried to show the modal while another one is open');
            return undefined;
        }
        if (ModalComponent) {
            this.setState({
                ModalComponent: ModalComponent
            });
            return {
                close: ()=>this.closeModal(ModalComponent),
                mountingPromise: mountingPromise
            };
        }
        (0, $eSnSE.default).safeErrorWithoutCustomerData($7fa73f06625b3ead$export$87d0ca22edb7493a, 'Tried to show the modal which does not exist');
        return undefined;
    }
    closeModal(ModalComponent) {
        if (this.state.ModalComponent === ModalComponent) this.setState({
            ModalComponent: undefined
        });
        else (0, $eSnSE.default).safeErrorWithoutCustomerData($7fa73f06625b3ead$export$87d0ca22edb7493a, 'Tried to close the modal which is not open');
    }
    render() {
        const { ModalComponent: ModalComponent } = this.state;
        if (!ModalComponent) return null;
        const onClose = ()=>this.closeModal(ModalComponent);
        // @ts-expect-error - TS2604 - JSX element type 'ModalComponent' does not have any construct or call signatures.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ModalComponent, {
            onClose: onClose
        });
    }
}
var $7fa73f06625b3ead$export$2e2bcd8739ae039 = $7fa73f06625b3ead$export$ca935a4305b90cfe;

});
parcelRegister("dP2lv", function(module, exports) {

$parcel$export(module.exports, "default", () => $759eb24b082e82eb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4xbv3 = parcelRequire("4xbv3");

var $HPlG4 = parcelRequire("HPlG4");

var $gZTP9 = parcelRequire("gZTP9");
const $759eb24b082e82eb$var$ArchiveProject = ({ onClose: onClose, projectName: projectName, projectId: projectId, projectType: projectType })=>{
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const onArchiveSuccess = ()=>{
        if (isAdmin) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace('/jira/settings/projects/manage');
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace('/jira/projects');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "EditProjectDetails",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $HPlG4.default), {
        isProjectSimplified: false,
        onClose: onClose,
        projectName: projectName,
        projectId: projectId,
        projectType: projectType,
        onArchiveSuccess: onArchiveSuccess,
        onArchiveSuccessFlagRestore: undefined
    }));
};
var $759eb24b082e82eb$export$2e2bcd8739ae039 = $759eb24b082e82eb$var$ArchiveProject;

});
// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("HPlG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $884546ce789fe100$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $884546ce789fe100$var$LazyComponent = (0, $bQWwW.lazy)(()=>(parcelRequire("aBh8t")), {
    moduleId: "./src/packages/project-pages/project-archive/project-archive-modal/src/index.tsx"
});
const $884546ce789fe100$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "bundle-async-project-archive-modal",
        packageName: "jira-project-archive-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "project-archive-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
            metricKey: (0, $d2876069a1c8b313$export$37312a67c3e314c6)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($884546ce789fe100$var$LazyComponent, props)));
var $884546ce789fe100$export$2e2bcd8739ae039 = $884546ce789fe100$var$Component;

});
const $d2876069a1c8b313$export$37312a67c3e314c6 = 'PROJECT_ARCHIVE_MODAL_LOAD_START_MARK_KEY';

parcelRegister("aBh8t", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("2ttoy")
]).then(()=>parcelRequire('1Ve5d'));

});



parcelRegister("3WZwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $afadc4aafd802975$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9nw3n = parcelRequire("9nw3n");
const $afadc4aafd802975$var$ConfigureMailServerModal = (props)=>{
    const { onClose: onClose, action: action, id: id, name: name, authenticationType: authenticationType } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9nw3n.default), {
        onClose: onClose,
        action: action,
        id: id,
        name: name,
        authenticationType: authenticationType
    });
};
var $afadc4aafd802975$export$2e2bcd8739ae039 = $afadc4aafd802975$var$ConfigureMailServerModal;

});
parcelRegister("9nw3n", function(module, exports) {

$parcel$export(module.exports, "default", () => $20f0bc662d171962$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $hFyIE = parcelRequire("hFyIE");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $20f0bc662d171962$var$AsyncLazyConfigureMailServerModal = (0, $bQWwW.lazy)(()=>(parcelRequire("5vYP3")), {
    moduleId: "./src/packages/admin-pages/configure-mail-server-modal/src/ui/index.tsx"
});
const $20f0bc662d171962$var$AsyncConfigureMailServerModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "configure-mail-server-modal",
        packageName: "jira-configure-mail-server-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "configure-mail-service-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
            metricKey: (0, $hFyIE.LOAD_START_MARK_KEY)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($20f0bc662d171962$var$AsyncLazyConfigureMailServerModal, props)));
var $20f0bc662d171962$export$2e2bcd8739ae039 = $20f0bc662d171962$var$AsyncConfigureMailServerModal;

});
parcelRegister("hFyIE", function(module, exports) {

$parcel$export(module.exports, "LOAD_START_MARK_KEY", () => $ab5f094ded3b3ed0$export$37312a67c3e314c6);
$parcel$export(module.exports, "OAUTH__UPDATE_SERVER_MODAL_ERROR_FLAG", () => $ab5f094ded3b3ed0$export$a792a4590d58b241);
$parcel$export(module.exports, "OAUTH_SAVE_AND_REAUTHORIZE_SERVER_MODAL_SUCCESS_FLAG", () => $ab5f094ded3b3ed0$export$5eac226c393e310c);
$parcel$export(module.exports, "OAUTH__SAVE_AND_REAUTHORIZE_SERVER_MODAL_ERROR_FLAG", () => $ab5f094ded3b3ed0$export$94d27d38e0820c0b);
$parcel$export(module.exports, "CUSTOM_SERVER_MODAL_SUCCESS_FLAG", () => $ab5f094ded3b3ed0$export$53e713d2a98cd747);
$parcel$export(module.exports, "CUSTOM_SERVER_MODAL_ERROR_FLAG", () => $ab5f094ded3b3ed0$export$a01d1307b4719d5f);
$parcel$export(module.exports, "ADD_MAIL_SERVER_MODAL", () => $ab5f094ded3b3ed0$export$3ca722c2d79959e0);
$parcel$export(module.exports, "EDIT_CUSTOM_MAIL_SERVER_MODAL", () => $ab5f094ded3b3ed0$export$7a0bad9b8f7f5f49);
$parcel$export(module.exports, "EDIT_OAUTH_MAIL_SERVER_MODAL", () => $ab5f094ded3b3ed0$export$76d6a02740ddbf15);
$parcel$export(module.exports, "ADD_CUSTOM_MAIL_SERVER_MODAL", () => $ab5f094ded3b3ed0$export$be66491207659cf9);
$parcel$export(module.exports, "DELETE_MAIL_SERVER_MODAL", () => $ab5f094ded3b3ed0$export$d3334283d631bf5e);
$parcel$export(module.exports, "SAVE_AND_REAUTHORIZE_MAIL_SERVER_MODAL", () => $ab5f094ded3b3ed0$export$2ff390148e621d72);
$parcel$export(module.exports, "BASIC_DETAILS_MAIL_SERVER_CANCEL_BTN", () => $ab5f094ded3b3ed0$export$43eff1520f004691);
$parcel$export(module.exports, "SAVE_AND_REAUTHORIZE_MAIL_SERVER_SUBMIT_BTN", () => $ab5f094ded3b3ed0$export$e7833cf4fbffefad);
$parcel$export(module.exports, "SAVE_AND_REAUTHORIZE_MAIL_SERVER_CANCEL_BTN", () => $ab5f094ded3b3ed0$export$2834c8c25257c0a);
$parcel$export(module.exports, "DELETE_SERVER_SUBMIT_BTN", () => $ab5f094ded3b3ed0$export$ee89d62be837cb5c);
$parcel$export(module.exports, "DELETE_SERVER_CANCEL_BTN", () => $ab5f094ded3b3ed0$export$9cf43e929a820b51);
$parcel$export(module.exports, "CUSTOM_DETAILS_MAIL_SERVER_SAVE_BTN", () => $ab5f094ded3b3ed0$export$a4061de68765281e);
$parcel$export(module.exports, "CUSTOM_DETAILS_MAIL_SERVER_CANCEL_BTN", () => $ab5f094ded3b3ed0$export$469099411a8b9fdd);
$parcel$export(module.exports, "GMAIL_SERVICE_KEY", () => $ab5f094ded3b3ed0$export$9d7fb5252c105003);
$parcel$export(module.exports, "MICROSOFT_SERVICE_KEY", () => $ab5f094ded3b3ed0$export$55b35aa2fcc524dc);
$parcel$export(module.exports, "getOAuth3LOProvider", () => $ab5f094ded3b3ed0$export$9624c6d13bd08f09);

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");
const $ab5f094ded3b3ed0$export$37312a67c3e314c6 = 'PROJECT_CONFIGURE_MAIL_SERVER_MODAL_LOAD_START_MARK_KEY';
const $ab5f094ded3b3ed0$export$1af8dc0354a1479f = 'configure-mailserver-modal.ui.delete-mailserver-modal.flags.delete-success';
const $ab5f094ded3b3ed0$export$ac16863eedc66f9f = 'configure-mailserver-modal.ui.delete-mailserver-modal.flags.delete-failure';
const $ab5f094ded3b3ed0$export$a792a4590d58b241 = 'configure-mailserver-modal.ui.update-oauth-mailserver-modal.flags.create-failure';
const $ab5f094ded3b3ed0$export$5eac226c393e310c = 'configure-mailserver-modal.ui.update-oauth-save-and-reauthorize-mailserver-modal.flags.create-success';
const $ab5f094ded3b3ed0$export$94d27d38e0820c0b = 'configure-mailserver-modal.ui.update-oauth-save-and-reauthorize-mailserver-modal.flags.create-failure';
const $ab5f094ded3b3ed0$export$53e713d2a98cd747 = 'configure-mailserver-modal.ui.basic-mailserver-modal.flags.create-success';
const $ab5f094ded3b3ed0$export$a01d1307b4719d5f = 'configure-mailserver-modal.ui.basic-mailserver-modal.flags.create-failure';
const $ab5f094ded3b3ed0$export$22ea0ea53d2d0fa4 = 'configure-mail-server-modal.custom-mailserver-modal.inline-error';
const $ab5f094ded3b3ed0$export$3ca722c2d79959e0 = 'addMailServer';
const $ab5f094ded3b3ed0$export$7a0bad9b8f7f5f49 = 'editCustomMailServer';
const $ab5f094ded3b3ed0$export$76d6a02740ddbf15 = 'editOAUTHMailServer';
const $ab5f094ded3b3ed0$export$be66491207659cf9 = 'addCustomMailServer';
const $ab5f094ded3b3ed0$export$d3334283d631bf5e = 'deleteMailServer';
const $ab5f094ded3b3ed0$export$2ff390148e621d72 = 'saveChanges';
const $ab5f094ded3b3ed0$export$43eff1520f004691 = 'cancelSaveMailServerButton';
const $ab5f094ded3b3ed0$export$e7833cf4fbffefad = 'saveMailServerButton';
const $ab5f094ded3b3ed0$export$2834c8c25257c0a = 'cancelSaveMailServerButton';
const $ab5f094ded3b3ed0$export$ee89d62be837cb5c = 'confirmDeleteMailServerButton';
const $ab5f094ded3b3ed0$export$9cf43e929a820b51 = 'cancelDeleteMailServerButton';
const $ab5f094ded3b3ed0$export$a4061de68765281e = 'saveCustomMailServerButton';
const $ab5f094ded3b3ed0$export$469099411a8b9fdd = 'cancelSaveCustomMailServerButton';
const $ab5f094ded3b3ed0$export$9d7fb5252c105003 = 'jira-email-service-gmail';
const $ab5f094ded3b3ed0$export$55b35aa2fcc524dc = 'jira-email-service-microsoft';
const $ab5f094ded3b3ed0$export$9624c6d13bd08f09 = ()=>{
    if ((0, $lopBx.isFedRamp)()) return {
        [$ab5f094ded3b3ed0$export$55b35aa2fcc524dc]: {
            prod: {
                containerId: 'f09c06db-0957-4ede-8d6d-daceccc22995',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'prod',
                    'fedramp-moderate'
                ])}/outboundAuth/v2/start`
            },
            staging: {
                containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'stg',
                    'fedramp-moderate'
                ])}/outboundAuth/v2/start`
            },
            dev: {
                containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'stg',
                    'fedramp-moderate'
                ])}/outboundAuth/v2/start`
            },
            local: {
                containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'dev',
                    'fedramp-moderate'
                ])}/outboundAuth/v2/start`
            }
        },
        [$ab5f094ded3b3ed0$export$9d7fb5252c105003]: {
            prod: {
                containerId: 'f09c06db-0957-4ede-8d6d-daceccc22995',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'prod',
                    'fedramp-moderate'
                ])}/outboundAuth/v2/start`
            },
            staging: {
                containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'stg',
                    'fedramp-moderate'
                ])}/outboundAuth/v2/start`
            },
            dev: {
                containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'stg',
                    'fedramp-moderate'
                ])}/outboundAuth/v2/start`
            },
            local: {
                containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'dev',
                    'fedramp-moderate'
                ])}/outboundAuth/v2/start`
            }
        }
    };
    return {
        [$ab5f094ded3b3ed0$export$55b35aa2fcc524dc]: {
            prod: {
                containerId: '4236689d-d21d-4741-ab4f-71892b2d55f9',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id')}/outboundAuth/v2/start`
            },
            staging: {
                containerId: 'e1b53a56-0a21-419e-a258-ee1d435ea0b8',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'stg',
                    'commercial'
                ])}/outboundAuth/v2/start`
            },
            dev: {
                containerId: 'e1b53a56-0a21-419e-a258-ee1d435ea0b8',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'stg',
                    'commercial'
                ])}/outboundAuth/v2/start`
            },
            local: {
                containerId: 'e1b53a56-0a21-419e-a258-ee1d435ea0b8',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'dev',
                    'commercial'
                ])}/outboundAuth/v2/start`
            }
        },
        [$ab5f094ded3b3ed0$export$9d7fb5252c105003]: {
            prod: {
                containerId: 'c16a389e-0776-44b3-9528-19c82119a022',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id')}/outboundAuth/v2/start`
            },
            staging: {
                containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'stg',
                    'commercial'
                ])}/outboundAuth/v2/start`
            },
            dev: {
                containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'stg',
                    'commercial'
                ])}/outboundAuth/v2/start`
            },
            local: {
                containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
                threeLOUrl: `https://${(0, $8RHPx.getATLContextDomain)('id', [
                    'dev',
                    'commercial'
                ])}/outboundAuth/v2/start`
            }
        }
    };
};

});

parcelRegister("5vYP3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fTsqw").then(()=>parcelRequire('590pm'));

});



parcelRegister("jjvHX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5edcbdb24bfef8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $c6Pkl = parcelRequire("c6Pkl");

var $6thF2 = parcelRequire("6thF2");
const $6d5edcbdb24bfef8$var$ConnectIssueModal = ({ issueKey: issueKey, onClose: onClose, onCancel: onCancel, onError: onError })=>{
    const onCloseCallback = (0, $eJOHy.useCallback)((props)=>{
        onClose();
        // onCancel might not be defined
        // onCancel might throw an error
        onCancel?.(props);
    }, [
        onCancel,
        onClose
    ]);
    (0, $6thF2.useNavigationEffect)(()=>{
        // execute in timeout in order to not let error from onCancel trigger ErrorBoundary
        setTimeout(()=>onCloseCallback(issueKey));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c6Pkl.AsyncConnectModal), {
        issueKey: issueKey,
        onClose: onCloseCallback,
        onError: onError
    });
};
var $6d5edcbdb24bfef8$export$2e2bcd8739ae039 = $6d5edcbdb24bfef8$var$ConnectIssueModal;

});
parcelRegister("c6Pkl", function(module, exports) {

$parcel$export(module.exports, "AsyncConnectModal", () => $d1505eae40ca7eca$export$114a56bd5931fa2a);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d1505eae40ca7eca$var$ConnectModal = (0, $bQWwW.lazy)(()=>(parcelRequire("54GAq")).then(({ ConnectIssueModal: ConnectIssueModal })=>ConnectIssueModal), {
    moduleId: "./src/packages/issue/connect-modal/src/index.tsx"
});
const $d1505eae40ca7eca$export$114a56bd5931fa2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "connect-issue-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d1505eae40ca7eca$var$ConnectModal, props));

});
parcelRegister("54GAq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");




module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("gVlCg"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("c687B"),
            $ewTvA("kNFvF")
        ]);
    }),
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $ewTvA("lw2Bw")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2lCLc")
        ]);
    }),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("a2yB0")
]).then(()=>parcelRequire('1LurC'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            console.error('Conditional dependency was not registered when executing. Falling back to synchronous bundle loading.');
            for (const url of fallback.urls)fallback.loader(url);
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});



parcelRegister("6thF2", function(module, exports) {

$parcel$export(module.exports, "useNavigationEffect", () => $2780f3080155a119$export$619befab0baf5dd8);

var $eJOHy = parcelRequire("eJOHy");

var $6d9QY = parcelRequire("6d9QY");

var $kfvK2 = parcelRequire("kfvK2");
const $2780f3080155a119$var$useRouteLocation = (0, $kfvK2.createRouterSelector)(// there are two possible options to use
// `pathname+search` or just `key`
// not using key as it will be updated on hash updates
// subject to change
({ location: location })=>`${location.pathname}?${location.search}`);
const $2780f3080155a119$export$619befab0baf5dd8 = (callback)=>{
    const locationKey = $2780f3080155a119$var$useRouteLocation();
    const callbackRef = (0, $eJOHy.useRef)(callback);
    callbackRef.current = callback;
    const previousLocationKey = (0, $6d9QY.usePreviousWithInitial)(locationKey);
    // possible improvement: capture and rethrow error in timeout
    // this is not "synchronization" - this is "reaction" similar to "onClick" because it reacts to "onClick" made in different place
    // error throw from useEffect will trigger ErrorBoundary, but error from onClick will not
    // we might need to synchronize their behaviors aka "useSafeEffect" or "useEventEffect"
    (0, $eJOHy.useEffect)(()=>{
        if (previousLocationKey !== locationKey) callbackRef.current();
    }, [
        previousLocationKey,
        locationKey
    ]);
};

});


parcelRegister("hfTOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd1e0b61cedd4176$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2JpxI = parcelRequire("2JpxI");

var $83DiZ = parcelRequire("83DiZ");
const $fd1e0b61cedd4176$var$CreateDashboardGadgetModal = ({ onClose: onClose, onInitiateFailed: __, onInitiateSuccess: ___, ...filterIdOrJql })=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const onSuccess = (dashboardId)=>{
        onClose();
        push(`/jira/dashboards/${dashboardId}/edit`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2JpxI.default), {
        onSuccess: onSuccess,
        onCancel: onClose,
        ...filterIdOrJql
    });
};
var $fd1e0b61cedd4176$export$2e2bcd8739ae039 = $fd1e0b61cedd4176$var$CreateDashboardGadgetModal;

});
parcelRegister("2JpxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe47cbd38805bd1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5Lo0w = parcelRequire("5Lo0w");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// We can't migrate this modal to entrypoints yet because entrypoints currently do not support rendering modals
// in legacy pages
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $bfe47cbd38805bd1$var$LazyCreateDashboardGadgetModal = (0, $bQWwW.lazy)(()=>(parcelRequire("35eD0")), {
    moduleId: "./src/packages/global-pages/dashboard/create-dashboard-gadget-modal/src/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bfe47cbd38805bd1$export$2e2bcd8739ae039 = ({ onFailed: onFailed = ()=>undefined, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "AsyncCreateDashboardGadgetModal",
        packageName: "jiraDashboardCreateDashboardGadgetModal",
        fallback: "flag",
        onError: onFailed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-create-dashboard-gadget-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Lo0w.default), {
            isTinted: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bfe47cbd38805bd1$var$LazyCreateDashboardGadgetModal, props)));

});
parcelRegister("35eD0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("0X1i0")
]).then(()=>parcelRequire('f6GYX'));

});



parcelRegister("jnAFb", function(module, exports) {

$parcel$export(module.exports, "default", () => $94f5ff347d3f403b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $5HOMW = parcelRequire("5HOMW");

var $4xbv3 = parcelRequire("4xbv3");
const $94f5ff347d3f403b$var$AsyncCustomFieldContextDelete = ({ onClose: onClose, customFieldId: customFieldId, fieldConfigSchemeId: fieldConfigSchemeId, ContextualAnalyticsData: // @ts-expect-error - TS2339 - Property 'ContextualAnalyticsData' does not exist on type 'Props'.
ContextualAnalyticsData = (0, $4xbv3.ContextualAnalyticsData), AsyncCustomFieldContextDeleteModal: // @ts-expect-error - TS2339 - Property 'AsyncCustomFieldContextDeleteModal' does not exist on type 'Props'.
AsyncCustomFieldContextDeleteModal = (0, $5HOMW.default) })=>{
    const onContextDeleteSuccess = ()=>{
        onClose();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContextualAnalyticsData, {
        sourceName: "CustomFieldContextDetails",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AsyncCustomFieldContextDeleteModal, {
        customFieldId: customFieldId,
        fieldConfigSchemeId: fieldConfigSchemeId,
        onDeleteSuccess: onContextDeleteSuccess,
        onDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onClose: onClose
    }));
};
var $94f5ff347d3f403b$export$2e2bcd8739ae039 = $94f5ff347d3f403b$var$AsyncCustomFieldContextDelete;

});
parcelRegister("5HOMW", function(module, exports) {

$parcel$export(module.exports, "default", () => $99a3da9f32ba042f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $1KdDN = parcelRequire("1KdDN");

var $1qbKn = parcelRequire("1qbKn");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");
const $99a3da9f32ba042f$var$LOAD_START_MARK_KEY = 'CUSTOM_FIELD_CONTEXT_DELETE_MODAL_LOAD_START_MARK_KEY';
const $99a3da9f32ba042f$var$ErrorComponent = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
        id: "bundle-async-admin-pages-custom-field-context-delete-modal",
        error: error
    });

const $99a3da9f32ba042f$var$preloadComponent = ()=>(parcelRequire("8zE8d"));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $99a3da9f32ba042f$var$LazyFieldContextDeleteModal = (0, $bQWwW.lazy)(()=>$99a3da9f32ba042f$var$preloadComponent(), {});
function $99a3da9f32ba042f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "asyncFieldContextDeleteModal",
        packageName: "jiraCustomFieldContextDeleteModal",
        teamName: "morphinecake",
        fallback: $99a3da9f32ba042f$var$ErrorComponent,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "field-context-delete-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
            metricKey: $99a3da9f32ba042f$var$LOAD_START_MARK_KEY
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a3da9f32ba042f$var$LazyFieldContextDeleteModal, props)));
}

});
parcelRegister("8zE8d", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9VBqA").then(()=>parcelRequire('fRfA1'));

});



parcelRegister("9m1pG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2111c80174f55e84$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $cvqdw = parcelRequire("cvqdw");
const $2111c80174f55e84$var$EditFilter = ({ sharePermissions: sharePermissions, editPermissions: editPermissions, id: id, name: name, description: description, onClose: onClose })=>{
    const onSuccess = ()=>{
        onClose();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cvqdw.default), {
        id: id,
        sharePermissions: sharePermissions,
        editPermissions: editPermissions,
        name: name,
        description: description,
        onInitiateSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onCancel: onClose,
        onEdited: onSuccess
    });
};
var $2111c80174f55e84$export$2e2bcd8739ae039 = $2111c80174f55e84$var$EditFilter;

});
parcelRegister("cvqdw", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ffacddba20b0a0$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

const $45ffacddba20b0a0$var$RLLAsyncEditFilterModal = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("RXjEE")), {
    moduleId: "./src/packages/global-pages/directories/filters-directory-v2/edit-filters-modal/src/index.tsx"
});
const $45ffacddba20b0a0$var$RLLAsyncEditFilterModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "edit-filter-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($45ffacddba20b0a0$var$RLLAsyncEditFilterModal, props));
var $45ffacddba20b0a0$export$2e2bcd8739ae039 = $45ffacddba20b0a0$var$RLLAsyncEditFilterModalContainer;

});
parcelRegister("RXjEE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("lbKRa")
]).then(()=>parcelRequire('ecsqp'));

});



parcelRegister("l7mJK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5dcd6a234232c3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $doG3P = parcelRequire("doG3P");
const $bf5dcd6a234232c3$var$EditPriorityMapping = ({ cloudId: cloudId, onClose: onClose, priorities: priorities, defaultPriorityId: defaultPriorityId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $doG3P.AsyncEditPriorityMappingModal), {
        cloudId: cloudId,
        onClose: onClose,
        jiraPriorities: priorities,
        defaultJiraPriorityId: defaultPriorityId
    });
var $bf5dcd6a234232c3$export$2e2bcd8739ae039 = $bf5dcd6a234232c3$var$EditPriorityMapping;

});
parcelRegister("doG3P", function(module, exports) {

$parcel$export(module.exports, "AsyncEditPriorityMappingModal", () => $846e3d0d888f102d$export$209a6ab110d0e343);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

const $846e3d0d888f102d$var$EditPriorityMappingModal = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("gdW3M")).then((module)=>module.EditPriorityMappingModalApp), {
    moduleId: "./src/packages/servicedesk/incident-management/edit-priority-mapping-modal/src/main.tsx"
});
const $846e3d0d888f102d$export$209a6ab110d0e343 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "edit-priority-mapping-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($846e3d0d888f102d$var$EditPriorityMappingModal, props));

});
parcelRegister("gdW3M", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("6QUaR")
]).then(()=>parcelRequire('fCymx'));

});



parcelRegister("cdz1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $c89a7277eb87c341$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $4xbv3 = parcelRequire("4xbv3");

var $aNDl0 = parcelRequire("aNDl0");
const $c89a7277eb87c341$var$AsyncHardDeleteProject = ({ onClose: onClose, projectName: projectName, projectId: projectId, projectType: projectType, isProjectSimplified: isProjectSimplified, ContextualAnalyticsData: // @ts-expect-error - TS2339 - Property 'ContextualAnalyticsData' does not exist on type 'Props'.
ContextualAnalyticsData = (0, $4xbv3.ContextualAnalyticsData), AsyncHardDeleteProjectModal: // @ts-expect-error - TS2339 - Property 'AsyncHardDeleteProjectModal' does not exist on type 'Props'.
AsyncHardDeleteProjectModal = (0, $aNDl0.default) })=>{
    const onProjectActionSuccess = ()=>{
        onClose();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace('/jira/your-work');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContextualAnalyticsData, {
        sourceName: "EditProjectDetails",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AsyncHardDeleteProjectModal, {
        onClose: onClose,
        projectName: projectName,
        projectType: projectType,
        projectId: projectId,
        isProjectSimplified: isProjectSimplified,
        onProjectDeleteSuccess: onProjectActionSuccess,
        onProjectDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }));
};
var $c89a7277eb87c341$export$2e2bcd8739ae039 = $c89a7277eb87c341$var$AsyncHardDeleteProject;

});
parcelRegister("aNDl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $518f5d3d55645fe4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $518f5d3d55645fe4$var$LazyComponent = (0, $bQWwW.lazy)(()=>(parcelRequire("1az3d")), {
    moduleId: "./src/packages/project-pages/project-restore/project-permanent-delete-modal/src/index.tsx"
});
const $518f5d3d55645fe4$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "bundle-async-project-permanent-delete-modal",
        packageName: "jira-project-permanent-delete-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "project-permanent-delete-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
            metricKey: (0, $df381accc06d4a4a$export$37312a67c3e314c6)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($518f5d3d55645fe4$var$LazyComponent, props)));
var $518f5d3d55645fe4$export$2e2bcd8739ae039 = $518f5d3d55645fe4$var$Component;

});
const $df381accc06d4a4a$export$37312a67c3e314c6 = 'PROJECT_PERMANENT_DELETE_MODAL_LOAD_START_MARK_KEY';

parcelRegister("1az3d", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("2PEaw")
]).then(()=>parcelRequire('csYqk'));

});



parcelRegister("faIsh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3407a370e50e18a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $4xbv3 = parcelRequire("4xbv3");

var $bLTqr = parcelRequire("bLTqr");

var $gZTP9 = parcelRequire("gZTP9");
const $e3407a370e50e18a$var$AsyncSoftDeleteProject = ({ onClose: onClose, projectName: projectName, projectId: projectId, projectType: projectType, isProjectSimplified: isProjectSimplified })=>{
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const onDeleteProjectSuccess = ()=>{
        onClose();
        if (isAdmin) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace('/jira/settings/projects/manage');
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace('/jira/projects');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "EditProjectDetails",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bLTqr.default), {
        onClose: onClose,
        projectName: projectName,
        projectType: projectType,
        projectId: projectId,
        isProjectSimplified: isProjectSimplified,
        onDeleteProjectSuccess: onDeleteProjectSuccess,
        onDeleteProjectFailure: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onDeleteSuccessFlagRestore: undefined
    }));
};
var $e3407a370e50e18a$export$2e2bcd8739ae039 = $e3407a370e50e18a$var$AsyncSoftDeleteProject;

});
parcelRegister("bLTqr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3324d7546788ce6b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3324d7546788ce6b$var$LazyComponent = (0, $bQWwW.lazy)(()=>(parcelRequire("bkcL1")), {
    moduleId: "./src/packages/project-pages/project-restore/project-soft-delete-modal/src/index.tsx"
});
const $3324d7546788ce6b$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "bundle-async-project-soft-delete-modal-errors",
        packageName: "jira-project-soft-delete-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "project-soft-delete-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
            metricKey: (0, $2e2d7a6c4b211bdc$export$37312a67c3e314c6)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3324d7546788ce6b$var$LazyComponent, props)));
var $3324d7546788ce6b$export$2e2bcd8739ae039 = $3324d7546788ce6b$var$Component;

});
const $2e2d7a6c4b211bdc$export$37312a67c3e314c6 = 'PROJECT_SOFT_DELETE_MODAL_LOAD_START_MARK_KEY';

parcelRegister("bkcL1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("e7Tzy")
]).then(()=>parcelRequire('fWI8A'));

});




parcelRegister("i9s9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ddfbfc57334d8a3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6K9yc = parcelRequire("6K9yc");
var $avQYn = parcelRequire("avQYn");
var $dSmxJ = parcelRequire("dSmxJ");
var $i59Yb = parcelRequire("i59Yb");

var $6J9k6 = parcelRequire("6J9k6");

var $aewX5 = parcelRequire("aewX5");
var $1DXK0 = parcelRequire("1DXK0");

var $5kYyR = parcelRequire("5kYyR");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $ch9En = parcelRequire("ch9En");

var $3xNM4 = parcelRequire("3xNM4");

var $bQWwW = parcelRequire("bQWwW");

var $bJscI = parcelRequire("bJscI");


var $6c6vC = parcelRequire("6c6vC");

var $1NIDh = parcelRequire("1NIDh");

var $7cIYo = parcelRequire("7cIYo");

const $9ddfbfc57334d8a3$export$3039dc74ce32c9c8 = (0, $bQWwW.lazy)(()=>{
    (0, $3xNM4.monitor).startTask((0, $12e40ee10589c2f2$export$9a977208af30ffae));
    return (parcelRequire("7eH8v")).then((module)=>module.default);
}, {
    ssr: false,
    moduleId: "./src/packages/portfolio-3/create-new-plan-wizard-drawer/src/ui/content/index.tsx"
});
const $9ddfbfc57334d8a3$var$AsyncPlanWizardWrapped = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderNew), {
        name: "async-plan-create-wizard",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9ddfbfc57334d8a3$export$3039dc74ce32c9c8, props));
const $9ddfbfc57334d8a3$var$CreateNewPlanWizardDrawer = ({ PlanWizard: PlanWizard = (0, $7jTnu.fg)('concurrent-rendering-fix-plan-create-drawer') ? $9ddfbfc57334d8a3$var$AsyncPlanWizardWrapped : $9ddfbfc57334d8a3$export$3039dc74ce32c9c8 })=>{
    const [{ isOpen: isOpen, plan: plan }, { closeDrawer: closeDrawer }] = (0, $6c6vC.useCreateNewPlanWizardDrawer)();
    const keepMounted = (0, $eJOHy.useRef)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (!keepMounted.current && !isOpen) return null;
    // Keep mounted to Drawer close animation works
    if (!keepMounted.current) keepMounted.current = true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleRequestClose = (e)=>{
        if (e.key === 'Escape') return;
        closeDrawer();
    };
    // Wrapping the AsyncPlanWizard component directly in Placeholder results the Drawer
    // flickering when it is opened immediately after the /plans page loads - either through
    // the create-plan=true query param, or by quickly clicking the top RHS Create plan
    // button. Wrapping the parent Drawer in Placeholder resolves this issue.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "create-new-plan-wizard",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K9yc.Drawer), {
        isOpen: isOpen,
        width: "full",
        onClose: handleRequestClose,
        label: formatMessage((0, $1NIDh.default).dialogLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i59Yb.DrawerSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $avQYn.DrawerCloseButton), {
        icon: (iconsProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
                ...iconsProps,
                LEGACY_size: "medium"
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dSmxJ.DrawerContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aewX5.default), {
        xcss: $9ddfbfc57334d8a3$var$containerStylesCentred,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: (0, $12e40ee10589c2f2$export$b8b9d90f9e5bd72b),
        packageName: (0, $12e40ee10589c2f2$export$b8b9d90f9e5bd72b),
        teamName: (0, $12e40ee10589c2f2$export$cfeee2ee86ead336),
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PlanWizard, {
        plan: plan
    }))))));
};
var $9ddfbfc57334d8a3$export$2e2bcd8739ae039 = (0, $bJscI.componentWithFG)('finish_jira-portfolio-3-plan-wizard_migration', $9ddfbfc57334d8a3$var$CreateNewPlanWizardDrawer, (0, $7cIYo.CreateNewPlanWizardDrawerOld));
const $9ddfbfc57334d8a3$var$containerStylesCentred = (0, $1DXK0.xcss)({
    minHeight: '100%',
    paddingTop: 'space.300',
    paddingBottom: 'space.300'
});

});
parcelRegister("3xNM4", function(module, exports) {

$parcel$export(module.exports, "SPA_APP_NAME", () => $c06cc877a4cec7c4$export$3121747bb6e73d1c);
$parcel$export(module.exports, "TTI_SLO", () => $c06cc877a4cec7c4$export$748427380a6493b0);
$parcel$export(module.exports, "ARJ_EARLY_PRELOAD_PREFIX", () => $c06cc877a4cec7c4$export$1b60784a15ad91a9);
$parcel$export(module.exports, "monitor", () => $c06cc877a4cec7c4$export$ec5b303098bc4b7f);

var $2gvG4 = parcelRequire("2gvG4");

var $6whQo = parcelRequire("6whQo");

var $2QO3b = parcelRequire("2QO3b");

var $k04JP = parcelRequire("k04JP");
var $hqYEY = parcelRequire("hqYEY");

var $akiS9 = parcelRequire("akiS9");

var $dydef = parcelRequire("dydef");

var $jbpoj = parcelRequire("jbpoj");
const $c06cc877a4cec7c4$export$3121747bb6e73d1c = 'advanced-roadmaps';
const $c06cc877a4cec7c4$export$748427380a6493b0 = 4000;
const $c06cc877a4cec7c4$export$2a97570d48bcd64d = 1000;
const $c06cc877a4cec7c4$export$1b60784a15ad91a9 = 'jira.fe-spa.advanced-roadmaps.early-preload';
const $c06cc877a4cec7c4$var$INTERACTION_PREFIX = $c06cc877a4cec7c4$export$3121747bb6e73d1c;
const $c06cc877a4cec7c4$var$ARJ_EARLY_PRELOAD = 'arj-early-preload';
const $c06cc877a4cec7c4$var$PRODUCT_PREFIX = 'jira.fe-spa.advanced-roadmaps.product';
const $c06cc877a4cec7c4$var$taskKeyToInteractionKey = (taskKey)=>`${$c06cc877a4cec7c4$var$INTERACTION_PREFIX}.${taskKey.toLowerCase()}`;
const $c06cc877a4cec7c4$export$4726438eb4db5074 = '__initial_render__';
const $c06cc877a4cec7c4$var$MAX_ENTRIES_PER_MARK = 5;
class $c06cc877a4cec7c4$export$3de16b9a4e4a99f4 {
    constructor(options){
        this.featureFlags = [];
        this.profiles = new Map();
        this.timings = [];
        this.tasks = new Map();
        this.contextualAnalyticsData = {
            planId: '',
            scenarioId: ''
        };
        this.browserMetrics = (options || {}).browserMetrics || (0, $k04JP.browserMetrics);
        this.metrics = (options || {}).metrics || (0, $hqYEY.metrics);
        this.resetInitialRenderTask();
    }
    initializeContextualAnalyticsData(data) {
        this.contextualAnalyticsData = {
            ...data
        };
    }
    addContextualAnalyticsData(newData) {
        this.contextualAnalyticsData = {
            ...this.contextualAnalyticsData,
            ...newData
        };
    }
    /**
	 * Add initial render stats to the ongoing UFO initial load metric
	 *
	 */ finishInitialRender(options) {
        // Retrieve the task in which all the initial render stats are stored.
        const task = this.tasks.get($c06cc877a4cec7c4$export$4726438eb4db5074);
        if (!task) return;
        // Extract and record the early preload timings
        this.recordEarlyPreloadTimings();
        const bm3Marks = {};
        this.timings.forEach(({ key: key, startTime: startTime, endTime: endTime })=>{
            bm3Marks[`${key}:start`] = startTime;
            bm3Marks[`${key}:end`] = endTime;
        });
        const bm3CustomTimings = this.timings.map(({ key: key })=>({
                key: key,
                startMark: `${key}:start`,
                endMark: `${key}:end`
            }));
        (0, $6whQo.addBM3TimingsToUFO)(bm3Marks, bm3CustomTimings);
        // Record the product stop in the UFO
        (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $akiS9.PRODUCT_START_MARK), true);
        // Add custom data to UFO
        const { scalingFactors: scalingFactors } = options;
        const customData = this.collectCustomData({
            scalingFactors: scalingFactors
        }, task.executionTimes, task.marks);
        (0, $2gvG4.addUFOCustomData)(customData);
        /**
		 * Record the custom TTI value in UFO. UFO will use this TTI value. If this is not provided it, will use TTAI.
		 * The key is only used to create [bm3_tti] mark. The TTI value is recorded using `stopTime`.
		 * As we are using UFO metric names, we don't need seperate keys here.
		 * platform/packages/react-ufo/ufo-create-payload/src/index.ts#74
		 */ (0, $2QO3b.addApdexToAll)({
            key: 'plans',
            stopTime: performance.now()
        });
        // Reset the initial render data.
        this.resetInitialRenderTask();
    }
    /**
	 * Start measuring the task and timed functions within.
	 *
	 * Task is a single report unit. Always pair `startTask` with `finishTask`, or the corresponding
	 * analytics event will not be sent. Tasks are re-entrant, starting the same task before it's
	 * finished has no effect, the monitor just continues to collect data. However, people looking
	 * at the data would most likely imply 1:1 start/finish correspondence, so please don't abuse
	 * re-entrance property.
	 *
	 * When timed function is executed within a task its timing is added to task's extra attributes,
	 * as well as provided scaleFactors and registered perf feature flags. Tasks support nesting,
	 * timed functions are reported for all running tasks.
	 *
	 * We track function timing in `executionTimes` instead of using `BrowserMetrics.setMark` as it
	 * gets ugly fast due to the need to keep track of start and end of multiple invocations encoded
	 * in mark keys.
	 *
	 * At the moment all the tasks are reported as `custom` metrics as it's a majority of our use-cases
	 * but we must add support for `interaction` metrics.
	 */ startTask(taskKey, options, customStartTime) {
        if (this.tasks.has(taskKey)) return;
        const interaction = this.metrics.custom({
            key: $c06cc877a4cec7c4$var$taskKeyToInteractionKey(taskKey),
            featureFlags: this.featureFlags,
            slo: {
                threshold: $c06cc877a4cec7c4$export$2a97570d48bcd64d
            }
        });
        customStartTime !== undefined ? interaction.start({
            startTime: customStartTime
        }) : interaction.start();
        const justOptions = options || {
            scalingFactors: {}
        };
        const executionTimes = new Map();
        const marks = new Set();
        const task = {
            interaction: interaction,
            options: justOptions,
            executionTimes: executionTimes,
            marks: marks
        };
        this.tasks.set(taskKey, task);
        this.setMark(`${taskKey}_start`);
    }
    /**
	 * Finish measuring the task, prepare and send corresponding analytics event.
	 */ finishTask(taskKey, options) {
        const task = this.tasks.get(taskKey);
        if (!task) return;
        const { sloSuccessThreshold: sloSuccessThreshold = $c06cc877a4cec7c4$export$2a97570d48bcd64d, scalingFactors: scalingFactors } = options || {};
        // NOTE BM3 doesn't support setting SLO after interaction instantiation.
        // We violate its contract and set private field directly from here.
        // We do it only for the sake of Monitor's API backward compatibility.
        // We must move SLO into startTask ASAP and remove this abomination.
        if (typeof task.interaction.config !== 'undefined') task.interaction.config.slo.threshold = sloSuccessThreshold;
        if (scalingFactors) // @ts-expect-error No overload matches this call.
        Object.assign(task.options.scalingFactors, scalingFactors);
        const customData = this.collectCustomData(task.options, task.executionTimes, task.marks);
        task.interaction.stop({
            customData: customData
        });
        this.tasks.delete(taskKey);
        this.setMark(`${taskKey}_end`);
    }
    /**
	 * Decorate a function as a task, synchronously (task is finished as soon as the function returns).
	 */ timeTask(task, taskKey, options) {
        return (...args)=>{
            this.startTask(taskKey, options);
            const result = task(...args);
            this.finishTask(taskKey);
            return result;
        };
    }
    /**
	 * Mark a synchronous function as a timed one.
	 *
	 * When the function is executed in the presence of running tasks, its timing is reported to all of them.
	 *
	 * TODO Have a register of timed functions to warn on name clashes.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeFunction(fn, fnKey) {
        return (...args)=>{
            this.startProfile(fnKey);
            const result = fn(...args);
            this.finishProfile(fnKey);
            return result;
        };
    }
    /**
	 * Start measuring execution time from the current point to the corresponding `finishProfile` call.
	 *
	 * When the profile is finished in the presence of running tasks, its timing is reported to all of them.
	 * *Do not* use it if the same profile could be potentially started concurrently,
	 * use `startProfileConcurrent` instead.
	 */ startProfile(profileKey) {
        if (this.profiles.has(profileKey)) return;
        this.profiles.set(profileKey, {
            start: performance.now()
        });
    }
    /**
	 * Finish profile and record its execution time to all running tasks.
	 *
	 * Use it only together with `startProfile`.
	 * To finish profile started by `startProfileConcurrent` use the returned function instead.
	 */ finishProfile(profileKey) {
        const profile = this.profiles.get(profileKey);
        if (!profile) return;
        this.recordProfile(profileKey, profile);
        this.profiles.delete(profileKey);
    }
    /**
	 * Start measuring execution time from the current point to the call of the returned function.
	 *
	 * When the profile is finish in the presence of running tasks, its timing is reported to all of them.
	 * This method is safe for the potentially concurrent multiple entries by the cost of the need
	 * to pass finish function down to the profile finish point.
	 * *Do not* use `finishProfile` method for the profile started by `startProfileConcurrent`.
	 */ startProfileConcurrent(profileKey) {
        const profile = {
            start: performance.now()
        };
        return ()=>this.recordProfile(profileKey, profile);
    }
    /**
	 * Register a boolean flag to be added as an extra attribute to emitted events.
	 */ registerBooleanFeatureFlag(flag) {
        this.featureFlags.push(flag);
    }
    /**
	 * Register a mark to be reported to all tasks running at that moment.
	 */ setMark(markKey) {
        if (!performance.mark) return;
        performance.mark(markKey);
        for (const { marks: marks } of this.tasks.values())marks.add(markKey);
    }
    // Private.
    /**
	 * Create a fake task to track initial render info
	 */ resetInitialRenderTask() {
        const executionTimes = new Map();
        const marks = new Set();
        const task = {
            interaction: {},
            options: {
                scalingFactors: {}
            },
            executionTimes: executionTimes,
            marks: marks
        };
        this.tasks.set($c06cc877a4cec7c4$export$4726438eb4db5074, task);
    }
    /**
	 * Record profile execution time to all running tasks.
	 */ recordProfile(profileKey, profile) {
        const profileEnd = performance.now();
        const measurement = {
            start: profile.start,
            end: profileEnd
        };
        for (const { executionTimes: executionTimes } of this.tasks.values()){
            const times = executionTimes.get(profileKey);
            if (times) times.push(measurement);
            else executionTimes.set(profileKey, [
                measurement
            ]);
        }
    }
    /**
	 * Record custom profile execution time to all running tasks
	 */ recordCustomProfile(profileKey, customProfile) {
        const measurement = {
            ...customProfile
        };
        for (const { executionTimes: executionTimes } of this.tasks.values()){
            const times = executionTimes.get(profileKey);
            if (times) times.push(measurement);
            else executionTimes.set(profileKey, [
                measurement
            ]);
        }
    }
    /**
	 * Records the timing for preload requests
	 */ recordEarlyPreloadTimings() {
        const resources = [
            '',
            'backlog',
            'info-metadata',
            'initial-checks-for-report',
            'plan-info-for-report'
        ];
        this.timings.push(...resources.map((resource)=>{
            /**
				 * Recording the performance information of the API before returning
				 * the response.
				 */ const start = Math.floor((0, $jbpoj.extractStartTime)(`${$c06cc877a4cec7c4$export$1b60784a15ad91a9}${resource ? `.${resource}` : ''}:start`));
            const end = Math.ceil((0, $jbpoj.extractStartTime)(`${$c06cc877a4cec7c4$export$1b60784a15ad91a9}${resource ? `.${resource}` : ''}:end`));
            return {
                key: resource ? `${$c06cc877a4cec7c4$var$ARJ_EARLY_PRELOAD}/${resource}` : $c06cc877a4cec7c4$var$ARJ_EARLY_PRELOAD,
                startTime: start,
                endTime: end
            };
        }));
    }
    recordProductTimings() {
        const resources = [
            'parse-json'
        ];
        this.timings.push(...resources.map((resource)=>{
            /**
				 * Recording the performance information for preprocessing product data
				 */ const start = Math.floor((0, $jbpoj.extractStartTime)(`${$c06cc877a4cec7c4$var$PRODUCT_PREFIX}.${resource}:start`));
            const end = Math.ceil((0, $jbpoj.extractStartTime)(`${$c06cc877a4cec7c4$var$PRODUCT_PREFIX}.${resource}:end`));
            return {
                key: `product/${resource}`,
                startTime: start,
                endTime: end
            };
        }));
    }
    /**
	 * Enrich task report with feature flags, scaling factors, and execution time stats.
	 *
	 * Reported stats: min, max, mean, standard deviation, number of runs.
	 *
	 * Note that dots in feature flag names (and any other attributes) will be replaced by underscores in Splunk.
	 * (TODO confirm if this is still true in BM3 case)
	 */ collectCustomData(options, executionTimes, marks) {
        const pageStart = this.pageStart();
        const report = {
            ...this.contextualAnalyticsData,
            scalingFactors: {},
            executionTimes: {},
            marks: {}
        };
        const scalingFactors = options.scalingFactors || {};
        for (const factor of Object.keys(scalingFactors))report.scalingFactors[factor] = scalingFactors[factor];
        for (const [fnKey, allTimes] of executionTimes){
            // Skip leftovers from the previous route.
            const times = allTimes.filter(({ start: start })=>start >= pageStart);
            const n = times.length;
            if (n > 0) {
                const start = times[0].start;
                let lastEnd = start;
                let min = Infinity;
                let max = -Infinity;
                let sum = 0;
                for (const { start: begin, end: finish } of times){
                    const duration = finish - begin;
                    sum += duration;
                    min = Math.min(min, duration);
                    max = Math.max(max, duration);
                    lastEnd = Math.max(lastEnd, finish);
                }
                const mean = sum / n;
                let devSum = 0;
                for (const { start: begin, end: finish } of times){
                    const dev = finish - begin - mean;
                    devSum += dev * dev;
                }
                const stddev = n > 1 ? Math.sqrt(devSum / (n - 1)) : 0;
                report.executionTimes[fnKey] = {
                    start: start - pageStart,
                    end: lastEnd - pageStart,
                    min: min,
                    max: max,
                    mean: mean,
                    stddev: stddev,
                    count: n,
                    sum: sum
                };
            }
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (performance.getEntriesByName) for (const mark of marks){
            let i = 0;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            for (const m of performance.getEntriesByName(mark) || []){
                if (i > $c06cc877a4cec7c4$var$MAX_ENTRIES_PER_MARK) break;
                const start = m.startTime - pageStart;
                // Skip leftovers from the previous route.
                if (start >= 0) {
                    report.marks[`${mark}_${i}`] = start;
                    i++;
                }
            }
        }
        return report;
    }
    /** When the most recent page transition started.
	 *
	 * It will be 0 on initial load.
	 */ pageStart() {
        return this.browserMetrics.getPageLoadMetric()?.startTime || 0;
    }
}
const $c06cc877a4cec7c4$export$ec5b303098bc4b7f = new $c06cc877a4cec7c4$export$3de16b9a4e4a99f4();

});
parcelRegister("6whQo", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $3708d872c36dd1bb$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $3708d872c36dd1bb$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $3708d872c36dd1bb$export$d93d677ef2f33c5c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $3708d872c36dd1bb$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    (0, $eJOHy.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $3708d872c36dd1bb$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingsConfig);
        (0, $2QO3b.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("akiS9", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $50b865cde2c2d004$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $50b865cde2c2d004$export$2a999c5f84501025);

var $6uWhG = parcelRequire("6uWhG");
const $50b865cde2c2d004$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $50b865cde2c2d004$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($50b865cde2c2d004$export$8e54fca0a680fdfd);
        (0, $6uWhG.setMark)($50b865cde2c2d004$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("jbpoj", function(module, exports) {

$parcel$export(module.exports, "extractStartTime", () => $aaa3968e32bfce42$export$97ed9769a496ce6e);
const $aaa3968e32bfce42$export$97ed9769a496ce6e = (markName)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    (performance.getEntriesByName(markName, 'mark')[0] || {
        startTime: 0
    }).startTime;

});


const $12e40ee10589c2f2$export$b8b9d90f9e5bd72b = 'jiraPortfolio3CreateNewPlanWizardDrawer';
const $12e40ee10589c2f2$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $12e40ee10589c2f2$export$f27a837467ec20e5 = 'planWizard';
const $12e40ee10589c2f2$export$6afdd25b4da87159 = 30;
const $12e40ee10589c2f2$export$9a977208af30ffae = 'create-plan-wizard.load-time';
const $12e40ee10589c2f2$export$a8e537ef0c1e2586 = 'Days';
const $12e40ee10589c2f2$export$2a59d0fbc784e5c1 = '1';
const $12e40ee10589c2f2$export$7288711b5316ff78 = 'YYYY-MM-DD';
const $12e40ee10589c2f2$export$14ae725d0cc7daa1 = 'DD/MMM/YY';

parcelRegister("1NIDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7cfbfeb0a1db96b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a7cfbfeb0a1db96b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    // remove when cleaning up "plan_wizard_accessible_button_labeling"
    close: {
        "id": "portfolio-3-create-new-plan-wizard-drawer.ui.close",
        "defaultMessage": "Close"
    },
    dialogLabel: {
        "id": "portfolio-3-create-new-plan-wizard-drawer.ui.dialogLabel",
        "defaultMessage": "Create a plan"
    }
});

});

parcelRegister("7cIYo", function(module, exports) {

$parcel$export(module.exports, "CreateNewPlanWizardDrawerOld", () => $da56cd49ee87522f$export$e66c2703242093eb);
/* index-old.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6K9yc = parcelRequire("6K9yc");
var $avQYn = parcelRequire("avQYn");
var $dSmxJ = parcelRequire("dSmxJ");
var $i59Yb = parcelRequire("i59Yb");

var $aewX5 = parcelRequire("aewX5");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $6J9k6 = parcelRequire("6J9k6");

var $5kYyR = parcelRequire("5kYyR");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $3nRRD = parcelRequire("3nRRD");

var $ch9En = parcelRequire("ch9En");

var $3xNM4 = parcelRequire("3xNM4");

var $bQWwW = parcelRequire("bQWwW");


var $6c6vC = parcelRequire("6c6vC");

var $1NIDh = parcelRequire("1NIDh");

const $da56cd49ee87522f$export$3039dc74ce32c9c8 = (0, $bQWwW.lazy)(()=>{
    (0, $3xNM4.monitor).startTask((0, $12e40ee10589c2f2$export$9a977208af30ffae));
    return (parcelRequire("7eH8v")).then((module)=>module.default);
}, {
    ssr: false,
    moduleId: "./src/packages/portfolio-3/create-new-plan-wizard-drawer/src/ui/content/index.tsx"
});
const $da56cd49ee87522f$var$AsyncPlanWizardWrapped = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderNew), {
        name: "async-plan-create-wizard",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da56cd49ee87522f$export$3039dc74ce32c9c8, props));
const $da56cd49ee87522f$export$e66c2703242093eb = ({ PlanWizard: PlanWizard = (0, $7jTnu.fg)('concurrent-rendering-fix-plan-create-drawer') ? $da56cd49ee87522f$var$AsyncPlanWizardWrapped : $da56cd49ee87522f$export$3039dc74ce32c9c8 })=>{
    const [{ isOpen: isOpen, plan: plan }, { closeDrawer: closeDrawer }] = (0, $6c6vC.useCreateNewPlanWizardDrawer)();
    const { loading: loading, intlMessages: intlMessages, locale: locale } = (0, $6c6vC.useImportedMessagesForLocale)();
    const keepMounted = (0, $eJOHy.useRef)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (!keepMounted.current && !isOpen) return null; // Keep mounted to Drawer close animation works
    if (!keepMounted.current) keepMounted.current = true; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleRequestClose = (e)=>{
        if (e.key === 'Escape') return;
        closeDrawer();
    };
    const spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da56cd49ee87522f$var$Center, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "xlarge"
    })); // Wrapping the AsyncPlanWizard component directly in Placeholder results the Drawer
    // flickering when it is opened immediately after the /plans page loads - either through
    // the create-plan=true query param, or by quickly clicking the top RHS Create plan
    // button. Wrapping the parent Drawer in Placeholder resolves this issue.
    const content = (()=>{
        if (loading) return spinner;
        if (!intlMessages) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PlanWizard, {
            plan: plan
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nRRD.IntlProvider), {
            messages: intlMessages,
            locale: locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PlanWizard, {
            plan: plan
        }));
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "create-new-plan-wizard",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K9yc.Drawer), {
        isOpen: isOpen,
        width: "full",
        onClose: handleRequestClose,
        label: formatMessage((0, $1NIDh.default).dialogLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i59Yb.DrawerSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $avQYn.DrawerCloseButton), {
        icon: (iconsProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
                ...iconsProps,
                LEGACY_size: "medium"
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dSmxJ.DrawerContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aewX5.default), {
        xcss: $da56cd49ee87522f$var$containerStylesCentred,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: (0, $12e40ee10589c2f2$export$b8b9d90f9e5bd72b),
        packageName: (0, $12e40ee10589c2f2$export$b8b9d90f9e5bd72b),
        teamName: (0, $12e40ee10589c2f2$export$cfeee2ee86ead336),
        sendToPrivacyUnsafeSplunk: true
    }, content)))));
};
const $da56cd49ee87522f$var$containerStylesCentred = (0, $1DXK0.xcss)({
    minHeight: '100%',
    paddingTop: 'space.300',
    paddingBottom: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da56cd49ee87522f$var$Center = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3id81e _c71l1w2c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7eH8v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("amwIY").then(()=>parcelRequire('QQ1JK'));

});



parcelRegister("fw9To", function(module, exports) {

$parcel$export(module.exports, "default", () => $248ef36b616a42f5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $956it = parcelRequire("956it");

var $5kYyR = parcelRequire("5kYyR");

var $bILK0 = parcelRequire("bILK0");

var $ch9En = parcelRequire("ch9En");

var $6d9QY = parcelRequire("6d9QY");

var $3MbOI = parcelRequire("3MbOI");

var $gCY1z = parcelRequire("gCY1z");
var $83DiZ = parcelRequire("83DiZ");

var $7woBL = parcelRequire("7woBL");

var $5BAEL = parcelRequire("5BAEL");

var $fRzC9 = parcelRequire("fRzC9");
const $248ef36b616a42f5$var$CreateSamplePlan = ()=>{
    const [{ isOpen: isOpen }, { close: close }] = (0, $5BAEL.useCreateSamplePlan)();
    const [{ location: location }] = (0, $gCY1z.useRouter)();
    const initialLocation = (0, $6d9QY.usePrevious)(location);
    // When the route changes we should close the modal
    (0, $eJOHy.useEffect)(()=>{
        if (initialLocation && initialLocation !== location) close();
    }, [
        close,
        initialLocation,
        location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "create-sample-plan",
        fallback: null
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fRzC9.default), null)));
};
const $248ef36b616a42f5$var$CreateSamplePlanContainer = ({ isOpen: isOpen = false })=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { data: { user: currentUser } } = (0, $3MbOI.useCurrentUser)();
    const redirectToPlan = (0, $eJOHy.useCallback)((planId)=>{
        push(`/jira/plans/${planId}`);
    }, [
        push
    ]);
    if (!currentUser.accountId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5BAEL.CreateSamplePlanProvider), {
        isGlobal: true,
        isOpen: isOpen,
        showFlag: showFlag,
        redirectToPlan: redirectToPlan,
        leadAccountId: currentUser.accountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: (0, $7woBL.ERROR_REPORTING_PACKAGE),
        packageName: (0, $7woBL.ERROR_REPORTING_PACKAGE),
        teamName: (0, $7woBL.ERROR_REPORTING_TEAM),
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($248ef36b616a42f5$var$CreateSamplePlan, null)));
};
var $248ef36b616a42f5$export$2e2bcd8739ae039 = $248ef36b616a42f5$var$CreateSamplePlanContainer;

});
parcelRegister("fRzC9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c994a880fac47a8f$export$2e2bcd8739ae039);

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c994a880fac47a8f$var$CreateSamplePlanContent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1JCWW")).then((module)=>module.default), {
    moduleId: "./src/packages/portfolio-3/create-sample-plan/src/ui/content/index.tsx"
});
var $c994a880fac47a8f$export$2e2bcd8739ae039 = $c994a880fac47a8f$var$CreateSamplePlanContent;

});
parcelRegister("1JCWW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lTtPK").then(()=>parcelRequire('ioUY8'));

});



parcelRegister("juJEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2ab7b7dd55498ed$export$2e2bcd8739ae039);

var $l5htz = parcelRequire("l5htz");

var $2QUmO = parcelRequire("2QUmO");

var $9pWNg = parcelRequire("9pWNg");

var $c7mRA = parcelRequire("c7mRA");

var $7pYQE = parcelRequire("7pYQE");
var $d2ab7b7dd55498ed$export$2e2bcd8739ae039 = (0, $l5htz.default)({
    onClose: ({ screen: screen, canCreateClassicProject: canCreateClassicProject, canCreateNextGenProject: canCreateNextGenProject, isAdmin: isAdmin, projectComparisonScreen: projectComparisonScreen })=>({
            name: 'projectCreate',
            screen: screen,
            canCreateClassic: canCreateClassicProject,
            canCreateNextGen: canCreateNextGenProject,
            isAdmin: isAdmin,
            projectComparisonScreen: projectComparisonScreen
        })
})((0, $2QUmO.default)((0, $7pYQE.default), {
    Consumer: (0, $9pWNg.ProjectCreateDrawerConsumer),
    ProjectCreate: $c7mRA.default
}));

});
parcelRegister("c7mRA", function(module, exports) {

$parcel$export(module.exports, "loadProjectCreateBundle", () => $6e73c7b82ee1a1c6$export$cb6ba161267f8f0c);
$parcel$export(module.exports, "AsyncProjectCreate", () => $6e73c7b82ee1a1c6$export$b283b23d37290b6a);
$parcel$export(module.exports, "default", () => $6e73c7b82ee1a1c6$export$2e2bcd8739ae039);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $fgF5F = parcelRequire("fgF5F");

const $6e73c7b82ee1a1c6$export$cb6ba161267f8f0c = ()=>(parcelRequire("dih9G"));

/* eslint-disable-next-line jira/import/webpack-magic-comment-entries, jira/deprecations/no-rll-client-async-experiences */ const $6e73c7b82ee1a1c6$var$LazyComponent = (0, $bQWwW.lazy)(()=>(parcelRequire("dih9G")), {
    moduleId: "./src/packages/project-create/main/src/index.tsx"
});
const $6e73c7b82ee1a1c6$export$b283b23d37290b6a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "bundle-async-project-create",
        fallback: "flag",
        packageName: (0, $fgF5F.PACKAGE_NAME),
        teamName: (0, $fgF5F.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "project-create",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6e73c7b82ee1a1c6$var$Center, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "large"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6e73c7b82ee1a1c6$var$LazyComponent, props)));
var $6e73c7b82ee1a1c6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6e73c7b82ee1a1c6$export$b283b23d37290b6a;
const $6e73c7b82ee1a1c6$var$Center = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1kxc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fgF5F", function(module, exports) {

$parcel$export(module.exports, "TEAM_NAME", () => $05fb611f213e452a$export$d57b6b390e78d90f);
$parcel$export(module.exports, "PROJECT_CREATE_APP_NAME", () => $05fb611f213e452a$export$8f0c4426531e762);
$parcel$export(module.exports, "PACKAGE_NAME", () => $05fb611f213e452a$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PROJECT_CREATE_LOAD_START_MARK_KEY", () => $05fb611f213e452a$export$59fe870bc818978d);
$parcel$export(module.exports, "PROJECT_CREATE_LOAD_END_MARK_KEY", () => $05fb611f213e452a$export$c31bdc8313c39f72);
$parcel$export(module.exports, "PROJECT_CREATE_READY_MARK_KEY", () => $05fb611f213e452a$export$5dc4f809336ac7c3);
$parcel$export(module.exports, "PROJECT_CREATE_JWM_ONBOARDING", () => $05fb611f213e452a$export$def2f343237303e5);
$parcel$export(module.exports, "defaultProps", () => $05fb611f213e452a$export$9c21a3269931e1e6);

var $12DRg = parcelRequire("12DRg");
const $05fb611f213e452a$export$d57b6b390e78d90f = 'helix';
const $05fb611f213e452a$export$8f0c4426531e762 = 'project-create';
const $05fb611f213e452a$export$b8b9d90f9e5bd72b = 'jiraProjectCreateMain';
const $05fb611f213e452a$export$59fe870bc818978d = 'PROJECT_CREATE_LOAD_START_MARK_KEY';
const $05fb611f213e452a$export$c31bdc8313c39f72 = 'PROJECT_CREATE_LOAD_END_MARK_KEY';
const $05fb611f213e452a$export$5dc4f809336ac7c3 = 'PROJECT_CREATE_READY_MARK_KEY';
const $05fb611f213e452a$export$def2f343237303e5 = 'projectCreateJwmOnboarding';
const $05fb611f213e452a$export$fde004f68299c66e = 'nthProjectCreate';
const $05fb611f213e452a$export$9c21a3269931e1e6 = {
    isImportProjectOpenInitially: false,
    isTemplatePickerOpenInitially: false,
    isJswOnboarding: false,
    isOnboarding: false,
    isConnectedProjectScenario: false,
    isJiraCoreOnboarding: false,
    skipTemplateSelection: false,
    recommendedTemplate: undefined,
    defaultSelectedTemplateKey: '',
    source: '',
    selectedProjectType: null,
    onPermissionsFetched: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onDrawerClose: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onCreateStarted: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    isBusinessUser: false
};

});

parcelRegister("dih9G", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kNFvF"),
    $ewTvA("fzqFk")
]).then(()=>parcelRequire('fp3kq'));

});


parcelRegister("7pYQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ba54023a1008c73$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $BwaQq = parcelRequire("BwaQq");

var $6uWhG = parcelRequire("6uWhG");

var $3Zulo = parcelRequire("3Zulo");


var $fgF5F = parcelRequire("fgF5F");

var $7zx7f = parcelRequire("7zx7f");
const $4ba54023a1008c73$var$PreloadAsyncProjectCreateDrawer = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        (0, $7zx7f.preloadAsyncProjectCreateDrawer)();
    }, []);
    return null;
};
// eslint-disable-next-line jira/react/no-class-components
const $4ba54023a1008c73$var$View = class ProjectCreateDrawer extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isAdmin: false,
            isOnboarding: false
        };
    }
    render() {
        const { Consumer: Consumer } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, Consumer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Consumer, null, ({ data: data, methods: methods })=>data.shouldRenderDrawer ? this.renderContent(data, methods) : null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Zulo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4ba54023a1008c73$var$PreloadAsyncProjectCreateDrawer, null)));
    }
    constructor(...args){
        super(...args), this.onScreenChange = (screen)=>{
            this.screen = screen;
        }, this.onPermissionsFetched = ({ canCreateClassicProject: canCreateClassicProject, canCreateNextGenProject: canCreateNextGenProject })=>{
            this.permissions = {
                canCreateClassicProject: canCreateClassicProject,
                canCreateNextGenProject: canCreateNextGenProject
            };
        }, this.screen = '', this.permissions = {
            canCreateClassicProject: null,
            canCreateNextGenProject: null
        }, this.renderContent = (data, methods)=>{
            const { isAdmin: isAdmin, locale: locale, isOnboarding: isOnboarding, appEditions: appEditions, ProjectCreate: ProjectCreate } = this.props;
            if (data.isOpen) (0, $6uWhG.setMark)((0, $fgF5F.PROJECT_CREATE_LOAD_START_MARK_KEY));
            const onClose = (e, analyticsEvent)=>{
                methods.close();
                this.props.onClose && this.props.onClose({
                    screen: this.screen,
                    isAdmin: this.props.isAdmin,
                    canCreateClassicProject: this.permissions.canCreateClassicProject,
                    canCreateNextGenProject: this.permissions.canCreateNextGenProject
                }, analyticsEvent);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7zx7f.AsyncProjectCreateDrawerContent), {
                onClose: onClose,
                isAdmin: isAdmin,
                isOnboarding: isOnboarding,
                data: data,
                methods: methods,
                locale: locale,
                appEditions: appEditions,
                onScreenChange: this.onScreenChange,
                onPermissionsFetched: this.onPermissionsFetched,
                ProjectCreate: ProjectCreate
            });
        };
    }
};
var $4ba54023a1008c73$export$2e2bcd8739ae039 = (0, $BwaQq.AnalyticsSource)('ProjectCreate', (0, $466f60259c330878$export$9d2de6eebf7462b5))($4ba54023a1008c73$var$View);

});
parcelRegister("3Zulo", function(module, exports) {

$parcel$export(module.exports, "NonCritical", () => $35e7d40f521eb281$export$20fd89b1bf707b1a);
$parcel$export(module.exports, "default", () => $35e7d40f521eb281$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $9XYcy = parcelRequire("9XYcy");
const $35e7d40f521eb281$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
    const [{ isReady: isReady }] = (0, $9XYcy.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eJOHy.useState)(true);
    const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (timerThreshold != null) setTimeout(()=>{
            setHasThresholdTimerExpired(true);
        }, timerThreshold);
    }, [
        timerThreshold
    ]);
    if (!isFirstRun || isReady || hasThresholdTimerExpired) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    }
    return null;
};
const $35e7d40f521eb281$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($35e7d40f521eb281$export$83d969795398ec56, props));
/**
 * Delays rendering its children until the page is deemed ready, optimizing for a smoother initial load. Suitable for content that is not immediately necessary.
 */ const $35e7d40f521eb281$var$NonCriticalComponent = (props)=>{
    const [{ isReady: isReady }] = (0, $9XYcy.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eJOHy.useState)(true);
    if (!isFirstRun || isReady) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    }
    return null;
};
const $35e7d40f521eb281$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($35e7d40f521eb281$var$NonCriticalComponent, props));
var $35e7d40f521eb281$export$2e2bcd8739ae039 = $35e7d40f521eb281$var$NonCriticalComponent;

});

parcelRegister("7zx7f", function(module, exports) {

$parcel$export(module.exports, "preloadAsyncProjectCreateDrawer", () => $acaf3824e5d603fb$export$bf40786982237798);
$parcel$export(module.exports, "AsyncProjectCreateDrawerContent", () => $acaf3824e5d603fb$export$975ae959df433581);

var $eJOHy = parcelRequire("eJOHy");

var $5Lo0w = parcelRequire("5Lo0w");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

const $acaf3824e5d603fb$export$bf40786982237798 = ()=>(parcelRequire("4RJIm"));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $acaf3824e5d603fb$var$LazyComponent = (0, $bQWwW.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("4RJIm")), {
    moduleId: "./src/packages/navigation-apps/project-create-drawer/src/view/index.tsx"
});
const $acaf3824e5d603fb$var$newComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "bundle-async-project-create-drawer",
        fallback: "flag",
        packageName: "jira-project-create-drawer",
        teamName: "helix"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-project-create-drawer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Lo0w.default), {
            isTinted: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acaf3824e5d603fb$var$LazyComponent, props)));
const $acaf3824e5d603fb$export$975ae959df433581 = $acaf3824e5d603fb$var$newComponent;

});
parcelRegister("4RJIm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kq6VC").then(()=>parcelRequire('hjISk'));

});




parcelRegister("h4s0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2e50921157e596f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");

var $bHRpp = parcelRequire("bHRpp");

var $39IeV = parcelRequire("39IeV");
const $a2e50921157e596f$var$Dialog = ()=>{
    const [, { setShortcutsDialogVisibility: setShortcutsDialogVisibility }] = (0, $bHRpp.useShortcutsActions)();
    const onClose = (0, $eJOHy.useCallback)(()=>setShortcutsDialogVisibility(false), [
        setShortcutsDialogVisibility
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "dotDialog",
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $39IeV.default), {
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: {
            name: 'dotDialog'
        }
    }));
};
const $a2e50921157e596f$var$ShortcutsDialog = ()=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }] = (0, $bHRpp.useShortcuts)();
    return isShortcutsDialogVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "shortcuts-dialog",
        packageName: "jira-shortcuts-dialog",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a2e50921157e596f$var$Dialog, null)) : null;
};
var $a2e50921157e596f$export$2e2bcd8739ae039 = $a2e50921157e596f$var$ShortcutsDialog;

});
parcelRegister("bHRpp", function(module, exports) {

$parcel$export(module.exports, "useShortcuts", () => $5ec870659f2b42dd$export$a1ca853c6e4bb6fb);
$parcel$export(module.exports, "useShortcutsActions", () => $5ec870659f2b42dd$export$b331ee6e87b9104c);

var $fgHZ8 = parcelRequire("fgHZ8");
const $5ec870659f2b42dd$export$a1ca853c6e4bb6fb = ()=>(0, $fgHZ8.useShortcutsStore)();
const $5ec870659f2b42dd$export$b331ee6e87b9104c = ()=>{
    const [, actions] = (0, $fgHZ8.useShortcutsActionsStore)();
    return [
        undefined,
        actions
    ];
};

});
parcelRegister("fgHZ8", function(module, exports) {

$parcel$export(module.exports, "useShortcutsStore", () => $1037d55a513c4cd3$export$a14646bfc7ba8d81);
$parcel$export(module.exports, "useShortcutsActionsStore", () => $1037d55a513c4cd3$export$1a29bfef7fa09838);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9rMca = parcelRequire("9rMca");
const $1037d55a513c4cd3$export$d4c72bab9d6cc13a = {
    shortcuts: {
        admin: {
            key: 'admin',
            label: 'ADMIN',
            options: [],
            isLoaded: false
        }
    },
    isShortcutsDialogVisible: false,
    isShortcutsLoading: false,
    hasError: false,
    isAdminLoading: false,
    selectedItemKey: null,
    header: null,
    title: undefined
};
const $1037d55a513c4cd3$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'shortcuts',
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly shortcuts: { readonly admin: { readonly key: "admin"; readonly label: "ADMIN"; readonly options: readonly []; readonly isLoaded: false; }; }; readonly isShortcutsDialogVisible: false; readonly isShortcutsLoading: false; ... 4 more ...; readonly title: undefined; }' is not assignable to type 'State'.
    $1037d55a513c4cd3$export$d4c72bab9d6cc13a,
    actions: $9rMca
});
const $1037d55a513c4cd3$export$a14646bfc7ba8d81 = (0, $iJq0l.createHook)($1037d55a513c4cd3$export$6f57813fe9f31bf9);
const $1037d55a513c4cd3$export$1a29bfef7fa09838 = (0, $iJq0l.createHook)($1037d55a513c4cd3$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("9rMca", function(module, exports) {

$parcel$export(module.exports, "registerShortcuts", () => $bd65986ef711b2b7$export$598ec0e6047cbdca);
$parcel$export(module.exports, "setShortcutsDialogVisibility", () => $bd65986ef711b2b7$export$80ab1e79e32c3021);
$parcel$export(module.exports, "setShortcutsLoading", () => $bd65986ef711b2b7$export$7ed2ac8328423043);
$parcel$export(module.exports, "setHasError", () => $bd65986ef711b2b7$export$645a7c7453685186);
$parcel$export(module.exports, "setHeader", () => $bd65986ef711b2b7$export$604ed74fb893f0e2);
$parcel$export(module.exports, "fetchAdminSections", () => $bd65986ef711b2b7$export$aec87c8c9bde62e6);
$parcel$export(module.exports, "setSelectedItemKey", () => $bd65986ef711b2b7$export$249c9d5b49cd9712);
$parcel$export(module.exports, "dropShortcutsByKeys", () => $bd65986ef711b2b7$export$9cf39adf0dec984);

var $2zs80 = parcelRequire("2zs80");

var $9FV9P = parcelRequire("9FV9P");

var $2TCxE = parcelRequire("2TCxE");
const $bd65986ef711b2b7$export$598ec0e6047cbdca = (shortcuts)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newShortcuts = shortcuts.reduce((acc, current)=>{
            acc[current.key] = current;
            return acc;
        }, {
            ...currentState.shortcuts
        });
        setState({
            ...currentState,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };
const $bd65986ef711b2b7$export$80ab1e79e32c3021 = (isVisible)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsDialogVisible: isVisible
        });
    };
const $bd65986ef711b2b7$export$7ed2ac8328423043 = (isLoading)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsLoading: isLoading
        });
    };
const $bd65986ef711b2b7$export$645a7c7453685186 = (hasError)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            hasError: hasError
        });
    };
const $bd65986ef711b2b7$export$604ed74fb893f0e2 = (header, title)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            header: header,
            title: title
        });
    };
const $bd65986ef711b2b7$export$aec87c8c9bde62e6 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isAdminLoading: true
        });
        const result = await (0, $9FV9P.default)();
        const shortcuts = result ? (0, $2TCxE.buildAdminSections)(result) : [];
        const newState = getState();
        setState({
            ...newState,
            shortcuts: {
                ...newState.shortcuts,
                admin: {
                    ...newState.shortcuts.admin,
                    key: 'admin',
                    options: shortcuts,
                    isLoaded: true
                }
            },
            hasError: currentState.hasError || !result,
            isAdminLoading: false
        });
    };
const $bd65986ef711b2b7$export$249c9d5b49cd9712 = (item)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            selectedItemKey: item
        });
    };
const $bd65986ef711b2b7$export$9cf39adf0dec984 = (keys)=>({ getState: getState, setState: setState })=>{
        if (!keys.length) return;
        const { shortcuts: shortcuts, ...rest } = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newShortcuts = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(Object.keys(shortcuts), keys).reduce((acc, key)=>{
            acc[key] = shortcuts[key];
            return acc;
        }, {});
        setState({
            ...rest,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };

});
parcelRegister("9FV9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9cd1634918b3cd3$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e9cd1634918b3cd3$export$2e2bcd8739ae039 = async ()=>{
    try {
        return await (0, $1Ozm9.default)('/rest/adminquicksearch/latest/links/default');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('shortcuts-dialog.fetch-admin-links', error.toString());
        return null;
    }
};

});

parcelRegister("2TCxE", function(module, exports) {

$parcel$export(module.exports, "buildAdminSections", () => $8b2ef73b57082485$export$5f8c94ecd4c9eb76);
const $8b2ef73b57082485$export$5f8c94ecd4c9eb76 = (parent, result = [])=>{
    if (parent.sections && parent.sections.length) parent.sections.forEach((s)=>$8b2ef73b57082485$export$5f8c94ecd4c9eb76(s, result));
    if (parent.items && parent.items.length) parent.items.forEach((i)=>result.push({
            key: i.key,
            label: i.label,
            // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(event?: Event | undefined) => Promise<undefined> | undefined'.
            onClick: ()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location.href = i.linkUrl;
            }
        }));
    return result;
};

});




parcelRegister("39IeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64a25cb2d2f3121$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");

var $iHPvF = parcelRequire("iHPvF");
var $akOEX = parcelRequire("akOEX");

var $g51Bg = parcelRequire("g51Bg");

var $4Wnht = parcelRequire("4Wnht");

var $2ZGUP = parcelRequire("2ZGUP");

var $lRq8t = parcelRequire("lRq8t");

var $fgJkD = parcelRequire("fgJkD");


var $bHRpp = parcelRequire("bHRpp");

var $l1y9o = parcelRequire("l1y9o");

var $ihMtr = parcelRequire("ihMtr");
const $e64a25cb2d2f3121$var$CommandPaletteSectionMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isEmbed = (0, $ihMtr.useIsEmbed)();
    const { open: open } = (0, $g51Bg.useActionsCommandPalette)();
    const [, { setShortcutsDialogVisibility: setShortcutsDialogVisibility }] = (0, $bHRpp.useShortcutsActions)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        setShortcutsDialogVisibility(false);
        open();
    }, [
        open,
        setShortcutsDialogVisibility
    ]);
    const strong = (0, $eJOHy.useCallback)((...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            as: "strong"
        }, chunks), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        "data-testid": "shortcuts-dialog.ui.modal.section-message",
        appearance: isEmbed ? 'information' : 'discovery',
        title: isEmbed ? undefined : formatMessage((0, $l1y9o.default).dotMenuRemovalTitle),
        actions: [
            ...!isEmbed ? [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akOEX.default), {
                    key: "try-now",
                    onClick: onClick
                }, formatMessage((0, $l1y9o.default).tryNowButton))
            ] : [],
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akOEX.default), {
                key: "learn-more",
                href: "https://community.atlassian.com/t5/Jira-Command-Palette-Beta-Group/We-re-removing-Jira-s-dot-menu-to-make-way-for-a-new-and/ba-p/2754322"
            }, formatMessage((0, $l1y9o.default).learnMoreButton))
        ]
    }, formatMessage((0, $l1y9o.default).dotMenuRemovalDescription, {
        strong: strong,
        isMac: (0, $4Wnht.isMacOs)(),
        isEmbed: isEmbed
    }));
};
const $e64a25cb2d2f3121$var$ModalFooterContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        padding: "space.200"
    }, children);
const $e64a25cb2d2f3121$var$ModalFooterWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e64a25cb2d2f3121$var$ModalFooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e64a25cb2d2f3121$var$CommandPaletteSectionMessage, null));
const $e64a25cb2d2f3121$var$Modal = (props)=>{
    const { onClose: onClose } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog), {
        messageId: "shortcuts-dialog.ui.modal.modal-dialog",
        messageType: "transactional",
        width: `${(0, $f3cc79a86aceffd8$export$ee46b8a74d6c94d3)}px`,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e64a25cb2d2f3121$var$ModalFooterWrapper, null)));
};
var $e64a25cb2d2f3121$export$2e2bcd8739ae039 = $e64a25cb2d2f3121$var$Modal;

});
parcelRegister("iHPvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4a865afee94050$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $806LH = parcelRequire("806LH");

var $6J9k6 = parcelRequire("6J9k6");

var $eGOwo = parcelRequire("eGOwo");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $9y5qW = parcelRequire("9y5qW");
const $1c4a865afee94050$var$sectionMessageStyles = {
    container: "_2rkoglpi _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_19pk1i6y"
};
const $1c4a865afee94050$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $1c4a865afee94050$var$SectionMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $eJOHy.useState)(false);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        onDismiss?.();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $9y5qW.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $eJOHy.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $eJOHy.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $gt9Am.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            $1c4a865afee94050$var$sectionMessageStyles.container,
            $1c4a865afee94050$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $1c4a865afee94050$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $1c4a865afee94050$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $eGOwo.fg)('platform_ads_explicit_font_styles') && $1c4a865afee94050$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$1c4a865afee94050$var$SectionMessage.displayName = 'SectionMessage';
var $1c4a865afee94050$export$2e2bcd8739ae039 = $1c4a865afee94050$var$SectionMessage;

});
parcelRegister("9y5qW", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $1656794cf4e78acc$export$e9b82d2e21ac0c1f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ejT8C = parcelRequire("ejT8C");

var $k9Gmz = parcelRequire("k9Gmz");

var $1NG86 = parcelRequire("1NG86");

var $i4Iw4 = parcelRequire("i4Iw4");

var $3TFuO = parcelRequire("3TFuO");

var $jkYbX = parcelRequire("jkYbX");

var $eGOwo = parcelRequire("eGOwo");

const $1656794cf4e78acc$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $7bb4c1736002a04a$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $7bb4c1736002a04a$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $7bb4c1736002a04a$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $7bb4c1736002a04a$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1NG86))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $7bb4c1736002a04a$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $7bb4c1736002a04a$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($k9Gmz))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$147899de772240ec)})`
    },
    discoveryUpdated: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $7bb4c1736002a04a$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ejT8C))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$147899de772240ec)})`
    }
};
function $1656794cf4e78acc$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $1656794cf4e78acc$var$appearanceIconSchema[appearance === 'discovery' && (0, $eGOwo.fg)('platform_dst_section_message_discovery_icon') ? 'discoveryUpdated' : appearance] || $1656794cf4e78acc$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("ejT8C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cd9c4605f2f731$var$_react = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a6cd9c4605f2f731$var$_discovery = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("h4COp")));

var $a6cd9c4605f2f731$var$_note = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("94404")));
function $a6cd9c4605f2f731$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cd9c4605f2f731$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $a6cd9c4605f2f731$var$_react.default.createElement($a6cd9c4605f2f731$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $a6cd9c4605f2f731$var$_note.default
    }, props));
$a6cd9c4605f2f731$var$DiscoveryIcon.displayName = 'DiscoveryIconMigration';
var $a6cd9c4605f2f731$var$_default = module.exports.default = $a6cd9c4605f2f731$var$DiscoveryIcon;

});
parcelRegister("h4COp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6e0eaad244db33f$var$_react = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c6e0eaad244db33f$var$_baseNew = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c6e0eaad244db33f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6e0eaad244db33f$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $c6e0eaad244db33f$var$_react.default.createElement($c6e0eaad244db33f$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$c6e0eaad244db33f$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $c6e0eaad244db33f$var$_default = module.exports.default = $c6e0eaad244db33f$var$DiscoveryIcon;

});

parcelRegister("94404", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6997971b5d08dbe2$var$_react = $6997971b5d08dbe2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $6997971b5d08dbe2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6997971b5d08dbe2$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $6997971b5d08dbe2$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$6997971b5d08dbe2$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $6997971b5d08dbe2$var$_default = module.exports.default = $6997971b5d08dbe2$var$EditorNoteIcon;

});


var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';



parcelRegister("akOEX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6330b1bed100d78d$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $6qaBj = parcelRequire("6qaBj");

var $eJ9f5 = parcelRequire("eJ9f5");

var $eGOwo = parcelRequire("eGOwo");

var $lc0OY = parcelRequire("lc0OY");
var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");
const $6330b1bed100d78d$var$stylesOld = {
    common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
const $6330b1bed100d78d$var$styles = {
    common: "_11c82smr",
    anchor: "_k48pi7a9",
    pressable: "_syaz14q2 _k48p1wq8 _bfhk18uv _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $6330b1bed100d78d$var$SectionMessageAction = /*#__PURE__*/ (0, $eJOHy.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }) {
    if (!linkComponent && (0, $eGOwo.fg)('platform_section_message_action_migration')) {
        if (href) {
            if ((0, $eGOwo.fg)('platform_dst_section_message_actions_as_link')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    $6330b1bed100d78d$var$styles.common,
                    $6330b1bed100d78d$var$styles.anchor
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                    testId: testId,
                    onClick: onClick,
                    href: href,
                    target: target,
                    children: children
                })
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
                testId: testId,
                onClick: onClick,
                href: href,
                xcss: (0, $6qaBj.cx)($6330b1bed100d78d$var$stylesOld.common, $6330b1bed100d78d$var$stylesOld.anchor),
                children: children
            });
        }
        if (onClick) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $6qaBj.cx)((0, $eGOwo.fg)('platform_dst_section_message_actions_as_link') ? $6330b1bed100d78d$var$styles.common : $6330b1bed100d78d$var$stylesOld.common, (0, $eGOwo.fg)('platform_dst_section_message_actions_as_link') ? $6330b1bed100d78d$var$styles.pressable : $6330b1bed100d78d$var$stylesOld.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "span",
            testId: testId,
            xcss: (0, $eGOwo.fg)('platform_dst_section_message_actions_as_link') && $6330b1bed100d78d$var$styles.common,
            children: children
        });
    }
    return onClick || href ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: children
    });
});
var $6330b1bed100d78d$export$2e2bcd8739ae039 = $6330b1bed100d78d$var$SectionMessageAction;

});

const $f3cc79a86aceffd8$export$ee46b8a74d6c94d3 = 360;
const $f3cc79a86aceffd8$export$c09f4880e00b72de = 'component';

parcelRegister("l1y9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d9909d34cef2282$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5d9909d34cef2282$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    sunsetDotMenuWarningTitle: {
        "id": "shortcuts-dialog.modal.sunset-dot-menu-warning-title",
        "defaultMessage": "We\u2019re removing the dot menu"
    },
    sunsetDotMenuWarningDescription: {
        "id": "shortcuts-dialog.modal.sunset-dot-menu-warning-description",
        "defaultMessage": "From August 19, we\u2019ll remove this menu to make way for an improved command palette. Press <strong>{isMac, select, true {Cmd + K} other {Ctrl + K}}</strong> on your keyboard to try it now."
    },
    tryNowButton: {
        "id": "shortcuts-dialog.modal.sunset-dot-menu-warning-try-now-button",
        "defaultMessage": "Try now"
    },
    learnMoreButton: {
        "id": "shortcuts-dialog.modal.sunset-dot-menu-warning-learn-more-button",
        "defaultMessage": "Why remove the dot menu?"
    },
    dotMenuRemovalTitle: {
        "id": "shortcuts-dialog.modal.dot-menu-removal-title",
        "defaultMessage": "Try the improved command palette"
    },
    dotMenuRemovalDescription: {
        "id": "shortcuts-dialog.modal.dot-menu-removal-description",
        "defaultMessage": "We removed the dot menu to make way for the command palette.{isEmbed, select, true {} other { Press <strong>{isMac, select, true {Cmd + K} other {Ctrl + K}}</strong> on your keyboard to try it now.}}"
    }
});

});

parcelRegister("ihMtr", function(module, exports) {

$parcel$export(module.exports, "useIsEmbed", () => $f52315bb192282bc$export$ce94463dec1ccebd);

var $gCY1z = parcelRequire("gCY1z");
const $f52315bb192282bc$export$ce94463dec1ccebd = ()=>{
    const [{ location: { pathname: pathname } }] = (0, $gCY1z.useRouter)();
    if (pathname.endsWith('/embed')) return true;
    return false;
};

});



parcelRegister("fYLvG", function(module, exports) {

$parcel$export(module.exports, "FlagIssueWithCommentModal", () => $fb8f752efded3b1d$export$dc5402e0014db7d2);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $clRM1 = parcelRequire("clRM1");

var $cystD = parcelRequire("cystD");

var $bbdV2 = parcelRequire("bbdV2");

var $1KdDN = parcelRequire("1KdDN");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $bILK0 = parcelRequire("bILK0");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $eKTwj = parcelRequire("eKTwj");

var $fAZgY = parcelRequire("fAZgY");

var $i4oKI = parcelRequire("i4oKI");

var $5Cee0 = parcelRequire("5Cee0");

var $61eWR = parcelRequire("61eWR");
const $fb8f752efded3b1d$var$entryPointParams = {};
const $fb8f752efded3b1d$var$FlagIssueWithCommentModalBase = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $eKTwj.asyncFlagWithCommentModal), $fb8f752efded3b1d$var$entryPointParams);
    const [initialized, setInitialized] = (0, $eJOHy.useState)(false);
    const [{ flagAction: flagAction, issues: issues, forcePreload: forcePreload, callback: callback, analyticsArgs: analyticsArgs }, { close: close }] = (0, $i4oKI.useFlagIssueModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    (0, $eJOHy.useEffect)(()=>{
        if (forcePreload && !initialized) {
            setInitialized(true);
            entryPointActions.preload();
        }
    }, [
        entryPointActions,
        forcePreload,
        initialized
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (flagAction !== undefined) {
            entryPointActions.load();
            if (!initialized) setInitialized(true);
        } else if (initialized) entryPointActions.unload();
    }, [
        flagAction,
        initialized,
        entryPointActions
    ]);
    const issueIds = (0, $eJOHy.useMemo)(()=>issues.map(({ issueId: issueId })=>issueId), [
        issues
    ]);
    // Not using issueIds from modal because it is number[] where they should be IssueId[]
    const handleSaveWithComment = (0, $eJOHy.useCallback)(async (_, flag, comment)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const extendedAnalyticsArgs = {
            hasComment: !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(comment, (0, $clRM1.getEmptyADF)()),
            ...analyticsArgs
        };
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'confirmButton', extendedAnalyticsArgs);
        close();
        try {
            await (0, $5Cee0.saveFlagWithComment)(issueIds, flag, comment);
            analyticsEvent.update({
                action: 'flagged',
                actionSubject: 'cards'
            });
            (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'cards flagged', {
                ...extendedAnalyticsArgs,
                numCards: issueIds.length,
                flagAction: flag ? 'added' : 'removed'
            });
            if (extendedAnalyticsArgs.hasComment && (0, $7jTnu.fg)('jira_task_off_track_experiment_popup_kill_switch')) {
                const cardsFlaggedCommentAnalyticsEvent = createAnalyticsEvent({
                    actionSubject: 'cards',
                    action: 'flagged_comment'
                });
                (0, $gCeeo.fireTrackAnalytics)(cardsFlaggedCommentAnalyticsEvent, 'cards flagged_comment', {
                    ...extendedAnalyticsArgs,
                    numCards: issueIds.length,
                    flagAction: flag ? 'added' : 'removed'
                });
            }
            if (callback) callback({
                issueIds: issueIds,
                flag: flag,
                comment: comment
            });
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Unknown error');
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'jira.addCommentOnFlagSaveAction',
                    packageName: 'jiraSoftwareAddIssueFlagWithComment',
                    teamName: 'deliveroo'
                }
            });
            const addFlagTitle = (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $61eWR.messages).addFlagFailedTitleIssueTermRefresh : (0, $61eWR.messages).addFlagFailedTitle;
            const removeFlagTitle = (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $61eWR.messages).removeFlagFailedTitleIssueTermRefresh : (0, $61eWR.messages).removeFlagFailedTitle;
            showFlag({
                key: 'flag-issue-with-comment-modal-error',
                type: 'error',
                title: flag ? addFlagTitle : removeFlagTitle,
                description: flag ? (0, $61eWR.messages).addFlagFailedDescription : (0, $61eWR.messages).removeFlagFailedDescription,
                messageId: 'software-add-issue-flag-with-comment.ui.show-flag.error',
                messageType: 'transactional'
            });
        }
    }, [
        createAnalyticsEvent,
        analyticsArgs,
        close,
        issueIds,
        callback,
        showFlag
    ]);
    const handleOnClose = (0, $fAZgY.useCallbackWithCondition)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'cancelButton', {
            ...analyticsArgs
        });
        close();
    }, [
        analyticsArgs,
        close,
        createAnalyticsEvent
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const modalProps = (0, $fAZgY.useMemoWithCondition)(()=>({
            flagAction: flagAction,
            cards: issues.map(({ issueId: issueId, issueKey: issueKey, summary: summary, type: type })=>({
                    id: +issueId,
                    key: issueKey,
                    summary: summary ?? '',
                    type: type
                })),
            onClose: handleOnClose,
            onFlagWithComment: handleSaveWithComment
        }), [
        flagAction,
        handleOnClose,
        handleSaveWithComment,
        issues
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cystD.ModalEntryPointContainer), {
        entryPointActions: entryPointActions,
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "flag-issue-with-comment-modal",
        packageName: "jira-software-add-issue-flag-with-comment",
        runtimeProps: modalProps
    });
};
const $fb8f752efded3b1d$export$dc5402e0014db7d2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jira-software-add-issue-flag-with-comment-entrypoint",
        packageName: "JiraSoftwareAddIssueFlagWithComment",
        fallback: "unmount",
        teamName: "deliveroo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb8f752efded3b1d$var$FlagIssueWithCommentModalBase, null));

});
parcelRegister("clRM1", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $5304529a0b87b9ee$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $i429R = parcelRequire("i429R");
const $5304529a0b87b9ee$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("i429R", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $f633a00593707962$export$dd1bc94b04021eeb);
const $f633a00593707962$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("eKTwj", function(module, exports) {

$parcel$export(module.exports, "asyncFlagWithCommentModal", () => $7f09dd798a097e95$export$58c94fab0d44ad1);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7f09dd798a097e95$export$58c94fab0d44ad1 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bwhXV")).then((module)=>module.CommentOnFlaggingUnflaggingEntryPoint), {
        moduleId: "265517b7",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bwhXV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("ljkCm")
]).then(()=>parcelRequire('hYKFX'));

});


parcelRegister("i4oKI", function(module, exports) {

$parcel$export(module.exports, "useFlagIssueModal", () => $7e66fc1c9ef33e58$export$db07b3fff1829cc2);
$parcel$export(module.exports, "useFlagIssueModalActions", () => $7e66fc1c9ef33e58$export$9c426adea6bff2be);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9jZyg = parcelRequire("9jZyg");
const $7e66fc1c9ef33e58$var$initialState = {
    forcePreload: false,
    issues: [],
    flagAction: undefined
};
const $7e66fc1c9ef33e58$var$store = (0, $GtRbT.createStore)({
    initialState: $7e66fc1c9ef33e58$var$initialState,
    actions: $9jZyg.actions,
    name: 'flagIssueModalStore'
});
const $7e66fc1c9ef33e58$export$db07b3fff1829cc2 = (0, $iJq0l.createHook)($7e66fc1c9ef33e58$var$store);
const $7e66fc1c9ef33e58$export$9c426adea6bff2be = (0, $iJq0l.createActionsHook)($7e66fc1c9ef33e58$var$store);

});
parcelRegister("9jZyg", function(module, exports) {

$parcel$export(module.exports, "actions", () => $dc8c86d4d6a850de$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $dc8c86d4d6a850de$var$open = ({ issues: issues, flagAction: flagAction, callback: callback, source: source, analyticsArgs: analyticsArgs })=>({ setState: setState })=>{
        const newState = {
            issues: issues,
            flagAction: flagAction,
            callback: callback,
            analyticsArgs: {
                source: source,
                ...analyticsArgs
            }
        };
        setState(newState);
    };
const $dc8c86d4d6a850de$var$close = ()=>({ setState: setState })=>{
        setState({
            issues: [],
            flagAction: undefined,
            callback: undefined,
            analyticsArgs: undefined
        });
    };
const $dc8c86d4d6a850de$var$preload = ()=>({ setState: setState, getState: getState })=>{
        const { forcePreload: forcePreload } = getState();
        if (!forcePreload) setState({
            forcePreload: true
        });
    };
const $dc8c86d4d6a850de$export$e324594224ef24da = {
    open: $dc8c86d4d6a850de$var$open,
    close: $dc8c86d4d6a850de$var$close,
    preload: $dc8c86d4d6a850de$var$preload
};

});


parcelRegister("5Cee0", function(module, exports) {

$parcel$export(module.exports, "saveFlagWithComment", () => $1ccd73e3541c8ea4$export$59f88df61be59073);

var $1uIew = parcelRequire("1uIew");

var $7AheX = parcelRequire("7AheX");
const $1ccd73e3541c8ea4$export$3ae968343ffb0d2b = '/rest/greenhopper/3/xboard/issue/flag/flag';
const $1ccd73e3541c8ea4$var$noContentStatus = 204;
const $1ccd73e3541c8ea4$export$59f88df61be59073 = (issueKeys, flag, comment)=>fetch($1ccd73e3541c8ea4$export$3ae968343ffb0d2b, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            issueKeys: issueKeys,
            flag: flag,
            comment: comment,
            commentProperty: '',
            commentVisibility: ''
        })
    }).then((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = (0, $7AheX.getTraceId)(response);
            if (traceId != null && traceId !== '') throw new (0, $1uIew.default)(status, `Fetch call failed with status code: ${status}`, traceId);
            else throw new (0, $1uIew.default)(status);
        }
        if (response.status === $1ccd73e3541c8ea4$var$noContentStatus) return null;
        return response.text().then((body)=>{
            const result = body ? JSON.parse(body) : null;
            if (result) {
                const errorMessage = result.errorMessages ? result.errorMessages.join(', ') : 'Unidentified error when saving flag with comment';
                throw new Error(errorMessage);
            }
            return null;
        });
    });

});

parcelRegister("61eWR", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bf8d5ae7faea47f3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $bf8d5ae7faea47f3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    addFlagFailedTitle: {
        "id": "software-add-issue-flag-with-comment.add-flag-failed-title",
        "defaultMessage": "We couldn't flag this issue"
    },
    addFlagFailedDescription: {
        "id": "software-add-issue-flag-with-comment.add-flag-failed-description",
        "defaultMessage": "Check your connection and try adding the flag again."
    },
    removeFlagFailedTitle: {
        "id": "software-add-issue-flag-with-comment.remove-flag-failed-title",
        "defaultMessage": "We couldn't remove the flag from this issue"
    },
    removeFlagFailedDescription: {
        "id": "software-add-issue-flag-with-comment.remove-flag-failed-description",
        "defaultMessage": "Check your connection and try removing the flag again."
    },
    addFlagFailedTitleIssueTermRefresh: {
        "id": "software-add-issue-flag-with-comment.add-flag-failed-title-issue-term-refresh",
        "defaultMessage": "We couldn't flag this work item"
    },
    removeFlagFailedTitleIssueTermRefresh: {
        "id": "software-add-issue-flag-with-comment.remove-flag-failed-title-issue-term-refresh",
        "defaultMessage": "We couldn't remove the flag from this work item"
    }
});

});


parcelRegister("bchQI", function(module, exports) {

$parcel$export(module.exports, "AsyncEnforceStorageLimitsModal", () => $1537b15be90a02a3$export$319be76441a339a9);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $9vzoN = parcelRequire("9vzoN");

var $cystD = parcelRequire("cystD");

var $bbdV2 = parcelRequire("bbdV2");

var $9IqQp = parcelRequire("9IqQp");

var $kEUB1 = parcelRequire("kEUB1");

var $gZTP9 = parcelRequire("gZTP9");


var $jZn5j = parcelRequire("jZn5j");


var $iAKFB = parcelRequire("iAKFB");

var $7P5Hx = parcelRequire("7P5Hx");
const $1537b15be90a02a3$export$319be76441a339a9 = ()=>{
    // We can optimise and not show the modal if the user is not on the free edition
    const isFreeEdition = (0, $9IqQp.useIsJswFreeEdition)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    if (!isFreeEdition || !isAdmin) return null;
    if ((0, $7jTnu.fg)('jsw_storage_limits_billing_admin_api_check')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1537b15be90a02a3$var$AsyncEnforceStorageLimitsModalWithAPI, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1537b15be90a02a3$var$AsyncEnforceStorageLimitsModalWithTraits, null);
};
const $1537b15be90a02a3$var$AsyncEnforceStorageLimitsModalWithTraits = ()=>{
    // We can optimise and not show the modal if the user is not on the free edition
    const isFreeEdition = (0, $9IqQp.useIsJswFreeEdition)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const { canUpgradeAndPay: canUpgradeAndPay, loading: isBillingPermissionsLoading } = (0, $9vzoN.useCanUpgradeAndPayForJswFree)({
        caller: (0, $808bbaf5f2b41f58$export$b8b9d90f9e5bd72b),
        billingAdminCheckMethod: 'traits'
    });
    // Note this API call will fire for both experiment and control cohorts
    // since it defines the cohort for the user
    const { jswStorageRatio: jswStorageRatio, jswStorageLimit: jswStorageLimit } = (0, $7P5Hx.useJswStorageUsage)({
        // API 403s for non-admins or without the manage billing permission
        skip: !isFreeEdition || !isAdmin || !canUpgradeAndPay
    });
    const hasReachedStorageRatioThreshold = jswStorageRatio && jswStorageRatio > (0, $bd8c18773efdb1c7$export$dada91eca2d214e9);
    if (!isFreeEdition || // usage limit & storage ratio are undefined if the request fails or not fetched yet
    !jswStorageLimit || !hasReachedStorageRatioThreshold || isBillingPermissionsLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1537b15be90a02a3$export$cfe1392b5c9b528f, {
        jswStorageRatio: jswStorageRatio,
        jswStorageLimit: jswStorageLimit,
        canUpgradeAndPay: Boolean(canUpgradeAndPay),
        offeringName: "standard",
        shouldFetchWithOfferingName: (0, $7jTnu.fg)('twc_jira_touchpoint_fix')
    });
};
const $1537b15be90a02a3$var$AsyncEnforceStorageLimitsModalWithAPI = ()=>{
    // Note this API call will fire for both experiment and control cohorts
    // since it defines the cohort for the user
    const { jswStorageRatio: jswStorageRatio, jswStorageLimit: jswStorageLimit } = (0, $7P5Hx.useJswStorageUsage)({
        skip: false
    });
    const hasReachedStorageRatioThreshold = jswStorageRatio && jswStorageRatio > (0, $bd8c18773efdb1c7$export$dada91eca2d214e9);
    const { canUpgradeAndPay: canUpgradeAndPay, loading: isBillingPermissionsLoading } = (0, $9vzoN.useCanUpgradeAndPayForJswFree)({
        caller: (0, $808bbaf5f2b41f58$export$b8b9d90f9e5bd72b),
        billingAdminCheckMethod: 'ccpApi',
        skip: !jswStorageLimit || !hasReachedStorageRatioThreshold
    });
    if (// usage limit & storage ratio are undefined if the request fails or not fetched yet
    !jswStorageLimit || !hasReachedStorageRatioThreshold || isBillingPermissionsLoading || !canUpgradeAndPay) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1537b15be90a02a3$export$cfe1392b5c9b528f, {
        jswStorageRatio: jswStorageRatio,
        jswStorageLimit: jswStorageLimit,
        canUpgradeAndPay: Boolean(canUpgradeAndPay),
        offeringName: "standard",
        shouldFetchWithOfferingName: (0, $7jTnu.fg)('twc_jira_touchpoint_fix')
    });
};
const $1537b15be90a02a3$export$cfe1392b5c9b528f = ({ jswStorageRatio: jswStorageRatio, jswStorageLimit: jswStorageLimit, canUpgradeAndPay: canUpgradeAndPay })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $iAKFB.enforceStorageLimitsModalEntryPoint), {
        cloudId: cloudId,
        // JSW productKey (experiment is JSW only)
        productKey: 'jira-software.ondemand',
        // Default user to JSW Standard plan
        // JSW Standard offeringKey
        // @see: https://stash.atlassian.com/projects/CCP/repos/billing-console/browse/packages/bac/components/product-offerings/src/service/data/jira-software/index.ts#21
        offeringKey: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526'
    });
    const [{ isOpen: isOpen }, { setIsOpen: setIsOpen }] = (0, $jZn5j.useEnforceStorageModal)();
    const enforceStorageLimitsModalProps = (0, $eJOHy.useMemo)(()=>({
            onClose: ()=>{
                setIsOpen({
                    isOpen: 'closed',
                    touchpoint: undefined
                });
            },
            jswStorageRatio: jswStorageRatio,
            jswStorageLimit: jswStorageLimit,
            canUpgradeAndPay: canUpgradeAndPay,
            offeringName: 'standard',
            shouldFetchWithOfferingName: (0, $7jTnu.fg)('twc_jira_touchpoint_fix')
        }), [
        jswStorageRatio,
        jswStorageLimit,
        canUpgradeAndPay,
        setIsOpen
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        // Note relay is smart enough not to re-fetch the chunk if it's already loaded
        // @todo: would be great if we didn't need isOpen and be able to load() directly from sweet state
        if (isOpen === 'open') entryPointActions.load();
    }, [
        entryPointActions,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cystD.ModalEntryPointContainer), {
        id: "async-enforce-storage-limits-modal",
        packageName: (0, $808bbaf5f2b41f58$export$b8b9d90f9e5bd72b),
        teamName: "jlove-makkuro",
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        errorFallback: "unmount",
        runtimeProps: enforceStorageLimitsModalProps
    });
};

});
parcelRegister("9vzoN", function(module, exports) {

$parcel$export(module.exports, "useCanUpgradeAndPayForJswFree", () => $96ea068b2fc749e4$export$f4f07d855739fba1);
$parcel$export(module.exports, "useCanUpgradeAndPayForCurrentProduct", () => $96ea068b2fc749e4$export$2e34435b19772971);
$parcel$export(module.exports, "useCanProductUserUpgradeAndPay", () => $96ea068b2fc749e4$export$53827a0ff095f14b);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $kFw1p = parcelRequire("kFw1p");

var $gYnSx = parcelRequire("gYnSx");

var $gvwWc = parcelRequire("gvwWc");

var $jGzN3 = parcelRequire("jGzN3");

var $lFovQ = parcelRequire("lFovQ");


var $figsJ = parcelRequire("figsJ");

var $lvKO5 = parcelRequire("lvKO5");


var $1Y19S = parcelRequire("1Y19S");
const $96ea068b2fc749e4$var$fetchEntitlementDetails = (entitlementId)=>(0, $jGzN3.performGetRequest)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $96ea068b2fc749e4$var$fetchBillingAdmins = (transactionAccountId)=>(0, $jGzN3.performGetRequest)('/gateway/api/ccp/api/v1/billing-admins', {
        headers: {
            'Content-Type': 'application/json',
            'X-transaction-account': transactionAccountId
        }
    });
const $96ea068b2fc749e4$export$2abcbc88aea6e581 = (0, $LFmXM.default)($96ea068b2fc749e4$var$fetchEntitlementDetails);
const $96ea068b2fc749e4$export$294eed4c864e0f71 = (0, $LFmXM.default)($96ea068b2fc749e4$var$fetchBillingAdmins);
const $96ea068b2fc749e4$export$f4f07d855739fba1 = ({ caller: caller, skip: skip = false, billingAdminCheckMethod: billingAdminCheckMethod = 'traits' })=>{
    const [canUpgradeAndPay, setCanUpgradeAndPay] = (0, $eJOHy.useState)(undefined);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(undefined);
    const [ineligibilityReason, setIneligibilityReason] = (0, $eJOHy.useState)(undefined);
    const { isSiteAdmin: isSiteAdmin, cloudId: cloudId, atlassianAccountId: atlassianAccountId, productEntitlementDetails: productEntitlementDetails } = (0, $lvKO5.useTenantContext)();
    const { fetch: fetch, error: personalizationApiError } = (0, $lFovQ.useSiteUserPersonalization)();
    const isBillingSystemCcp = productEntitlementDetails?.[0, $e08dff4ae358d899$export$1346c9aa3cbb477d]?.billingSourceSystem === 'CCP';
    const entitlementId = productEntitlementDetails?.[0, $e08dff4ae358d899$export$1346c9aa3cbb477d]?.entitlementId;
    const checkIsCcpBillingAdmin = (0, $eJOHy.useCallback)(async ()=>{
        if (!entitlementId) throw new Error('Empty entitlementId');
        if (!atlassianAccountId) throw new Error('Empty atlassianAccountId');
        // CCP API approach
        if (billingAdminCheckMethod === 'ccpApi') {
            const entitlementDetails = await $96ea068b2fc749e4$export$2abcbc88aea6e581(entitlementId);
            const transactionAccountId = entitlementDetails?.transactionAccountId;
            const billingAdminsResponse = await $96ea068b2fc749e4$export$294eed4c864e0f71(transactionAccountId);
            const isBillingAdmin = !!billingAdminsResponse?.data?.find(({ id: id = null })=>id === atlassianAccountId);
            return isBillingAdmin;
        }
        // Traits approach
        const personalizationData = await fetch({
            cloudId: cloudId,
            userId: atlassianAccountId
        });
        if (!personalizationData) return undefined;
        const isBillingAdmin = personalizationData.find((trait)=>trait.name === (0, $f642f2d48423122a$export$3aad3de2cc377789) && trait.value === true) !== undefined;
        return isBillingAdmin;
    }, [
        atlassianAccountId,
        billingAdminCheckMethod,
        cloudId,
        entitlementId,
        fetch
    ]);
    /**
	 * This `useEffect` performs the permission checks.
	 */ (0, $eJOHy.useEffect)(()=>{
        if (skip) return;
        setLoading(true);
        // Only logged in site admins can upgrade
        if (isSiteAdmin) {
            if (isBillingSystemCcp) // On CCP, only billing admins can manage billing
            checkIsCcpBillingAdmin().then((isBillingAdmin)=>{
                setCanUpgradeAndPay(isBillingAdmin);
                // Empty ineligibilityReason marks that the requisites were checked
                setIneligibilityReason(isBillingAdmin ? '' : 'not a billing admin');
            }).catch((e)=>{
                setError(e);
                setIneligibilityReason('error checking eligibility');
            }).finally(()=>{
                setLoading(false);
            });
            else {
                // On HAMS, site admins can also manage billing
                setCanUpgradeAndPay(true);
                setLoading(false);
                // Empty ineligibilityReason marks that the requisites were checked
                setIneligibilityReason('');
            }
        } else {
            setCanUpgradeAndPay(false);
            setLoading(false);
            setIneligibilityReason('not a site admin');
        }
    }, [
        atlassianAccountId,
        caller,
        checkIsCcpBillingAdmin,
        isBillingSystemCcp,
        isSiteAdmin,
        skip
    ]);
    /**
	 * Errors from the Traits API are not thrown. Instead, they are stored in the `error` field from `useSiteUserPersonalization`.
	 * Since we can't catch those errors, we need to listen for changes to that `error` field and update our own "error" state accordingly.
	 */ (0, $eJOHy.useEffect)(()=>{
        if (personalizationApiError) setError(personalizationApiError);
    }, [
        personalizationApiError
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (error) (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'useCanUpgradeAndPayForJswFree',
                packageName: (0, $f642f2d48423122a$export$b8b9d90f9e5bd72b),
                teamName: 'growth-tako'
            },
            attributes: {
                billingSourceSystem: isBillingSystemCcp ? 'CCP' : 'HAMS',
                caller: caller,
                billingAdminCheckMethod: billingAdminCheckMethod
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error,
        isBillingSystemCcp,
        caller,
        billingAdminCheckMethod
    ]);
    return {
        canUpgradeAndPay: canUpgradeAndPay,
        loading: loading,
        error: error,
        ineligibilityReason: ineligibilityReason
    };
};
const $96ea068b2fc749e4$export$2e34435b19772971 = ({ caller: caller, skip: skip = false })=>{
    const [canUpgradeAndPay, setCanUpgradeAndPay] = (0, $eJOHy.useState)(undefined);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(undefined);
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const subProduct = (0, $figsJ.useSubProduct)();
    const explicitlyLicensedProducts = (0, $kFw1p.default)(tenantContext);
    const applicationKey = (0, $gvwWc.getProductKey)(subProduct, explicitlyLicensedProducts);
    (0, $eJOHy.useEffect)(()=>{
        if (skip) return;
        if (!applicationKey) {
            setError(new Error('Empty applicationKey'));
            return;
        }
        const isBillingSystemCcp = tenantContext.productEntitlementDetails?.[applicationKey]?.billingSourceSystem === 'CCP';
        const entitlementId = tenantContext.productEntitlementDetails?.[applicationKey]?.entitlementId;
        const checkIsCcpBillingAdmin = async ()=>{
            if (!entitlementId) throw new Error('Empty entitlementId');
            if (!tenantContext.atlassianAccountId) throw new Error('Empty atlassianAccountId');
            const entitlementDetails = await $96ea068b2fc749e4$export$2abcbc88aea6e581(entitlementId);
            const transactionAccountId = entitlementDetails?.transactionAccountId;
            const billingAdminsResponse = await $96ea068b2fc749e4$export$294eed4c864e0f71(transactionAccountId);
            const isBillingAdmin = billingAdminsResponse?.data?.some(({ id: id = null })=>id === tenantContext.atlassianAccountId) ?? false;
            return isBillingAdmin;
        };
        setLoading(true);
        // Only logged in site admins can upgrade
        if (tenantContext.isSiteAdmin && tenantContext.atlassianAccountId) {
            if (isBillingSystemCcp) // On CCP, only billing admins can manage billing
            checkIsCcpBillingAdmin().then((isBillingAdmin)=>{
                setCanUpgradeAndPay(isBillingAdmin);
            }).catch((e)=>{
                setError(e);
                (0, $gYnSx.default)({
                    error: e,
                    meta: {
                        id: 'useCanUpgradeAndPayForCurrentProduct',
                        packageName: (0, $f642f2d48423122a$export$b8b9d90f9e5bd72b),
                        teamName: 'growth-tako'
                    },
                    attributes: {
                        billingSourceSystem: isBillingSystemCcp ? 'CCP' : 'HAMS',
                        caller: caller,
                        subProduct: subProduct,
                        applicationKey: applicationKey,
                        licensedProducts: tenantContext.licensedProducts,
                        productEntitlementDetails: tenantContext.productEntitlementDetails
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                setLoading(false);
            });
            else {
                // On HAMS, site admins can also manage billing
                setCanUpgradeAndPay(true);
                setLoading(false);
            }
        } else {
            setCanUpgradeAndPay(false);
            setLoading(false);
        }
    }, [
        applicationKey,
        caller,
        skip,
        subProduct,
        tenantContext.atlassianAccountId,
        tenantContext.isSiteAdmin,
        tenantContext.licensedProducts,
        tenantContext.productEntitlementDetails
    ]);
    return {
        canUpgradeAndPay: canUpgradeAndPay,
        loading: loading,
        error: error
    };
};
function $96ea068b2fc749e4$export$53827a0ff095f14b({ skip: skip, productKey: productKey }) {
    const { data: data, isLoading: isLoading, error: error, fetch: fetchCanProductUserUpgradeAndPay } = (0, $1Y19S.useCanProductUserUpgradeAndPayQuery)();
    (0, $eJOHy.useEffect)(()=>{
        if (skip || !productKey) return;
        fetchCanProductUserUpgradeAndPay(productKey);
    }, [
        fetchCanProductUserUpgradeAndPay,
        productKey,
        skip
    ]);
    const canProductUserUpgradeAndPay = data?.canProductUserUpgradeAndPay;
    const isProductUserBillingAdmin = data?.isBillingAdmin;
    const hasPaymentDetailsOnFile = data?.hasPaymentDetailsOnFile;
    return {
        isProductUserBillingAdmin: isProductUserBillingAdmin,
        canProductUserUpgradeAndPay: canProductUserUpgradeAndPay,
        hasPaymentDetailsOnFile: hasPaymentDetailsOnFile,
        isLoading: isLoading,
        error: error
    };
}

});
const $e08dff4ae358d899$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $e08dff4ae358d899$export$e9c56aa3b027d98f = 'jira-customer-service';
const $e08dff4ae358d899$export$1346c9aa3cbb477d = 'jira-software';
const $e08dff4ae358d899$export$202f50ee62667e32 = 'jira-product-discovery';
const $e08dff4ae358d899$export$db515c8cec1e6f79 = 'jira-core';
const $e08dff4ae358d899$export$c811f21c9ad05dc2 = 'confluence';
const $e08dff4ae358d899$export$961148c98d198270 = 'opsgenie';

const $f642f2d48423122a$export$3aad3de2cc377789 = 'jira_software_free_is_ccp_billing_admins';
const $f642f2d48423122a$export$b8b9d90f9e5bd72b = 'jiraBilling';

parcelRegister("1Y19S", function(module, exports) {

$parcel$export(module.exports, "useCanProductUserUpgradeAndPayQuery", () => $3edd9f073631159d$export$44d5ccfd376c6700);

var $5wi2Y = parcelRequire("5wi2Y");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kEUB1 = parcelRequire("kEUB1");
const $3edd9f073631159d$export$62297b13309008b2 = (0, $5wi2Y.default);
const $3edd9f073631159d$export$44d5ccfd376c6700 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const relayEnvironment = (0, $j4oe4.useRelayEnvironment)();
    const [data, setData] = (0, $eJOHy.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const fetch = (0, $eJOHy.useCallback)((productKey)=>{
        setIsLoading(true);
        const variables = {
            cloudId: cloudId,
            productKey: productKey
        };
        (0, $j4oe4.fetchQuery)(relayEnvironment, $3edd9f073631159d$export$62297b13309008b2, variables, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            complete: ()=>{
                setIsLoading(false);
            },
            next: (response)=>{
                // Endpoint takes in an array of cloudIds, but we never call this with more than one cloudId
                const entitlement = response?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
                const canPay = entitlement?.transactionAccount?.experienceCapabilities?.addPaymentMethodV2?.isAvailableToUser;
                const canUpgrade = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
                const isCurrentUserBillingAdmin = entitlement?.transactionAccount?.isCurrentUserBillingAdmin;
                const canUpgradeAndPay = canUpgrade && canPay;
                const invoiceable = entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable;
                setData({
                    canProductUserUpgradeAndPay: canUpgradeAndPay ?? false,
                    isBillingAdmin: isCurrentUserBillingAdmin ?? false,
                    hasPaymentDetailsOnFile: invoiceable
                });
            },
            error: (fetchError)=>{
                setIsLoading(false);
                setError(fetchError);
            }
        });
    }, [
        cloudId,
        relayEnvironment
    ]);
    return {
        fetch: fetch,
        data: data,
        isLoading: isLoading,
        error: error
    };
};

});
parcelRegister("5wi2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $be4e2c492f92aa96$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d6accdd1a0947a34d36303b2570ed070>>
 * @relayHash c6c2ef5f8d187832473178df5aafec6f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c564445c477dbce6d341491b08786fb2217b8015660fbe2bf38ed31c3ba12ec
const $be4e2c492f92aa96$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v5 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v6 /*: any*/ ,
        v4 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCanProductUserUpgradeAndPayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.isCurrentUserBillingAdmin"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "addPaymentMethodV2",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.experienceCapabilities.addPaymentMethodV2.isAvailableToUser"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "tenantContexts.entitlementInfo.entitlement.experienceCapabilities.changeOfferingV2.isAvailableToUser"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCanProductUserUpgradeAndPayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "addPaymentMethodV2",
                                                            "plural": false,
                                                            "selections": v7 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v9 /*: any*/ ,
                                                                    "type": "CcpInvoiceGroup"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": v7 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0c564445c477dbce6d341491b08786fb2217b8015660fbe2bf38ed31c3ba12ec",
            "metadata": {},
            "name": "useCanProductUserUpgradeAndPayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$be4e2c492f92aa96$var$node.hash = "1907c25c52beb71d551bc795f9cb5c76";
var $be4e2c492f92aa96$export$2e2bcd8739ae039 = $be4e2c492f92aa96$var$node;

});



parcelRegister("9IqQp", function(module, exports) {

$parcel$export(module.exports, "useIsJswFreeEdition", () => $f2d70df039628fb2$export$caad10020a17bf56);

var $eJOHy = parcelRequire("eJOHy");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");
const $f2d70df039628fb2$export$caad10020a17bf56 = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    return (0, $eJOHy.useMemo)(()=>appEditions.software === (0, $a9ldn.FREE_EDITION), [
        appEditions
    ]);
};

});

const $808bbaf5f2b41f58$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $808bbaf5f2b41f58$export$ed785d2382d0101d = 'lastStorageEnforcement';

parcelRegister("jZn5j", function(module, exports) {

$parcel$export(module.exports, "useEnforceStorageModal", () => $bad0976bbaba6118$export$56beb4c2629d6615);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $g7tOu = parcelRequire("g7tOu");
const $bad0976bbaba6118$var$initialState = {
    isOpen: 'closed',
    touchpoint: undefined
};
const $bad0976bbaba6118$var$store = (0, $GtRbT.createStore)({
    name: 'jsw-enforce-storage-limit-modal',
    initialState: $bad0976bbaba6118$var$initialState,
    actions: $g7tOu.actions
});
const $bad0976bbaba6118$export$56beb4c2629d6615 = (0, $iJq0l.createHook)($bad0976bbaba6118$var$store);

});
parcelRegister("g7tOu", function(module, exports) {

$parcel$export(module.exports, "actions", () => $b8453a12c9cd3eae$export$e324594224ef24da);

var $lyS1F = parcelRequire("lyS1F");
const $b8453a12c9cd3eae$export$e324594224ef24da = {
    setIsOpen: $lyS1F.setIsOpen
};

});
parcelRegister("lyS1F", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $a4cda3271be449bf$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a4cda3271be449bf$export$dcf23146e0a40195 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };

});



const $bd8c18773efdb1c7$export$dada91eca2d214e9 = 1;

parcelRegister("iAKFB", function(module, exports) {

$parcel$export(module.exports, "enforceStorageLimitsModalEntryPoint", () => $e984a15525bc0d4d$export$9dc1f3d91d81486);

var $jsnfV = parcelRequire("jsnfV");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $7jTnu = parcelRequire("7jTnu");

const $e984a15525bc0d4d$export$9dc1f3d91d81486 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("e82lD")), {
        moduleId: "0c63b578",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey, offeringKey: offeringKey })=>({
            queries: {
                changeOffering: {
                    parameters: $jsnfV.default,
                    variables: {
                        cloudId: cloudId,
                        productKey: productKey,
                        offeringKey: offeringKey,
                        offeringName: 'standard',
                        shouldFetchWithOfferingName: (0, $7jTnu.fg)('twc_jira_touchpoint_fix')
                    }
                }
            }
        })
});

});
parcelRegister("jsnfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $65bc1099dcbbe16a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7daace8f267fe55d2b7f838342e406e3>>
 * @relayHash 96222d8226cccbd78f5bbac05a7fe1dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67de40a7489846e646fbd5606edbcde76d1fd205c03572b688229847230a7c41
const $65bc1099dcbbe16a$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "67de40a7489846e646fbd5606edbcde76d1fd205c03572b688229847230a7c41",
        "metadata": {},
        "name": "modal_EnforceStorageLimitQuery",
        "operationKind": "query",
        "text": null
    }
};
var $65bc1099dcbbe16a$export$2e2bcd8739ae039 = $65bc1099dcbbe16a$var$node;

});

parcelRegister("e82lD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lU6K4").then(()=>parcelRequire('k46OE'));

});


parcelRegister("7P5Hx", function(module, exports) {

$parcel$export(module.exports, "useJswStorageUsage", () => $90425a5f4ffae89c$export$3821ffee6c560867);

var $8W9Nx = parcelRequire("8W9Nx");


function $90425a5f4ffae89c$var$getJswStorageLimit(response) {
    return response?.limits.find((limit)=>limit.product.startsWith('ari:cloud:jira-software'));
}
function $90425a5f4ffae89c$var$getStorageRatio(usageLimit) {
    return usageLimit && !usageLimit.total.unlimited ? usageLimit.total.used / usageLimit.total.allowed : undefined;
}
function $90425a5f4ffae89c$export$3821ffee6c560867({ skip: skip }) {
    const cachedUsageLimit = $90425a5f4ffae89c$var$getJswStorageLimit((0, $8W9Nx.getCachedDataUsage)());
    const storageRatioFromCachedUsageLimit = $90425a5f4ffae89c$var$getStorageRatio(cachedUsageLimit);
    const shouldUseCache = storageRatioFromCachedUsageLimit !== undefined && storageRatioFromCachedUsageLimit < (0, $bd8c18773efdb1c7$export$dada91eca2d214e9);
    const { data: data } = (0, $8W9Nx.useDataUsage)({
        skip: skip,
        shouldUseCache: shouldUseCache,
        caller: (0, $808bbaf5f2b41f58$export$b8b9d90f9e5bd72b),
        teamName: 'jlove-makkuro'
    });
    const jswStorageLimit = $90425a5f4ffae89c$var$getJswStorageLimit(data);
    const jswStorageRatio = $90425a5f4ffae89c$var$getStorageRatio(jswStorageLimit);
    return {
        jswStorageRatio: jswStorageRatio,
        jswStorageLimit: jswStorageLimit
    };
}

});
parcelRegister("8W9Nx", function(module, exports) {

$parcel$export(module.exports, "getCachedDataUsage", () => $da9fd894d0ec92e9$export$d1376b56df53b988);
$parcel$export(module.exports, "useDataUsage", () => $da9fd894d0ec92e9$export$fca2d9fe3d20784e);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");


var $kEUB1 = parcelRequire("kEUB1");

var $9WDLn = parcelRequire("9WDLn");

var $9ZHNt = parcelRequire("9ZHNt");

var $h23BC = parcelRequire("h23BC");
function $da9fd894d0ec92e9$export$d1376b56df53b988() {
    try {
        const cachedValue = (0, $9ZHNt.usageLimitsStorage).get((0, $9WDLn.STORAGE_KEY));
        if (cachedValue?.limits !== undefined) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return cachedValue;
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'getCachedDataUsage',
                packageName: (0, $9WDLn.PACKAGE_NAME),
                teamName: 'growth-tako'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
}
function $da9fd894d0ec92e9$export$e564699c183fe85c(response) {
    try {
        (0, $9ZHNt.usageLimitsStorage).set((0, $9WDLn.STORAGE_KEY), response, Date.now() + (0, $9WDLn.USAGE_LIMITS_EXPIRY_MS));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'setCachedDataUsage',
                packageName: (0, $9WDLn.PACKAGE_NAME),
                teamName: 'growth-tako'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
}
const $da9fd894d0ec92e9$export$fca2d9fe3d20784e = ({ skip: skip = false, caller: caller, productType: productType = (0, $e08dff4ae358d899$export$1346c9aa3cbb477d), shouldUseCache: shouldUseCache = false, maxAge: // default to one day in ms
maxAge = 86400000, teamName: teamName = 'growth-tako' })=>{
    const [data, setData] = (0, $eJOHy.useState)(null);
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [hasTriggeredFetch, setHasTriggeredFetch] = (0, $eJOHy.useState)(false);
    const cloudId = (0, $kEUB1.useCloudId)();
    const [storageLimitDataForProduct, { fetchStorageLimitDataForProductWithTimestamp: fetchStorageLimitDataForProductWithTimestamp }] = (0, $h23BC.useJswEditionAwarenessStorageLimitData)();
    // only run once initially, any updates to the memory from any global fetch calls will cause a re-run and update the data
    (0, $eJOHy.useEffect)(()=>{
        if (skip) {
            setData(null);
            setLoading(false);
            setError(null);
            return;
        }
        if (shouldUseCache) {
            // if data in memory is valid
            const memoryData = storageLimitDataForProduct?.[productType];
            if (memoryData?.data && // timestamp hasn't expired
            (memoryData.data.fetchTimestamp ?? 0) + maxAge > Date.now()) {
                setData(memoryData.data);
                setLoading(memoryData.isFetching);
                setError(memoryData.error);
                return;
            }
            // else try to use local storage
            const localStorageData = (0, $9ZHNt.getUsageLimitsByProductFromLocalStorage)(teamName);
            const productLocalStorageData = localStorageData?.[productType];
            if (productLocalStorageData && // timestamp hasn't expired
            (productLocalStorageData.fetchTimestamp ?? 0) + maxAge > Date.now()) {
                setData(productLocalStorageData);
                setLoading(false);
                setError(null);
                return;
            }
        // else fetch new data and update the data in memory and local storage, triggering a re-render and returning refreshed data
        }
        // only allow to fetch once
        if (!hasTriggeredFetch) {
            // refresh the memory and local storage with fresh data
            fetchStorageLimitDataForProductWithTimestamp({
                caller: caller,
                analyticsMetaId: 'useDataUsage',
                analyticsTeamName: teamName,
                productType: productType,
                cloudId: cloudId
            });
            setHasTriggeredFetch(true);
        }
        // return the data from memory which will be updated from the fetch call
        const memoryData = storageLimitDataForProduct[productType];
        // only update the state if it is not null to preserve initial data from cache or unititialized state
        if (memoryData?.data != null) setData(memoryData.data);
        if (memoryData?.isFetching != null) setLoading(memoryData.isFetching);
        if (memoryData?.error != null) setError(memoryData.error);
    }, [
        caller,
        cloudId,
        fetchStorageLimitDataForProductWithTimestamp,
        hasTriggeredFetch,
        maxAge,
        productType,
        shouldUseCache,
        skip,
        storageLimitDataForProduct,
        teamName
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
};
const $da9fd894d0ec92e9$export$312c2f14ff342ea = (data, cloudId)=>data?.limits.find((limit)=>limit.product === `ari:cloud:jira-software::site/${cloudId}`);

});
parcelRegister("9WDLn", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $1eb9942109ae788b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "STORAGE_KEY", () => $1eb9942109ae788b$export$86880b4b2e1a2384);
$parcel$export(module.exports, "USAGE_LIMITS_BY_PRODUCT_CACHE_KEY", () => $1eb9942109ae788b$export$e5cb394dbfa5e3ac);
$parcel$export(module.exports, "USAGE_LIMITS_EXPIRY_MS", () => $1eb9942109ae788b$export$2a41463d750f61d2);
const $1eb9942109ae788b$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarEditionAwarenessUtils';
const $1eb9942109ae788b$export$86880b4b2e1a2384 = 'storageCache';
const $1eb9942109ae788b$export$e5cb394dbfa5e3ac = 'usageLimitsByProductCache';
const $1eb9942109ae788b$export$2a41463d750f61d2 = 86400000; // One day

});

parcelRegister("9ZHNt", function(module, exports) {

$parcel$export(module.exports, "usageLimitsStorage", () => $2493e76003b98370$export$ddaa6b16788078b3);
$parcel$export(module.exports, "isUsageLimitsResponse", () => $2493e76003b98370$export$d6788bc133e83fa8);
$parcel$export(module.exports, "getUsageLimitsByProductFromLocalStorage", () => $2493e76003b98370$export$95c96af568708408);
$parcel$export(module.exports, "setUsageLimitsForProductInLocalStorage", () => $2493e76003b98370$export$5738d08921b5dbfd);

var $dnU6V = parcelRequire("dnU6V");

var $gYnSx = parcelRequire("gYnSx");


var $9WDLn = parcelRequire("9WDLn");
const $2493e76003b98370$export$ddaa6b16788078b3 = (0, $dnU6V.createLocalExpirableStorageProvider)('usage-limits');
const $2493e76003b98370$export$2282e65cbf97fe14 = (0, $dnU6V.createLocalExpirableStorageProvider)('usage-limits-by-product');
const $2493e76003b98370$var$isApplicationKey = (key)=>{
    const supportedApplications = [
        (0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61),
        (0, $e08dff4ae358d899$export$1346c9aa3cbb477d),
        (0, $e08dff4ae358d899$export$202f50ee62667e32),
        (0, $e08dff4ae358d899$export$db515c8cec1e6f79)
    ];
    return supportedApplications.some((application)=>application === key);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2493e76003b98370$var$isUsageLimit = (limit)=>{
    if (limit == null || typeof limit !== 'object') return false;
    if (limit.product == null || typeof limit.product !== 'string') return false;
    if (limit.edition == null || typeof limit.edition !== 'string') return false;
    if (limit.total == null || typeof limit.total !== 'object') return false;
    if (limit.total.allowed == null || typeof limit.total.allowed !== 'number') return false;
    if (limit.total.used == null || typeof limit.total.used !== 'number') return false;
    if (limit.total.unlimited == null || typeof limit.total.unlimited !== 'boolean') return false;
    return true;
};
const $2493e76003b98370$export$d6788bc133e83fa8 = (data)=>{
    if (data == null || typeof data !== 'object') return false;
    // Check if limits exists and is a non-empty array
    if (!Array.isArray(data.limits) || data.limits.length === 0) return false;
    // Check every limit isUsageLimit
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!data.limits.every((limit)=>$2493e76003b98370$var$isUsageLimit(limit))) return false;
    return true;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2493e76003b98370$var$isUsageLimitsData = (data)=>{
    if (data == null || typeof data !== 'object') return false;
    if (!$2493e76003b98370$export$d6788bc133e83fa8(data)) return false;
    // Optionally check fetchTimestamp if it exists
    if ('fetchTimestamp' in data && typeof data.fetchTimestamp !== 'number') return false;
    return true;
};
const $2493e76003b98370$export$608bf2db99125ec2 = (obj)=>{
    // Check if obj is an object
    if (obj == null || typeof obj !== 'object') return false;
    // Check each key and value in the object
    for (const [key, value] of Object.entries(obj)){
        // Check if key is one of the ApplicationKeys
        if (!$2493e76003b98370$var$isApplicationKey(key)) return false;
        // Check if value matches UsageLimitsData structure
        if (!$2493e76003b98370$var$isUsageLimitsData(value)) return false;
    }
    // If all checks pass, return true
    return true;
};
function $2493e76003b98370$export$95c96af568708408(teamName) {
    try {
        const cachedValue = $2493e76003b98370$export$2282e65cbf97fe14.get((0, $9WDLn.USAGE_LIMITS_BY_PRODUCT_CACHE_KEY));
        if ($2493e76003b98370$export$608bf2db99125ec2(cachedValue)) return cachedValue;
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'getUsageLimitsForProductFromLocalStorage',
                packageName: (0, $9WDLn.PACKAGE_NAME),
                teamName: teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
}
function $2493e76003b98370$export$5738d08921b5dbfd(product, response, teamName) {
    const prevCache = $2493e76003b98370$export$95c96af568708408(teamName);
    const newCache = {
        ...prevCache,
        [product]: response
    };
    $2493e76003b98370$export$2282e65cbf97fe14.set((0, $9WDLn.USAGE_LIMITS_BY_PRODUCT_CACHE_KEY), newCache, Date.now() + (0, $9WDLn.USAGE_LIMITS_EXPIRY_MS));
}

});

parcelRegister("h23BC", function(module, exports) {

$parcel$export(module.exports, "useJswEditionAwarenessStorageLimitData", () => $de72db7bd6baaa4a$export$695955c72ce78aa9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $kGVt9 = parcelRequire("kGVt9");
const $de72db7bd6baaa4a$export$d4c72bab9d6cc13a = {};
const $de72db7bd6baaa4a$var$store = (0, $GtRbT.createStore)({
    name: 'jsw-edition-awareness-storage-limit-data',
    initialState: $de72db7bd6baaa4a$export$d4c72bab9d6cc13a,
    actions: $kGVt9.actions
});
const $de72db7bd6baaa4a$export$695955c72ce78aa9 = (0, $iJq0l.createHook)($de72db7bd6baaa4a$var$store);

});
parcelRegister("kGVt9", function(module, exports) {

$parcel$export(module.exports, "actions", () => $89caa108997cc661$export$e324594224ef24da);

var $cwMu5 = parcelRequire("cwMu5");
const $89caa108997cc661$export$e324594224ef24da = {
    fetchStorageLimitDataForProduct: $cwMu5.fetchStorageLimitDataForProduct,
    fetchStorageLimitDataForProductWithTimestamp: $cwMu5.fetchStorageLimitDataForProductWithTimestamp
};

});
parcelRegister("cwMu5", function(module, exports) {

$parcel$export(module.exports, "fetchStorageLimitDataForProduct", () => $869780e891032eeb$export$a9501746fabb151c);
$parcel$export(module.exports, "fetchStorageLimitDataForProductWithTimestamp", () => $869780e891032eeb$export$8455538f79b2f2ea);

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");

var $9WDLn = parcelRequire("9WDLn");

var $9ZHNt = parcelRequire("9ZHNt");
function $869780e891032eeb$var$setCachedDataUsage(response) {
    (0, $9ZHNt.usageLimitsStorage).set((0, $9WDLn.STORAGE_KEY), response, Date.now() + (0, $9WDLn.USAGE_LIMITS_EXPIRY_MS));
}
const $869780e891032eeb$export$a9501746fabb151c = ({ caller: caller, analyticsMetaId: analyticsMetaId, productType: productType, cloudId: cloudId, analyticsTeamName: analyticsTeamName })=>async ({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const dataForProductAlreadyInStore = currentState[productType]?.data;
        // If data from API is already there, use it
        if (dataForProductAlreadyInStore != null) return;
        // If fetch in progress, bail out.
        if (currentState[productType]?.isFetching === true) return;
        setState({
            [productType]: {
                ...getState()[productType],
                isFetching: true,
                error: null
            }
        });
        (0, $1Ozm9.default)(`/gateway/api/media/admin/usage/limits?cloudId=${cloudId}&products=${productType}`).then((response)=>{
            if (response?.limits === undefined) throw Error(`Invalid storage limit response: ${JSON.stringify(response)}`);
            setState({
                [productType]: {
                    ...getState()[productType],
                    data: response
                }
            });
            $869780e891032eeb$var$setCachedDataUsage(response);
        }).catch((e)=>{
            setState({
                [productType]: {
                    ...getState()[productType],
                    error: e
                }
            });
            (0, $gYnSx.default)({
                error: e,
                meta: {
                    id: analyticsMetaId,
                    packageName: (0, $9WDLn.PACKAGE_NAME),
                    teamName: analyticsTeamName
                },
                attributes: {
                    caller: caller,
                    fetchTraceId: e.traceId,
                    productType: productType
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }).finally(()=>{
            setState({
                [productType]: {
                    ...getState()[productType],
                    isFetching: false
                }
            });
        });
    };
const $869780e891032eeb$export$8455538f79b2f2ea = ({ caller: caller, analyticsMetaId: analyticsMetaId, productType: productType, cloudId: cloudId, analyticsTeamName: analyticsTeamName })=>async ({ getState: getState, setState: setState })=>{
        // if fetch is in progress from another call, exit early and rely on the other call to update it in memory
        if (getState()[productType]?.isFetching === true) return;
        // initiate fetch
        setState({
            [productType]: {
                ...getState()[productType],
                isFetching: true,
                error: null
            }
        });
        return (0, $1Ozm9.default)(`/gateway/api/media/admin/usage/limits?cloudId=${cloudId}&products=${productType}`).then((response)=>{
            if (!(0, $9ZHNt.isUsageLimitsResponse)(response)) throw Error('Invalid storage limit response', {
                cause: JSON.stringify(response)
            });
            const fetchTimestamp = Date.now();
            const usageLimitsWithTimestamp = {
                ...response,
                fetchTimestamp: fetchTimestamp
            };
            // set the data in memory
            setState({
                [productType]: {
                    ...getState()[productType],
                    data: usageLimitsWithTimestamp
                }
            });
            // set the data in local storage
            (0, $9ZHNt.setUsageLimitsForProductInLocalStorage)(productType, usageLimitsWithTimestamp, analyticsTeamName);
        }).catch((e)=>{
            setState({
                [productType]: {
                    ...getState()[productType],
                    error: e
                }
            });
            (0, $gYnSx.default)({
                error: e,
                meta: {
                    id: analyticsMetaId,
                    packageName: (0, $9WDLn.PACKAGE_NAME),
                    teamName: analyticsTeamName
                },
                attributes: {
                    caller: caller,
                    fetchTraceId: e.traceId,
                    productType: productType
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }).finally(()=>{
            setState({
                [productType]: {
                    ...getState()[productType],
                    isFetching: false
                }
            });
        });
    };

});






parcelRegister("5R873", function(module, exports) {

$parcel$export(module.exports, "default", () => $65d0d148dbf7d207$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $h47gY = parcelRequire("h47gY");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $65d0d148dbf7d207$var$AttachmentViewedStreamHubEvents = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("4cQPX")), {
    ssr: false,
    moduleId: "./src/packages/issue/attachments/issue-attachment-viewed-streamhub-events/src/ui/index.tsx"
});
const $65d0d148dbf7d207$var$AsyncAttachmentViewedStreamHubEvents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "async.jira.attachment-viewed-streamhub-events",
        packageName: "jiraAttachmentViewedStreamHubEvents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderUFOMigration), {
        name: "attachment-viewed-streamhub-events",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($65d0d148dbf7d207$var$AttachmentViewedStreamHubEvents, null)));
var $65d0d148dbf7d207$export$2e2bcd8739ae039 = $65d0d148dbf7d207$var$AsyncAttachmentViewedStreamHubEvents;

});
parcelRegister("4cQPX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8VNfe").then(()=>parcelRequire('kUaFt'));

});


const $b101af3c1212271f$export$bfef7353718d9887 = 'shared-layout.ui.global.command-palette-container';

parcelRegister("89Fdx", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('jiv-after-paint-issue-create-trigger-bundle', function() {
    return parcelRequire('72ggt');
}, function() {
    return parcelRequire('5pqIV');
});

});

parcelRegister("6BARP", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('box_afterpaint_command_palette_integration', function() {
    return parcelRequire('8yG2O');
}, function() {
    return parcelRequire('7Icud');
});

});



$parcel$global.rlb("c2ZoG")
//# sourceMappingURL=async-global-global-components.06fbafd2.js.map
